/* eslint-disable */
/*
@license

dhtmlxCalendar v.7.1.8 Professional

This software is covered by DHTMLX Enterprise License.
Usage without proper license is prohibited.

(c) XB Software.

*/
if (window.dhx) { window.dhx_legacy = dhx; delete window.dhx; } (function webpackUniversalModuleDefinition(root, factory) {
    if (typeof exports === 'object' && typeof module === 'object')
        module.exports = factory();
    else if (typeof define === 'function' && define.amd)
        define([], factory);
    else if (typeof exports === 'object')
        exports["dhx"] = factory();
    else
        root["dhx"] = factory();
})(window, function () {
    return /******/ (function (modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if (installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
                /******/
            }
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
                /******/
            };
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
            /******/
        }
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function (exports, name, getter) {
/******/ 		if (!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
                /******/
            }
            /******/
        };
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function (exports) {
/******/ 		if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
                /******/
            }
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
            /******/
        };
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function (value, mode) {
/******/ 		if (mode & 1) value = __webpack_require__(value);
/******/ 		if (mode & 8) return value;
/******/ 		if ((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if (mode & 2 && typeof value != 'string') for (var key in value) __webpack_require__.d(ns, key, function (key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
            /******/
        };
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function (module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
            /******/
        };
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function (object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/codebase/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 16);
        /******/
    })
/************************************************************************/
/******/([
/* 0 */
/***/ (function (module, exports, __webpack_require__) {

            "use strict";

            var __assign = (this && this.__assign) || function () {
                __assign = Object.assign || function (t) {
                    for (var s, i = 1, n = arguments.length; i < n; i++) {
                        s = arguments[i];
                        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                            t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", { value: true });
            function toNode(node) {
                return typeof node === "string"
                    ? document.getElementById(node) || document.querySelector(node) || document.body
                    : node || document.body;
            }
            exports.toNode = toNode;
            function eventHandler(prepare, hash, afterCall) {
                var keys = Object.keys(hash);
                return function (ev) {
                    var data = prepare(ev);
                    if (data !== undefined) {
                        var node = ev.target;
                        outer_block: while (node) {
                            var cssstring = node.getAttribute ? node.getAttribute("class") || "" : "";
                            if (cssstring.length) {
                                var css = cssstring.split(" ");
                                for (var j = 0; j < keys.length; j++) {
                                    if (css.includes(keys[j])) {
                                        if (hash[keys[j]](ev, data) === false)
                                            return false;
                                        else
                                            break outer_block;
                                    }
                                }
                            }
                            node = node.parentNode;
                        }
                    }
                    if (afterCall)
                        afterCall(ev);
                    return true;
                };
            }
            exports.eventHandler = eventHandler;
            function locateNode(target, attr, dir) {
                if (attr === void 0) { attr = "dhx_id"; }
                if (dir === void 0) { dir = "target"; }
                if (target instanceof Event) {
                    target = target[dir];
                }
                while (target) {
                    if (target.getAttribute && target.getAttribute(attr)) {
                        return target;
                    }
                    target = target.parentNode;
                }
            }
            exports.locateNode = locateNode;
            function locate(target, attr) {
                if (attr === void 0) { attr = "dhx_id"; }
                var node = locateNode(target, attr);
                return node ? node.getAttribute(attr) : "";
            }
            exports.locate = locate;
            function locateNodeByClassName(target, className) {
                if (target instanceof Event) {
                    target = target.target;
                }
                while (target) {
                    if (className) {
                        if (target.classList && target.classList.contains(className)) {
                            return target;
                        }
                    }
                    else if (target.getAttribute && target.getAttribute("dhx_id")) {
                        return target;
                    }
                    target = target.parentNode;
                }
            }
            exports.locateNodeByClassName = locateNodeByClassName;
            function getBox(elem) {
                var box = elem.getBoundingClientRect();
                var body = document.body;
                var scrollTop = window.pageYOffset || body.scrollTop;
                var scrollLeft = window.pageXOffset || body.scrollLeft;
                var top = box.top + scrollTop;
                var left = box.left + scrollLeft;
                var right = body.offsetWidth - box.right;
                var bottom = body.offsetHeight - box.bottom;
                var width = box.right - box.left;
                var height = box.bottom - box.top;
                return { top: top, left: left, right: right, bottom: bottom, width: width, height: height };
            }
            exports.getBox = getBox;
            var scrollWidth = -1;
            function getScrollbarWidth() {
                if (scrollWidth > -1) {
                    return scrollWidth;
                }
                var scrollDiv = document.createElement("div");
                document.body.appendChild(scrollDiv);
                scrollDiv.style.cssText = "position: absolute;left: -99999px;overflow:scroll;width: 100px;height: 100px;";
                scrollWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
                document.body.removeChild(scrollDiv);
                return scrollWidth;
            }
            exports.getScrollbarWidth = getScrollbarWidth;
            function isIE() {
                var ua = window.navigator.userAgent;
                return ua.includes("MSIE ") || ua.includes("Trident/");
            }
            exports.isIE = isIE;
            function isSafari() {
                var check = function (str) { return str.test(window.navigator.userAgent); };
                var chrome = check(/Chrome/);
                var firefox = check(/Firefox/);
                return !chrome && !firefox && check(/Safari/);
            }
            exports.isSafari = isSafari;
            function getRealPosition(node) {
                var rects = node.getBoundingClientRect();
                return {
                    left: rects.left + window.pageXOffset,
                    right: rects.right + window.pageXOffset,
                    top: rects.top + window.pageYOffset,
                    bottom: rects.bottom + window.pageYOffset,
                };
            }
            exports.getRealPosition = getRealPosition;
            function getWindowBorders() {
                return {
                    rightBorder: window.pageXOffset + window.innerWidth,
                    bottomBorder: window.pageYOffset + window.innerHeight,
                };
            }
            function horizontalCentering(pos, width, rightBorder) {
                var nodeWidth = pos.right - pos.left;
                var diff = (width - nodeWidth) / 2;
                var left = pos.left - diff;
                var right = pos.right + diff;
                if (left >= 0 && right <= rightBorder) {
                    return left;
                }
                if (left < 0) {
                    return 0;
                }
                return rightBorder - width;
            }
            function verticalCentering(pos, height, bottomBorder) {
                var nodeHeight = pos.bottom - pos.top;
                var diff = (height - nodeHeight) / 2;
                var top = pos.top - diff;
                var bottom = pos.bottom + diff;
                if (top >= 0 && bottom <= bottomBorder) {
                    return top;
                }
                if (top < 0) {
                    return 0;
                }
                return bottomBorder - height;
            }
            function placeBottomOrTop(pos, config) {
                var _a = getWindowBorders(), rightBorder = _a.rightBorder, bottomBorder = _a.bottomBorder;
                var left;
                var top;
                var bottomDiff = bottomBorder - pos.bottom - config.height;
                var topDiff = pos.top - config.height;
                if (config.mode === "bottom") {
                    if (bottomDiff >= 0) {
                        top = pos.bottom;
                    }
                    else if (topDiff >= 0) {
                        top = topDiff;
                    }
                }
                else {
                    if (topDiff >= 0) {
                        top = topDiff;
                    }
                    else if (bottomDiff >= 0) {
                        top = pos.bottom;
                    }
                }
                if (bottomDiff < 0 && topDiff < 0) {
                    if (config.auto) {
                        // eslint-disable-next-line @typescript-eslint/no-use-before-define
                        return placeRightOrLeft(pos, __assign(__assign({}, config), { mode: "right", auto: false }));
                    }
                    top = bottomDiff > topDiff ? pos.bottom : topDiff;
                }
                if (config.centering) {
                    left = horizontalCentering(pos, config.width, rightBorder);
                }
                else {
                    var leftDiff = rightBorder - pos.left - config.width;
                    var rightDiff = pos.right - config.width;
                    if (leftDiff >= 0) {
                        left = pos.left;
                    }
                    else if (rightDiff >= 0) {
                        left = rightDiff;
                    }
                    else {
                        left = rightDiff > leftDiff ? pos.left : rightDiff;
                    }
                }
                return { left: left, top: top };
            }
            function placeRightOrLeft(pos, config) {
                var _a = getWindowBorders(), rightBorder = _a.rightBorder, bottomBorder = _a.bottomBorder;
                var left;
                var top;
                var rightDiff = rightBorder - pos.right - config.width;
                var leftDiff = pos.left - config.width;
                if (config.mode === "right") {
                    if (rightDiff >= 0) {
                        left = pos.right;
                    }
                    else if (leftDiff >= 0) {
                        left = leftDiff;
                    }
                }
                else {
                    if (leftDiff >= 0) {
                        left = leftDiff;
                    }
                    else if (rightDiff >= 0) {
                        left = pos.right;
                    }
                }
                if (leftDiff < 0 && rightDiff < 0) {
                    if (config.auto) {
                        return placeBottomOrTop(pos, __assign(__assign({}, config), { mode: "bottom", auto: false }));
                    }
                    left = leftDiff > rightDiff ? leftDiff : pos.right;
                }
                if (config.centering) {
                    top = verticalCentering(pos, config.height, rightBorder);
                }
                else {
                    var bottomDiff = pos.bottom - config.height;
                    var topDiff = bottomBorder - pos.top - config.height;
                    if (topDiff >= 0) {
                        top = pos.top;
                    }
                    else if (bottomDiff > 0) {
                        top = bottomDiff;
                    }
                    else {
                        top = bottomDiff > topDiff ? bottomDiff : pos.top;
                    }
                }
                return { left: left, top: top };
            }
            function calculatePosition(pos, config) {
                var _a = config.mode === "bottom" || config.mode === "top"
                    ? placeBottomOrTop(pos, config)
                    : placeRightOrLeft(pos, config), left = _a.left, top = _a.top;
                return {
                    left: Math.round(left) + "px",
                    top: Math.round(top) + "px",
                    minWidth: Math.round(config.width) + "px",
                    position: "absolute",
                };
            }
            exports.calculatePosition = calculatePosition;
            function fitPosition(node, config) {
                return calculatePosition(getRealPosition(node), config);
            }
            exports.fitPosition = fitPosition;
            function getPageCss() {
                var css = [];
                for (var sheeti = 0; sheeti < document.styleSheets.length; sheeti++) {
                    var sheet = document.styleSheets[sheeti];
                    var rules = "cssRules" in sheet ? sheet.cssRules : sheet.rules;
                    for (var rulei = 0; rulei < rules.length; rulei++) {
                        var rule = rules[rulei];
                        if ("cssText" in rule) {
                            css.push(rule.cssText);
                        }
                        else {
                            css.push(rule.selectorText + " {\n" + rule.style.cssText + "\n}\n");
                        }
                    }
                }
                return css.join("\n");
            }
            exports.getPageCss = getPageCss;
            function getLabelStyle(config) {
                var helpMessage = config.helpMessage, type = config.type, labelWidth = config.labelWidth, label = config.label;
                var isZero = labelWidth && labelWidth.toString().startsWith("0");
                var required = type !== "text" && config.required;
                if (!helpMessage && !required && (!label || (label && isZero)) && (!labelWidth || isZero)) {
                    return false;
                }
                return {
                    style: (label || labelWidth) && !isZero && { width: labelWidth, "max-width": "100%" },
                    label: label && isZero ? null : label,
                };
            }
            exports.getLabelStyle = getLabelStyle;


            /***/
        }),
/* 1 */
/***/ (function (module, exports, __webpack_require__) {

            "use strict";

            var __assign = (this && this.__assign) || function () {
                __assign = Object.assign || function (t) {
                    for (var s, i = 1, n = arguments.length; i < n; i++) {
                        s = arguments[i];
                        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                            t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", { value: true });
            var html_1 = __webpack_require__(0);
            var counter = new Date().valueOf();
            function uid() {
                return "u" + counter++;
            }
            exports.uid = uid;
            function extend(target, source, deep) {
                if (deep === void 0) { deep = true; }
                if (source) {
                    for (var key in source) {
                        var sobj = source[key];
                        var tobj = target[key];
                        if (sobj === undefined) {
                            delete target[key];
                        }
                        else if (deep &&
                            typeof tobj === "object" &&
                            !(tobj instanceof Date) &&
                            !(tobj instanceof Array)) {
                            extend(tobj, sobj);
                        }
                        else {
                            target[key] = sobj;
                        }
                    }
                }
                return target;
            }
            exports.extend = extend;
            function copy(source, withoutInner) {
                var result = {};
                for (var key in source) {
                    if (!withoutInner || !key.startsWith("$")) {
                        result[key] = source[key];
                    }
                }
                return result;
            }
            exports.copy = copy;
            function naturalSort(arr) {
                return arr.sort(function (a, b) {
                    var nn = typeof a === "string" ? a.localeCompare(b) : a - b;
                    return nn;
                });
            }
            exports.naturalSort = naturalSort;
            function findIndex(arr, predicate) {
                var len = arr.length;
                for (var i = 0; i < len; i++) {
                    if (predicate(arr[i])) {
                        return i;
                    }
                }
                return -1;
            }
            exports.findIndex = findIndex;
            function isEqualString(from, to) {
                from = from.toString();
                to = to.toString();
                if (from.length > to.length) {
                    return false;
                }
                for (var i = 0; i < from.length; i++) {
                    if (from[i].toLowerCase() !== to[i].toLowerCase()) {
                        return false;
                    }
                }
                return true;
            }
            exports.isEqualString = isEqualString;
            function singleOuterClick(fn) {
                var click = function (e) {
                    if (fn(e)) {
                        document.removeEventListener("click", click);
                    }
                };
                document.addEventListener("click", click);
            }
            exports.singleOuterClick = singleOuterClick;
            function detectWidgetClick(widgetId, cb) {
                var click = function (e) { return cb(html_1.locate(e, "dhx_widget_id") === widgetId); };
                document.addEventListener("click", click);
                return function () { return document.removeEventListener("click", click); };
            }
            exports.detectWidgetClick = detectWidgetClick;
            function unwrapBox(box) {
                if (Array.isArray(box)) {
                    return box[0];
                }
                return box;
            }
            exports.unwrapBox = unwrapBox;
            function wrapBox(unboxed) {
                if (Array.isArray(unboxed)) {
                    return unboxed;
                }
                return [unboxed];
            }
            exports.wrapBox = wrapBox;
            function isDefined(some) {
                return some !== null && some !== undefined;
            }
            exports.isDefined = isDefined;
            function range(from, to) {
                if (from > to) {
                    return [];
                }
                var result = [];
                while (from <= to) {
                    result.push(from++);
                }
                return result;
            }
            exports.range = range;
            function isNumeric(val) {
                return !isNaN(val - parseFloat(val));
            }
            exports.isNumeric = isNumeric;
            function downloadFile(data, filename, mimeType) {
                if (mimeType === void 0) { mimeType = "text/plain"; }
                var file = new Blob([data], { type: mimeType });
                if (window.navigator.msSaveOrOpenBlob) {
                    // IE10+
                    window.navigator.msSaveOrOpenBlob(file, filename);
                }
                else {
                    var a_1 = document.createElement("a");
                    var url_1 = URL.createObjectURL(file);
                    a_1.href = url_1;
                    a_1.download = filename;
                    document.body.appendChild(a_1);
                    a_1.click();
                    setTimeout(function () {
                        document.body.removeChild(a_1);
                        window.URL.revokeObjectURL(url_1);
                    }, 0);
                }
            }
            exports.downloadFile = downloadFile;
            function debounce(func, wait, immediate) {
                var timeout;
                return function executedFunction() {
                    var _this = this;
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    var later = function () {
                        timeout = null;
                        if (!immediate) {
                            func.apply(_this, args);
                        }
                    };
                    var callNow = immediate && !timeout;
                    clearTimeout(timeout);
                    timeout = setTimeout(later, wait);
                    if (callNow) {
                        func.apply(this, args);
                    }
                };
            }
            exports.debounce = debounce;
            function compare(obj1, obj2) {
                for (var p in obj1) {
                    if (obj1.hasOwnProperty(p) !== obj2.hasOwnProperty(p)) {
                        return false;
                    }
                    switch (typeof obj1[p]) {
                        case "object":
                            if (!compare(obj1[p], obj2[p])) {
                                return false;
                            }
                            break;
                        case "function":
                            if (typeof obj2[p] === "undefined" ||
                                (p !== "compare" && obj1[p].toString() !== obj2[p].toString())) {
                                return false;
                            }
                            break;
                        default:
                            if (obj1[p] !== obj2[p]) {
                                return false;
                            }
                    }
                }
                for (var p in obj2) {
                    if (typeof obj1[p] === "undefined") {
                        return false;
                    }
                }
                return true;
            }
            exports.compare = compare;
            exports.isType = function (value) {
                var regex = /^\[object (\S+?)\]$/;
                var matches = Object.prototype.toString.call(value).match(regex) || [];
                return (matches[1] || "undefined").toLowerCase();
            };
            exports.isEmptyObj = function (obj) {
                for (var key in obj) {
                    return false;
                }
                return true;
            };
            exports.getMaxArrayNymber = function (array) {
                if (!array.length)
                    return;
                var maxNumber = -Infinity;
                var index = 0;
                var length = array.length;
                for (index; index < length; index++) {
                    if (array[index] > maxNumber)
                        maxNumber = array[index];
                }
                return maxNumber;
            };
            exports.getMinArrayNymber = function (array) {
                if (!array.length)
                    return;
                var minNumber = +Infinity;
                var index = 0;
                var length = array.length;
                for (index; index < length; index++) {
                    if (array[index] < minNumber)
                        minNumber = array[index];
                }
                return minNumber;
            };
            exports.getStringWidth = function (value, config) {
                config = __assign({ font: "normal 14px Roboto", lineHeight: 20 }, config);
                var canvas = document.createElement("canvas");
                var ctx = canvas.getContext("2d");
                if (config.font)
                    ctx.font = config.font;
                var width = ctx.measureText(value).width;
                canvas.remove();
                return width;
            };


            /***/
        }),
/* 2 */
/***/ (function (module, exports, __webpack_require__) {

            "use strict";
/* WEBPACK VAR INJECTION */(function (Promise) {
                Object.defineProperty(exports, "__esModule", { value: true });
                var dom = __webpack_require__(33);
                exports.el = dom.defineElement;
                exports.sv = dom.defineSvgElement;
                exports.view = dom.defineView;
                exports.create = dom.createView;
                exports.inject = dom.injectView;
                exports.KEYED_LIST = dom.KEYED_LIST;
                function disableHelp() {
                    dom.DEVMODE.mutations = false;
                    dom.DEVMODE.warnings = false;
                    dom.DEVMODE.verbose = false;
                    dom.DEVMODE.UNKEYED_INPUT = false;
                }
                exports.disableHelp = disableHelp;
                function resizer(handler) {
                    var resize = window.ResizeObserver;
                    var activeHandler = function (node) {
                        var height = node.el.offsetHeight;
                        var width = node.el.offsetWidth;
                        handler(width, height);
                    };
                    if (resize) {
                        return exports.el("div.dhx-resize-observer", {
                            _hooks: {
                                didInsert: function (node) {
                                    new resize(function () { return activeHandler(node); }).observe(node.el);
                                },
                            },
                        });
                    }
                    return exports.el("iframe.dhx-resize-observer", {
                        _hooks: {
                            didInsert: function (node) {
                                node.el.contentWindow.onresize = function () { return activeHandler(node); };
                                activeHandler(node);
                            },
                        },
                    });
                }
                exports.resizer = resizer;
                function resizeHandler(container, handler) {
                    return exports.create({
                        render: function () {
                            return resizer(handler);
                        },
                    }).mount(container);
                }
                exports.resizeHandler = resizeHandler;
                function awaitRedraw() {
                    return new Promise(function (res) {
                        requestAnimationFrame(function () {
                            res();
                        });
                    });
                }
                exports.awaitRedraw = awaitRedraw;

                /* WEBPACK VAR INJECTION */
            }.call(this, __webpack_require__(7)))

            /***/
        }),
/* 3 */
/***/ (function (module, exports, __webpack_require__) {

            "use strict";

            Object.defineProperty(exports, "__esModule", { value: true });
            var EventSystem = /** @class */ (function () {
                function EventSystem(context) {
                    this.events = {};
                    this.context = context || this;
                }
                EventSystem.prototype.on = function (name, callback, context) {
                    var event = name.toLowerCase();
                    this.events[event] = this.events[event] || [];
                    this.events[event].push({ callback: callback, context: context || this.context });
                };
                EventSystem.prototype.detach = function (name, context) {
                    var event = name.toLowerCase();
                    var eStack = this.events[event];
                    if (context && eStack && eStack.length) {
                        for (var i = eStack.length - 1; i >= 0; i--) {
                            if (eStack[i].context === context) {
                                eStack.splice(i, 1);
                            }
                        }
                    }
                    else {
                        this.events[event] = [];
                    }
                };
                EventSystem.prototype.fire = function (name, args) {
                    if (typeof args === "undefined") {
                        args = [];
                    }
                    var event = name.toLowerCase();
                    if (this.events[event]) {
                        var res = this.events[event].map(function (e) { return e.callback.apply(e.context, args); });
                        return !res.includes(false);
                    }
                    return true;
                };
                EventSystem.prototype.clear = function () {
                    this.events = {};
                };
                return EventSystem;
            }());
            exports.EventSystem = EventSystem;
            function EventsMixin(obj) {
                obj = obj || {};
                var eventSystem = new EventSystem(obj);
                obj.detachEvent = eventSystem.detach.bind(eventSystem);
                obj.attachEvent = eventSystem.on.bind(eventSystem);
                obj.callEvent = eventSystem.fire.bind(eventSystem);
            }
            exports.EventsMixin = EventsMixin;


            /***/
        }),
/* 4 */
/***/ (function (module, exports, __webpack_require__) {

            "use strict";

            Object.defineProperty(exports, "__esModule", { value: true });
            var core_1 = __webpack_require__(1);
            var html_1 = __webpack_require__(0);
            var View = /** @class */ (function () {
                function View(_container, config) {
                    this.config = config || {};
                    this._uid = this.config.rootId || core_1.uid();
                }
                View.prototype.mount = function (container, vnode) {
                    if (vnode) {
                        this._view = vnode;
                    }
                    if (container && this._view && this._view.mount) {
                        // init view inside of HTML container
                        this._container = html_1.toNode(container);
                        if (this._container.tagName) {
                            this._view.mount(this._container);
                        }
                        else if (this._container.attach) {
                            this._container.attach(this);
                        }
                    }
                };
                View.prototype.unmount = function () {
                    var rootView = this.getRootView();
                    if (rootView && rootView.node) {
                        rootView.unmount();
                        this._view = null;
                    }
                };
                View.prototype.getRootView = function () {
                    return this._view;
                };
                View.prototype.getRootNode = function () {
                    return this._view && this._view.node && this._view.node.el;
                };
                View.prototype.paint = function () {
                    if (this._view && // was mounted
                        (this._view.node || // already rendered node
                            this._container)) {
                        // not rendered, but has container
                        this._doNotRepaint = false;
                        this._view.redraw();
                    }
                };
                return View;
            }());
            exports.View = View;
            function toViewLike(view) {
                return {
                    getRootView: function () { return view; },
                    paint: function () { return view.node && view.redraw(); },
                    mount: function (container) { return view.mount(container); },
                };
            }
            exports.toViewLike = toViewLike;


            /***/
        }),
/* 5 */
/***/ (function (module, exports, __webpack_require__) {

            "use strict";

            Object.defineProperty(exports, "__esModule", { value: true });
            var LayoutEvents;
            (function (LayoutEvents) {
                LayoutEvents["beforeShow"] = "beforeShow";
                LayoutEvents["afterShow"] = "afterShow";
                LayoutEvents["beforeHide"] = "beforeHide";
                LayoutEvents["afterHide"] = "afterHide";
                LayoutEvents["beforeResizeStart"] = "beforeResizeStart";
                LayoutEvents["resize"] = "resize";
                LayoutEvents["afterResizeEnd"] = "afterResizeEnd";
                LayoutEvents["beforeAdd"] = "beforeAdd";
                LayoutEvents["afterAdd"] = "afterAdd";
                LayoutEvents["beforeRemove"] = "beforeRemove";
                LayoutEvents["afterRemove"] = "afterRemove";
                LayoutEvents["beforeCollapse"] = "beforeCollapse";
                LayoutEvents["afterCollapse"] = "afterCollapse";
                LayoutEvents["beforeExpand"] = "beforeExpand";
                LayoutEvents["afterExpand"] = "afterExpand";
            })(LayoutEvents = exports.LayoutEvents || (exports.LayoutEvents = {}));
            var resizeMode;
            (function (resizeMode) {
                resizeMode[resizeMode["unknown"] = 0] = "unknown";
                resizeMode[resizeMode["percents"] = 1] = "percents";
                resizeMode[resizeMode["pixels"] = 2] = "pixels";
                resizeMode[resizeMode["mixedpx1"] = 3] = "mixedpx1";
                resizeMode[resizeMode["mixedpx2"] = 4] = "mixedpx2";
                resizeMode[resizeMode["mixedperc1"] = 5] = "mixedperc1";
                resizeMode[resizeMode["mixedperc2"] = 6] = "mixedperc2";
            })(resizeMode = exports.resizeMode || (exports.resizeMode = {}));


            /***/
        }),
/* 6 */
/***/ (function (module, exports, __webpack_require__) {

            "use strict";

            Object.defineProperty(exports, "__esModule", { value: true });
            var RealPosition;
            (function (RealPosition) {
                RealPosition["left"] = "left";
                RealPosition["right"] = "right";
                RealPosition["top"] = "top";
                RealPosition["bottom"] = "bottom";
                RealPosition["center"] = "center";
            })(RealPosition = exports.RealPosition || (exports.RealPosition = {}));
            var Position;
            (function (Position) {
                Position["right"] = "right";
                Position["bottom"] = "bottom";
                Position["center"] = "center";
            })(Position = exports.Position || (exports.Position = {}));
            var MessageContainerPosition;
            (function (MessageContainerPosition) {
                MessageContainerPosition["topLeft"] = "top-left";
                MessageContainerPosition["topRight"] = "top-right";
                MessageContainerPosition["bottomLeft"] = "bottom-left";
                MessageContainerPosition["bottomRight"] = "bottom-right";
            })(MessageContainerPosition = exports.MessageContainerPosition || (exports.MessageContainerPosition = {}));


            /***/
        }),
/* 7 */
/***/ (function (module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function (global, setImmediate) {
                (function () {
                    // global = this
                    global = window

                    var queueId = 1
                    var queue = {}
                    var isRunningTask = false

                    if (!global.setImmediate)
                        global.addEventListener('message', function (e) {
                            if (e.source == global) {
                                if (isRunningTask)
                                    nextTick(queue[e.data])
                                else {
                                    isRunningTask = true
                                    try {
                                        queue[e.data]()
                                    } catch (e) { }

                                    delete queue[e.data]
                                    isRunningTask = false
                                }
                            }
                        })

                    function nextTick(fn) {
                        if (global.setImmediate) setImmediate(fn)
                        // if inside of web worker
                        else if (global.importScripts) setTimeout(fn)
                        else {
                            queueId++
                            queue[queueId] = fn
                            global.postMessage(queueId, '*')
                        }
                    }

                    Deferred.resolve = function (value) {
                        if (!(this._d == 1))
                            throw TypeError()

                        if (value instanceof Deferred)
                            return value

                        return new Deferred(function (resolve) {
                            resolve(value)
                        })
                    }

                    Deferred.reject = function (value) {
                        if (!(this._d == 1))
                            throw TypeError()

                        return new Deferred(function (resolve, reject) {
                            reject(value)
                        })
                    }

                    Deferred.all = function (arr) {
                        if (!(this._d == 1))
                            throw TypeError()

                        if (!(arr instanceof Array))
                            return Deferred.reject(TypeError())

                        var d = new Deferred()

                        function done(e, v) {
                            if (v)
                                return d.resolve(v)

                            if (e)
                                return d.reject(e)

                            var unresolved = arr.reduce(function (cnt, v) {
                                if (v && v.then)
                                    return cnt + 1
                                return cnt
                            }, 0)

                            if (unresolved == 0)
                                d.resolve(arr)

                            arr.map(function (v, i) {
                                if (v && v.then)
                                    v.then(function (r) {
                                        arr[i] = r
                                        done()
                                        return r
                                    }, done)
                            })
                        }

                        done()

                        return d
                    }

                    Deferred.race = function (arr) {
                        if (!(this._d == 1))
                            throw TypeError()

                        if (!(arr instanceof Array))
                            return Deferred.reject(TypeError())

                        if (arr.length == 0)
                            return new Deferred()

                        var d = new Deferred()

                        function done(e, v) {
                            if (v)
                                return d.resolve(v)

                            if (e)
                                return d.reject(e)

                            var unresolved = arr.reduce(function (cnt, v) {
                                if (v && v.then)
                                    return cnt + 1
                                return cnt
                            }, 0)

                            if (unresolved == 0)
                                d.resolve(arr)

                            arr.map(function (v, i) {
                                if (v && v.then)
                                    v.then(function (r) {
                                        done(null, r)
                                    }, done)
                            })
                        }

                        done()

                        return d
                    }

                    Deferred._d = 1


                    /**
                     * @constructor
                     */
                    function Deferred(resolver) {
                        'use strict'
                        if (typeof resolver != 'function' && resolver != undefined)
                            throw TypeError()

                        if (typeof this != 'object' || (this && this.then))
                            throw TypeError()

                        // states
                        // 0: pending
                        // 1: resolving
                        // 2: rejecting
                        // 3: resolved
                        // 4: rejected
                        var self = this,
                            state = 0,
                            val = 0,
                            next = [],
                            fn, er;

                        self['promise'] = self

                        self['resolve'] = function (v) {
                            fn = self.fn
                            er = self.er
                            if (!state) {
                                val = v
                                state = 1

                                nextTick(fire)
                            }
                            return self
                        }

                        self['reject'] = function (v) {
                            fn = self.fn
                            er = self.er
                            if (!state) {
                                val = v
                                state = 2

                                nextTick(fire)

                            }
                            return self
                        }

                        self['_d'] = 1

                        self['then'] = function (_fn, _er) {
                            if (!(this._d == 1))
                                throw TypeError()

                            var d = new Deferred()

                            d.fn = _fn
                            d.er = _er
                            if (state == 3) {
                                d.resolve(val)
                            }
                            else if (state == 4) {
                                d.reject(val)
                            }
                            else {
                                next.push(d)
                            }

                            return d
                        }

                        self['catch'] = function (_er) {
                            return self['then'](null, _er)
                        }

                        var finish = function (type) {
                            state = type || 4
                            next.map(function (p) {
                                state == 3 && p.resolve(val) || p.reject(val)
                            })
                        }

                        try {
                            if (typeof resolver == 'function')
                                resolver(self['resolve'], self['reject'])
                        } catch (e) {
                            self['reject'](e)
                        }

                        return self

                        // ref : reference to 'then' function
                        // cb, ec, cn : successCallback, failureCallback, notThennableCallback
                        function thennable(ref, cb, ec, cn) {
                            // Promises can be rejected with other promises, which should pass through
                            if (state == 2) {
                                return cn()
                            }
                            if ((typeof val == 'object' || typeof val == 'function') && typeof ref == 'function') {
                                try {

                                    // cnt protects against abuse calls from spec checker
                                    var cnt = 0
                                    ref.call(val, function (v) {
                                        if (cnt++) return
                                        val = v
                                        cb()
                                    }, function (v) {
                                        if (cnt++) return
                                        val = v
                                        ec()
                                    })
                                } catch (e) {
                                    val = e
                                    ec()
                                }
                            } else {
                                cn()
                            }
                        };

                        function fire() {

                            // check if it's a thenable
                            var ref;
                            try {
                                ref = val && val.then
                            } catch (e) {
                                val = e
                                state = 2
                                return fire()
                            }

                            thennable(ref, function () {
                                state = 1
                                fire()
                            }, function () {
                                state = 2
                                fire()
                            }, function () {
                                try {
                                    if (state == 1 && typeof fn == 'function') {
                                        val = fn(val)
                                    }

                                    else if (state == 2 && typeof er == 'function') {
                                        val = er(val)
                                        state = 1
                                    }
                                } catch (e) {
                                    val = e
                                    return finish()
                                }

                                if (val == self) {
                                    val = TypeError()
                                    finish()
                                } else thennable(ref, function () {
                                    finish(3)
                                }, finish, function () {
                                    finish(state == 1 && 3)
                                })

                            })
                        }


                    }

                    // Export our library object, either for node.js or as a globally scoped variable
                    if (true) {
                        module['exports'] = Deferred
                    } else { }
                })()

                /* WEBPACK VAR INJECTION */
            }.call(this, __webpack_require__(8), __webpack_require__(27).setImmediate))

            /***/
        }),
/* 8 */
/***/ (function (module, exports) {

            "use strict";

            var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

            var g;

            // This works in non-strict mode
            g = function () {
                return this;
            }();

            try {
                // This works if eval is allowed (see CSP)
                g = g || new Function("return this")();
            } catch (e) {
                // This works if the window reference is available
                if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === "object") g = window;
            }

            // g can still be undefined, but nothing to do about it...
            // We return undefined, instead of nothing here, so it's
            // easier to handle this case. if(!global) { ...}

            module.exports = g;

            /***/
        }),
/* 9 */
/***/ (function (module, exports, __webpack_require__) {

            "use strict";

            Object.defineProperty(exports, "__esModule", { value: true });
            var locale = {
                apply: "apply",
                reject: "reject",
            };
            exports.default = locale;


            /***/
        }),
/* 10 */
/***/ (function (module, exports, __webpack_require__) {

            "use strict";

            Object.defineProperty(exports, "__esModule", { value: true });
            function blockKeys(e) {
                var active = document.activeElement;
                if (!active.classList.contains("dhx_alert__confirm-reject") &&
                    !active.classList.contains("dhx_alert__confirm-aply")) {
                    e.preventDefault();
                }
            }
            function blockScreen(css) {
                var blocker = document.createElement("div");
                blocker.className = "dhx_alert__overlay " + (css || "");
                document.body.appendChild(blocker);
                document.addEventListener("keydown", blockKeys);
                return function () {
                    document.body.removeChild(blocker);
                    document.removeEventListener("keydown", blockKeys);
                };
            }
            exports.blockScreen = blockScreen;


            /***/
        }),
/* 11 */
/***/ (function (module, exports, __webpack_require__) {

            "use strict";

            function __export(m) {
                for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
            }
            Object.defineProperty(exports, "__esModule", { value: true });
            __export(__webpack_require__(32));
            __export(__webpack_require__(12));


            /***/
        }),
/* 12 */
/***/ (function (module, exports, __webpack_require__) {

            "use strict";

            Object.defineProperty(exports, "__esModule", { value: true });
            var PopupEvents;
            (function (PopupEvents) {
                PopupEvents["beforeHide"] = "beforeHide";
                PopupEvents["beforeShow"] = "beforeShow";
                PopupEvents["afterHide"] = "afterHide";
                PopupEvents["afterShow"] = "afterShow";
                PopupEvents["click"] = "click";
            })(PopupEvents = exports.PopupEvents || (exports.PopupEvents = {}));


            /***/
        }),
/* 13 */
/***/ (function (module, exports, __webpack_require__) {

            "use strict";

            Object.defineProperty(exports, "__esModule", { value: true });
            var SliderEvents;
            (function (SliderEvents) {
                SliderEvents["change"] = "change";
                SliderEvents["mousedown"] = "mousedown";
                SliderEvents["mouseup"] = "mouseup";
            })(SliderEvents = exports.SliderEvents || (exports.SliderEvents = {}));


            /***/
        }),
/* 14 */
/***/ (function (module, exports, __webpack_require__) {

            "use strict";

            Object.defineProperty(exports, "__esModule", { value: true });
            var TimepickerEvents;
            (function (TimepickerEvents) {
                TimepickerEvents["change"] = "change";
                TimepickerEvents["beforeApply"] = "beforeApply";
                TimepickerEvents["afterApply"] = "afterApply";
                TimepickerEvents["beforeClose"] = "beforeClose";
                TimepickerEvents["afterClose"] = "afterClose";
                /** @deprecated See a documentation: https://docs.dhtmlx.com/ */
                TimepickerEvents["apply"] = "apply";
                /** @deprecated See a documentation: https://docs.dhtmlx.com/ */
                TimepickerEvents["close"] = "close";
                /** @deprecated See a documentation: https://docs.dhtmlx.com/ */
                TimepickerEvents["save"] = "save";
            })(TimepickerEvents = exports.TimepickerEvents || (exports.TimepickerEvents = {}));


            /***/
        }),
/* 15 */
/***/ (function (module, exports, __webpack_require__) {

            "use strict";

            Object.defineProperty(exports, "__esModule", { value: true });
            var core_1 = __webpack_require__(1);
            var core_2 = __webpack_require__(1);
            exports.locale = {
                monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                months: [
                    "January",
                    "February",
                    "March",
                    "April",
                    "May",
                    "June",
                    "July",
                    "August",
                    "September",
                    "October",
                    "November",
                    "December",
                ],
                daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
                days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Monday"],
                cancel: "Cancel",
            };
            /*
                %d	day as a number with leading zero, 01..31
                %j	day as a number, 1..31
                %D	short name of the day, Su Mo Tu...
                %l	full name of the day, Sunday Monday Tuesday...
                %m	month as a number with leading zero, 01..12
                %n	month as a number, 1..12
                %M	short name of the month, Jan Feb Mar...
                %F	full name of the month, January February March...
                %y	year as a number, 2 digits
                %Y	year as a number, 4 digits
                %h	hours 12-format with leading zero, 01..12)
                %g	hours 12-format, 1..12)
                %H	hours 24-format with leading zero, 01..24
                %G	hours 24-format, 1..24
                %i	minutes with leading zero, 01..59
                %s	seconds with leading zero, 01..59
                %a	am or pm
                %A	AM or PM
                %u	milliseconds
            */
            var formatters = {
                "%d": function (date) {
                    var day = date.getDate();
                    return day < 10 ? "0" + day : day;
                },
                "%j": function (date) { return date.getDate(); },
                "%l": function (date) {
                    return exports.locale.days[date.getDay()];
                },
                "%D": function (date) {
                    return exports.locale.daysShort[date.getDay()];
                },
                "%m": function (date) {
                    var month = date.getMonth() + 1;
                    return month < 10 ? "0" + month : month;
                },
                "%n": function (date) { return date.getMonth() + 1; },
                "%M": function (date) { return exports.locale.monthsShort[date.getMonth()]; },
                "%F": function (date) { return exports.locale.months[date.getMonth()]; },
                "%y": function (date) {
                    return date
                        .getFullYear()
                        .toString()
                        .slice(2);
                },
                "%Y": function (date) { return date.getFullYear(); },
                "%h": function (date) {
                    var hours = date.getHours() % 12;
                    if (hours === 0) {
                        hours = 12;
                    }
                    return hours < 10 ? "0" + hours : hours;
                },
                "%g": function (date) {
                    var hours = date.getHours() % 12;
                    if (hours === 0) {
                        hours = 12;
                    }
                    return hours;
                },
                "%H": function (date) {
                    var hours = date.getHours();
                    return hours < 10 ? "0" + hours : hours;
                },
                "%G": function (date) { return date.getHours(); },
                "%i": function (date) {
                    var minutes = date.getMinutes();
                    return minutes < 10 ? "0" + minutes : minutes;
                },
                "%s": function (date) {
                    var seconds = date.getSeconds();
                    return seconds < 10 ? "0" + seconds : seconds;
                },
                "%a": function (date) {
                    return date.getHours() >= 12 ? "pm" : "am";
                },
                "%A": function (date) {
                    return date.getHours() >= 12 ? "PM" : "AM";
                },
                "%u": function (date) { return date.getMilliseconds(); },
            };
            var setFormatters = {
                "%d": function (date, value) {
                    var check = /(^([0-9][0-9])$)/i.test(value);
                    check ? date.setDate(Number(value)) : date.setDate(Number(1));
                },
                "%j": function (date, value) {
                    var check = /(^([0-9]?[0-9])$)/i.test(value);
                    check ? date.setDate(Number(value)) : date.setDate(Number(1));
                },
                "%m": function (date, value) {
                    var check = /(^([0-9][0-9])$)/i.test(value);
                    check ? date.setMonth(Number(value) - 1) : date.setMonth(Number(0));
                },
                "%n": function (date, value) {
                    var check = /(^([0-9]?[0-9])$)/i.test(value);
                    check ? date.setMonth(Number(value) - 1) : date.setMonth(Number(0));
                },
                "%M": function (date, value) {
                    var index = core_2.findIndex(exports.locale.monthsShort, function (v) { return v === value; });
                    index === -1 ? date.setMonth(0) : date.setMonth(index);
                },
                "%F": function (date, value) {
                    var index = core_2.findIndex(exports.locale.months, function (v) { return v === value; });
                    index === -1 ? date.setMonth(0) : date.setMonth(index);
                },
                "%y": function (date, value) {
                    var check = /(^([0-9][0-9])$)/i.test(value);
                    check ? date.setFullYear(Number("20" + value)) : date.setFullYear(Number("2000"));
                },
                "%Y": function (date, value) {
                    var check = /(^([0-9][0-9][0-9][0-9])$)/i.test(value);
                    check ? date.setFullYear(Number(value)) : date.setFullYear(Number("2000"));
                },
                "%h": function (date, value, dateFormat) {
                    var check = /(^0[1-9]|1[0-2]$)/i.test(value);
                    (check && dateFormat === "pm") || dateFormat === "PM"
                        ? date.setHours(Number(value))
                        : date.setHours(Number(0));
                },
                "%g": function (date, value, dateFormat) {
                    var check = /(^[1-9]$)|(^0[1-9]|1[0-2]$)/i.test(value);
                    (check && dateFormat === "pm") || dateFormat === "PM"
                        ? date.setHours(Number(value))
                        : date.setHours(Number(0));
                },
                "%H": function (date, value) {
                    var check = /(^[0-2][0-9]$)/i.test(value);
                    check ? date.setHours(Number(value)) : date.setHours(Number(0));
                },
                "%G": function (date, value) {
                    var check = /(^[1-9][0-9]?$)/i.test(value);
                    check ? date.setHours(Number(value)) : date.setHours(Number(0));
                },
                "%i": function (date, value) {
                    var check = /(^([0-5][0-9])$)/i.test(value);
                    check ? date.setMinutes(Number(value)) : date.setMinutes(Number(0));
                },
                "%s": function (date, value) {
                    var check = /(^([0-5][0-9])$)/i.test(value);
                    check ? date.setSeconds(Number(value)) : date.setSeconds(Number(0));
                },
                "%a": function (date, value) {
                    if (value === "pm") {
                        date.setHours(date.getHours() + 12);
                    }
                },
                "%A": function (date, value) {
                    if (value === "PM") {
                        date.setHours(date.getHours() + 12);
                    }
                },
            };
            var TokenType;
            (function (TokenType) {
                TokenType[TokenType["separator"] = 0] = "separator";
                TokenType[TokenType["datePart"] = 1] = "datePart";
            })(TokenType || (TokenType = {}));
            function tokenizeFormat(format) {
                var tokens = [];
                var currentSeparator = "";
                for (var i = 0; i < format.length; i++) {
                    if (format[i] === "%") {
                        if (currentSeparator.length > 0) {
                            tokens.push({
                                type: TokenType.separator,
                                value: currentSeparator,
                            });
                            currentSeparator = "";
                        }
                        tokens.push({
                            type: TokenType.datePart,
                            value: format[i] + format[i + 1],
                        });
                        i++;
                    }
                    else {
                        currentSeparator += format[i];
                    }
                }
                if (currentSeparator.length > 0) {
                    tokens.push({
                        type: TokenType.separator,
                        value: currentSeparator,
                    });
                }
                return tokens;
            }
            function getFormattedDate(format, date) {
                return tokenizeFormat(format).reduce(function (res, token) {
                    if (token.type === TokenType.separator) {
                        return res + token.value;
                    }
                    else {
                        if (!formatters[token.value]) {
                            return res;
                        }
                        return res + formatters[token.value](date);
                    }
                }, "");
            }
            exports.getFormattedDate = getFormattedDate;
            function stringToDate(str, format, validate) {
                if (typeof str !== "string") {
                    return;
                }
                var tokens = tokenizeFormat(format);
                var dateParts = [];
                var index = 0;
                var formatter = null;
                for (var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++) {
                    var token = tokens_1[_i];
                    if (token.type === TokenType.separator) {
                        var sepratorIndex = str.indexOf(token.value, index);
                        if (sepratorIndex === -1) {
                            if (validate) {
                                return false;
                            }
                            throw new Error("Incorrect date, see docs: https://docs.dhtmlx.com/suite/calendar__api__calendar_dateformat_config.html");
                        }
                        if (formatter) {
                            dateParts.push({
                                formatter: formatter,
                                value: str.slice(index, sepratorIndex),
                            });
                            formatter = null;
                        }
                        index = sepratorIndex + token.value.length;
                    }
                    else if (token.type === TokenType.datePart) {
                        formatter = token.value;
                    }
                }
                if (formatter === "%A" || formatter === "%a") {
                    dateParts.unshift({
                        formatter: formatter,
                        value: str.slice(index),
                    });
                }
                else if (formatter) {
                    dateParts.push({
                        formatter: formatter,
                        value: str.slice(index),
                    });
                }
                dateParts.reverse();
                var dateFormat;
                for (var _a = 0, dateParts_1 = dateParts; _a < dateParts_1.length; _a++) {
                    var datePart = dateParts_1[_a];
                    if (datePart.formatter === "%A" || datePart.formatter === "%a") {
                        dateFormat = datePart.value;
                    }
                }
                var date = new Date(0);
                for (var _b = 0, dateParts_2 = dateParts; _b < dateParts_2.length; _b++) {
                    var datePart = dateParts_2[_b];
                    if (setFormatters[datePart.formatter]) {
                        setFormatters[datePart.formatter](date, datePart.value, dateFormat);
                    }
                }
                return validate ? true : date;
            }
            exports.stringToDate = stringToDate;
            var DateHelper = /** @class */ (function () {
                function DateHelper() {
                }
                DateHelper.copy = function (d) {
                    return new Date(d);
                };
                DateHelper.fromYear = function (year) {
                    return new Date(year, 0, 1);
                };
                DateHelper.fromYearAndMonth = function (year, month) {
                    return new Date(year, month, 1);
                };
                DateHelper.weekStart = function (d, firstWeekday) {
                    var diff = (d.getDay() + 7 - firstWeekday) % 7;
                    return new Date(d.getFullYear(), d.getMonth(), d.getDate() - diff);
                };
                DateHelper.monthStart = function (d) {
                    return new Date(d.getFullYear(), d.getMonth(), 1);
                };
                DateHelper.yearStart = function (d) {
                    return new Date(d.getFullYear(), 0, 1);
                };
                DateHelper.dayStart = function (d) {
                    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
                };
                DateHelper.addDay = function (d, count) {
                    if (count === void 0) { count = 1; }
                    return new Date(d.getFullYear(), d.getMonth(), d.getDate() + count);
                };
                DateHelper.addMonth = function (d, count) {
                    if (count === void 0) { count = 1; }
                    return new Date(d.getFullYear(), d.getMonth() + count);
                };
                DateHelper.addYear = function (d, count) {
                    if (count === void 0) { count = 1; }
                    return new Date(d.getFullYear() + count, d.getMonth());
                };
                DateHelper.withHoursAndMinutes = function (d, hours, minutes, dateFormat) {
                    if (dateFormat === undefined || (!dateFormat && hours === 12) || (dateFormat && hours !== 12)) {
                        return new Date(d.getFullYear(), d.getMonth(), d.getDate(), hours, minutes);
                    }
                    else if (dateFormat && hours === 12) {
                        return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, minutes);
                    }
                    else {
                        return new Date(d.getFullYear(), d.getMonth(), d.getDate(), hours + 12, minutes);
                    }
                };
                DateHelper.setMonth = function (d, month) {
                    d.setMonth(month);
                };
                DateHelper.setYear = function (d, year) {
                    d.setFullYear(year);
                };
                DateHelper.mergeHoursAndMinutes = function (source, target) {
                    return new Date(source.getFullYear(), source.getMonth(), source.getDate(), target.getHours(), target.getMinutes());
                };
                DateHelper.isWeekEnd = function (d) {
                    return d.getDay() === 0 || d.getDay() === 6;
                };
                DateHelper.getTwelweYears = function (d) {
                    var y = d.getFullYear();
                    var firstYear = y - (y % 12);
                    return core_1.range(firstYear, firstYear + 11);
                };
                DateHelper.getWeekNumber = function (d) {
                    if (d.getDay() !== 6) {
                        d = DateHelper.addDay(d, 6 - d.getDay());
                    }
                    var dayMS = 24 * 60 * 60 * 1000;
                    var ordinal = (d.valueOf() - DateHelper.yearStart(d).valueOf()) / dayMS;
                    return Math.floor((ordinal - d.getDay() + 10) / 7);
                };
                DateHelper.isSameDay = function (d1, d2) {
                    return (d1.getFullYear() === d2.getFullYear() &&
                        d1.getMonth() === d2.getMonth() &&
                        d1.getDate() === d2.getDate());
                };
                DateHelper.toDateObject = function (date, dateFormat) {
                    if (typeof date === "string") {
                        return stringToDate(date, dateFormat);
                    }
                    else {
                        return new Date(date);
                    }
                };
                DateHelper.nullTimestampDate = new Date(0);
                return DateHelper;
            }());
            exports.DateHelper = DateHelper;


            /***/
        }),
/* 16 */
/***/ (function (module, exports, __webpack_require__) {

            __webpack_require__(17);
            __webpack_require__(18);
            __webpack_require__(19);
            __webpack_require__(20);
            __webpack_require__(21);
            module.exports = __webpack_require__(22);


            /***/
        }),
/* 17 */
/***/ (function (module, exports) {

            Object.values = Object.values
                ? Object.values
                : function (obj) {
                    var allowedTypes = [
                        "[object String]",
                        "[object Object]",
                        "[object Array]",
                        "[object Function]",
                    ];
                    var objType = Object.prototype.toString.call(obj);
                    if (obj === null || typeof obj === "undefined") {
                        throw new TypeError("Cannot convert undefined or null to object");
                    }
                    else if (!~allowedTypes.indexOf(objType)) {
                        return [];
                    }
                    else {
                        // if ES6 is supported
                        if (Object.keys) {
                            return Object.keys(obj).map(function (key) {
                                return obj[key];
                            });
                        }
                        var result = [];
                        for (var prop in obj) {
                            if (obj.hasOwnProperty(prop)) {
                                result.push(obj[prop]);
                            }
                        }
                        return result;
                    }
                };
            if (!Object.assign) {
                Object.defineProperty(Object, "assign", {
                    enumerable: false,
                    configurable: true,
                    writable: true,
                    value: function (target) {
                        "use strict";
                        var args = [];
                        for (var _i = 1; _i < arguments.length; _i++) {
                            args[_i - 1] = arguments[_i];
                        }
                        if (target === undefined || target === null) {
                            throw new TypeError("Cannot convert first argument to object");
                        }
                        var to = Object(target);
                        for (var i = 0; i < args.length; i++) {
                            var nextSource = args[i];
                            if (nextSource === undefined || nextSource === null) {
                                continue;
                            }
                            var keysArray = Object.keys(Object(nextSource));
                            for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
                                var nextKey = keysArray[nextIndex];
                                var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                                if (desc !== undefined && desc.enumerable) {
                                    to[nextKey] = nextSource[nextKey];
                                }
                            }
                        }
                        return to;
                    },
                });
            }


            /***/
        }),
/* 18 */
/***/ (function (module, exports) {

            /* eslint-disable prefer-rest-params */
            /* eslint-disable @typescript-eslint/unbound-method */
            // eslint-disable-next-line @typescript-eslint/unbound-method
            if (!Array.prototype.includes) {
                Object.defineProperty(Array.prototype, "includes", {
                    value: function (searchElement, fromIndex) {
                        if (this == null) {
                            throw new TypeError('"this" is null or not defined');
                        }
                        // 1. Let O be ? ToObject(this value).
                        var o = Object(this);
                        // 2. Let len be ? ToLength(? Get(O, "length")).
                        var len = o.length >>> 0;
                        // 3. If len is 0, return false.
                        if (len === 0) {
                            return false;
                        }
                        // 4. Let n be ? ToInteger(fromIndex).
                        //    (If fromIndex is undefined, this step produces the value 0.)
                        var n = fromIndex | 0;
                        // 5. If n ≥ 0, then
                        //  a. Let k be n.
                        // 6. Else n < 0,
                        //  a. Let k be len + n.
                        //  b. If k < 0, let k be 0.
                        var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);
                        function sameValueZero(x, y) {
                            return x === y || (typeof x === "number" && typeof y === "number" && isNaN(x) && isNaN(y));
                        }
                        // 7. Repeat, while k < len
                        while (k < len) {
                            // a. Let elementK be the result of ? Get(O, ! ToString(k)).
                            // b. If SameValueZero(searchElement, elementK) is true, return true.
                            if (sameValueZero(o[k], searchElement)) {
                                return true;
                            }
                            // c. Increase k by 1.
                            k++;
                        }
                        // 8. Return false
                        return false;
                    },
                    configurable: true,
                    writable: true,
                });
            }
            // https://tc39.github.io/ecma262/#sec-array.prototype.find
            if (!Array.prototype.find) {
                Object.defineProperty(Array.prototype, "find", {
                    value: function (predicate) {
                        // 1. Let O be ? ToObject(this value).
                        if (this == null) {
                            throw new TypeError('"this" is null or not defined');
                        }
                        var o = Object(this);
                        // 2. Let len be ? ToLength(? Get(O, "length")).
                        var len = o.length >>> 0;
                        // 3. If IsCallable(predicate) is false, throw a TypeError exception.
                        if (typeof predicate !== "function") {
                            throw new TypeError("predicate must be a function");
                        }
                        // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
                        var thisArg = arguments[1];
                        // 5. Let k be 0.
                        var k = 0;
                        // 6. Repeat, while k < len
                        while (k < len) {
                            // a. Let Pk be ! ToString(k).
                            // b. Let kValue be ? Get(O, Pk).
                            // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                            // d. If testResult is true, return kValue.
                            var kValue = o[k];
                            if (predicate.call(thisArg, kValue, k, o)) {
                                return kValue;
                            }
                            // e. Increase k by 1.
                            k++;
                        }
                        // 7. Return undefined.
                        return undefined;
                    },
                    configurable: true,
                    writable: true,
                });
            }
            if (!Array.prototype.findIndex) {
                Array.prototype.findIndex = function (predicate) {
                    if (this == null) {
                        throw new TypeError("Array.prototype.findIndex called on null or undefined");
                    }
                    if (typeof predicate !== "function") {
                        throw new TypeError("predicate must be a function");
                    }
                    var list = Object(this);
                    var length = list.length >>> 0;
                    var thisArg = arguments[1];
                    var value;
                    for (var i = 0; i < length; i++) {
                        value = list[i];
                        if (predicate.call(thisArg, value, i, list)) {
                            return i;
                        }
                    }
                    return -1;
                };
            }


            /***/
        }),
/* 19 */
/***/ (function (module, exports) {

            if (!String.prototype.includes) {
                String.prototype.includes = function (search, start) {
                    "use strict";
                    if (typeof start !== "number") {
                        start = 0;
                    }
                    if (start + search.length > this.length) {
                        return false;
                    }
                    else {
                        return this.indexOf(search, start) !== -1;
                    }
                };
            }
            if (!String.prototype.startsWith) {
                Object.defineProperty(String.prototype, "startsWith", {
                    enumerable: false,
                    configurable: true,
                    writable: true,
                    value: function (searchString, position) {
                        position = position || 0;
                        return this.indexOf(searchString, position) === position;
                    },
                });
            }
            if (!String.prototype.padStart) {
                String.prototype.padStart = function padStart(targetLength, padString) {
                    targetLength = targetLength >> 0;
                    padString = String(padString || " ");
                    if (this.length > targetLength) {
                        return String(this);
                    }
                    else {
                        targetLength = targetLength - this.length;
                        if (targetLength > padString.length) {
                            padString += padString.repeat(targetLength / padString.length);
                        }
                        return padString.slice(0, targetLength) + String(this);
                    }
                };
            }
            if (!String.prototype.padEnd) {
                String.prototype.padEnd = function padEnd(targetLength, padString) {
                    targetLength = targetLength >> 0;
                    padString = String(padString || " ");
                    if (this.length > targetLength) {
                        return String(this);
                    }
                    else {
                        targetLength = targetLength - this.length;
                        if (targetLength > padString.length) {
                            padString += padString.repeat(targetLength / padString.length);
                        }
                        return String(this) + padString.slice(0, targetLength);
                    }
                };
            }


            /***/
        }),
/* 20 */
/***/ (function (module, exports) {

            /* eslint-disable @typescript-eslint/no-this-alias */
            /* eslint-disable prefer-rest-params */
            /* eslint-disable @typescript-eslint/unbound-method */
            if (Element && !Element.prototype.matches) {
                var proto = Element.prototype;
                proto.matches =
                    proto.matchesSelector ||
                    proto.mozMatchesSelector ||
                    proto.msMatchesSelector ||
                    proto.oMatchesSelector ||
                    proto.webkitMatchesSelector;
            }
            // Source: https://github.com/naminho/svg-classlist-polyfill/blob/master/polyfill.js
            if (!("classList" in SVGElement.prototype)) {
                Object.defineProperty(SVGElement.prototype, "classList", {
                    get: function get() {
                        var _this = this;
                        return {
                            contains: function contains(className) {
                                return _this.className.baseVal.split(" ").indexOf(className) !== -1;
                            },
                            add: function add(className) {
                                return _this.setAttribute("class", _this.getAttribute("class") + " " + className);
                            },
                            remove: function remove(className) {
                                var removedClass = _this
                                    .getAttribute("class")
                                    .replace(new RegExp("(\\s|^)".concat(className, "(\\s|$)"), "g"), "$2");
                                if (_this.classList.contains(className)) {
                                    _this.setAttribute("class", removedClass);
                                }
                            },
                            toggle: function toggle(className) {
                                if (this.contains(className)) {
                                    this.remove(className);
                                }
                                else {
                                    this.add(className);
                                }
                            },
                        };
                    },
                    configurable: true,
                });
            }
            // Source: https://github.com/tc39/proposal-object-values-entries/blob/master/polyfill.js
            if (!Object.entries) {
                var reduce_1 = Function.bind.call(Function.call, Array.prototype.reduce);
                var isEnumerable_1 = Function.bind.call(Function.call, Object.prototype.propertyIsEnumerable);
                var concat_1 = Function.bind.call(Function.call, Array.prototype.concat);
                Object.entries = function entries(O) {
                    return reduce_1(Object.keys(O), function (e, k) { return concat_1(e, typeof k === "string" && isEnumerable_1(O, k) ? [[k, O[k]]] : []); }, []);
                };
            }
            // Source: https://gist.github.com/rockinghelvetica/00b9f7b5c97a16d3de75ba99192ff05c
            if (!Event.prototype.composedPath) {
                Event.prototype.composedPath = function () {
                    if (this.path) {
                        return this.path;
                    }
                    var target = this.target;
                    this.path = [];
                    while (target.parentNode !== null) {
                        this.path.push(target);
                        target = target.parentNode;
                    }
                    this.path.push(document, window);
                    return this.path;
                };
            }


            /***/
        }),
/* 21 */
/***/ (function (module, exports) {

            Math.sign =
                Math.sign ||
                function (x) {
                    x = +x;
                    if (x === 0 || isNaN(x)) {
                        return x;
                    }
                    return x > 0 ? 1 : -1;
                };


            /***/
        }),
/* 22 */
/***/ (function (module, exports, __webpack_require__) {

            "use strict";

            Object.defineProperty(exports, "__esModule", { value: true });
            __webpack_require__(23);
            // WIDGETS
            var ts_message_1 = __webpack_require__(24);
            exports.tooltip = ts_message_1.tooltip;
            var ts_popup_1 = __webpack_require__(11);
            exports.Popup = ts_popup_1.Popup;
            var Calendar_1 = __webpack_require__(34);
            exports.Calendar = Calendar_1.Calendar;
            // TOOLS
            var date_1 = __webpack_require__(15);
            var w = window;
            exports.i18n = w.dhx && w.dhx.i18n ? w.dhx.i18 : {};
            exports.i18n.setLocale = function (component, value) {
                var target = exports.i18n[component];
                for (var key in value) {
                    target[key] = value[key];
                }
            };
            exports.i18n.calendar = exports.i18n.calendar || date_1.locale;


            /***/
        }),
/* 23 */
/***/ (function (module, exports, __webpack_require__) {

            // extracted by mini-css-extract-plugin

            /***/
        }),
/* 24 */
/***/ (function (module, exports, __webpack_require__) {

            "use strict";

            function __export(m) {
                for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
            }
            Object.defineProperty(exports, "__esModule", { value: true });
            __export(__webpack_require__(25));
            __export(__webpack_require__(26));
            __export(__webpack_require__(30));
            __export(__webpack_require__(31));
            __export(__webpack_require__(6));


            /***/
        }),
/* 25 */
/***/ (function (module, exports, __webpack_require__) {

            "use strict";

            Object.defineProperty(exports, "__esModule", { value: true });
            var html_1 = __webpack_require__(0);
            var types_1 = __webpack_require__(6);
            var nodeTimeout = new WeakMap();
            var containers = new Map();
            function createMessageContainer(parent, position) {
                var messageContainer = document.createElement("div");
                messageContainer.setAttribute("data-position", position);
                messageContainer.className =
                    "dhx_message-container " +
                    "dhx_message-container--" +
                    position +
                    (parent === document.body ? " dhx_message-container--in-body" : "");
                return messageContainer;
            }
            function onExpire(node, fromClick) {
                if (fromClick) {
                    clearTimeout(nodeTimeout.get(node));
                }
                var container = node.parentNode;
                var position = container.getAttribute("data-position");
                var parent = container.parentNode;
                var messageContainerInfo = containers.get(parent);
                if (!messageContainerInfo) {
                    return;
                }
                var positionInfo = messageContainerInfo[position];
                if (!positionInfo) {
                    return;
                }
                var stack = positionInfo.stack;
                var index = stack.indexOf(node);
                if (index !== -1) {
                    container.removeChild(node);
                    stack.splice(index, 1);
                    if (stack.length === 0) {
                        parent.removeChild(container);
                    }
                    return;
                }
            }
            function message(props) {
                var _a;
                if (typeof props === "string") {
                    props = { text: props };
                }
                props.position = props.position || types_1.MessageContainerPosition.topRight;
                var messageBox = document.createElement("div");
                messageBox.className = "dhx_widget dhx_message " + (props.css || "");
                messageBox.setAttribute("role", "alert");
                props.text && messageBox.setAttribute("aria-describedby", "dhx_alert__content");
                if (props.html) {
                    messageBox.innerHTML = props.html;
                }
                else {
                    messageBox.innerHTML = "<span class=\"dhx_message__text\">" + props.text + "</span>\n\t\t" + (props.icon ? "<span class=\"dhx_message__icon dxi " + props.icon + "\"></span>" : "");
                }
                var parent = props.node ? html_1.toNode(props.node) : document.body;
                var position = getComputedStyle(parent).position;
                if (position === "static") {
                    parent.style.position = "relative";
                }
                var messageContainerInfo = containers.get(parent);
                if (!messageContainerInfo) {
                    containers.set(parent, (_a = {},
                        _a[props.position] = {
                            stack: [],
                            container: createMessageContainer(parent, props.position),
                        },
                        _a));
                }
                else if (!messageContainerInfo[props.position]) {
                    messageContainerInfo[props.position] = {
                        stack: [],
                        container: createMessageContainer(parent, props.position),
                    };
                }
                var _b = containers.get(parent)[props.position], stack = _b.stack, container = _b.container;
                if (stack.length === 0) {
                    parent.appendChild(container);
                }
                stack.push(messageBox);
                container.appendChild(messageBox);
                if (props.expire) {
                    var timeout = setTimeout(function () { return onExpire(messageBox); }, props.expire);
                    nodeTimeout.set(messageBox, timeout);
                }
                messageBox.onclick = function () { return onExpire(messageBox, true); };
            }
            exports.message = message;


            /***/
        }),
/* 26 */
/***/ (function (module, exports, __webpack_require__) {

            "use strict";
/* WEBPACK VAR INJECTION */(function (Promise) {
                Object.defineProperty(exports, "__esModule", { value: true });
                var en_1 = __webpack_require__(9);
                var common_1 = __webpack_require__(10);
                function alert(props) {
                    var apply = props.buttons && props.buttons[0] ? props.buttons[0] : en_1.default.apply;
                    var unblock = common_1.blockScreen(props.blockerCss);
                    return new Promise(function (res) {
                        var alertBox = document.createElement("div");
                        alertBox.setAttribute("role", "alert");
                        alertBox.setAttribute("aria-modal", "true");
                        props.text && alertBox.setAttribute("aria-describedby", "dhx_alert__content");
                        props.header && alertBox.setAttribute("aria-labelledby", "dhx_alert__header");
                        alertBox.className = "dhx_widget dhx_alert " + (props.css || "");
                        var closeAlert = function (e) {
                            if (e.key === "Escape" || e.key === "Esc" || e.key === " ") {
                                e.preventDefault();
                                alertBox.querySelector("button").click();
                            }
                        };
                        alertBox.innerHTML = "\n\t\t\t" + (props.header ? "<div id=\"dhx_alert__header\" class=\"dhx_alert__header\"> " + props.header + " </div>" : "") + "\n\t\t\t" + (props.text ? "<div id=\"dhx_alert__content\" class=\"dhx_alert__content\">" + props.text + "</div>" : "") + "\n\t\t\t<div class=\"dhx_alert__footer " + (props.buttonsAlignment ? "dhx_alert__footer--" + props.buttonsAlignment : "") + "\">\n\t\t\t\t<button type=\"button\" aria-label=\"confirm\" class=\"dhx_alert__apply-button dhx_button dhx_button--view_flat dhx_button--color_primary dhx_button--size_medium\">" + apply + "</button>\n\t\t\t</div>";
                        document.body.appendChild(alertBox);
                        alertBox.querySelector(".dhx_alert__apply-button").focus();
                        alertBox.querySelector("button").addEventListener("click", function () {
                            unblock();
                            document.body.removeChild(alertBox);
                            res(true);
                        });
                        alertBox.addEventListener("keydown", closeAlert);
                    });
                }
                exports.alert = alert;

                /* WEBPACK VAR INJECTION */
            }.call(this, __webpack_require__(7)))

            /***/
        }),
/* 27 */
/***/ (function (module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function (global) {
                var scope = (typeof global !== "undefined" && global) ||
                    (typeof self !== "undefined" && self) ||
                    window;
                var apply = Function.prototype.apply;

                // DOM APIs, for completeness

                exports.setTimeout = function () {
                    return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
                };
                exports.setInterval = function () {
                    return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
                };
                exports.clearTimeout =
                    exports.clearInterval = function (timeout) {
                        if (timeout) {
                            timeout.close();
                        }
                    };

                function Timeout(id, clearFn) {
                    this._id = id;
                    this._clearFn = clearFn;
                }
                Timeout.prototype.unref = Timeout.prototype.ref = function () { };
                Timeout.prototype.close = function () {
                    this._clearFn.call(scope, this._id);
                };

                // Does not start the time, just sets up the members needed.
                exports.enroll = function (item, msecs) {
                    clearTimeout(item._idleTimeoutId);
                    item._idleTimeout = msecs;
                };

                exports.unenroll = function (item) {
                    clearTimeout(item._idleTimeoutId);
                    item._idleTimeout = -1;
                };

                exports._unrefActive = exports.active = function (item) {
                    clearTimeout(item._idleTimeoutId);

                    var msecs = item._idleTimeout;
                    if (msecs >= 0) {
                        item._idleTimeoutId = setTimeout(function onTimeout() {
                            if (item._onTimeout)
                                item._onTimeout();
                        }, msecs);
                    }
                };

                // setimmediate attaches itself to the global object
                __webpack_require__(28);
                // On some exotic environments, it's not clear which object `setimmediate` was
                // able to install onto.  Search each possibility in the same order as the
                // `setimmediate` library.
                exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                    (typeof global !== "undefined" && global.setImmediate) ||
                    (this && this.setImmediate);
                exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                    (typeof global !== "undefined" && global.clearImmediate) ||
                    (this && this.clearImmediate);

                /* WEBPACK VAR INJECTION */
            }.call(this, __webpack_require__(8)))

            /***/
        }),
/* 28 */
/***/ (function (module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function (global, process) {
                (function (global, undefined) {
                    "use strict";

                    if (global.setImmediate) {
                        return;
                    }

                    var nextHandle = 1; // Spec says greater than zero
                    var tasksByHandle = {};
                    var currentlyRunningATask = false;
                    var doc = global.document;
                    var registerImmediate;

                    function setImmediate(callback) {
                        // Callback can either be a function or a string
                        if (typeof callback !== "function") {
                            callback = new Function("" + callback);
                        }
                        // Copy function arguments
                        var args = new Array(arguments.length - 1);
                        for (var i = 0; i < args.length; i++) {
                            args[i] = arguments[i + 1];
                        }
                        // Store and register the task
                        var task = { callback: callback, args: args };
                        tasksByHandle[nextHandle] = task;
                        registerImmediate(nextHandle);
                        return nextHandle++;
                    }

                    function clearImmediate(handle) {
                        delete tasksByHandle[handle];
                    }

                    function run(task) {
                        var callback = task.callback;
                        var args = task.args;
                        switch (args.length) {
                            case 0:
                                callback();
                                break;
                            case 1:
                                callback(args[0]);
                                break;
                            case 2:
                                callback(args[0], args[1]);
                                break;
                            case 3:
                                callback(args[0], args[1], args[2]);
                                break;
                            default:
                                callback.apply(undefined, args);
                                break;
                        }
                    }

                    function runIfPresent(handle) {
                        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
                        // So if we're currently running a task, we'll need to delay this invocation.
                        if (currentlyRunningATask) {
                            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
                            // "too much recursion" error.
                            setTimeout(runIfPresent, 0, handle);
                        } else {
                            var task = tasksByHandle[handle];
                            if (task) {
                                currentlyRunningATask = true;
                                try {
                                    run(task);
                                } finally {
                                    clearImmediate(handle);
                                    currentlyRunningATask = false;
                                }
                            }
                        }
                    }

                    function installNextTickImplementation() {
                        registerImmediate = function (handle) {
                            process.nextTick(function () { runIfPresent(handle); });
                        };
                    }

                    function canUsePostMessage() {
                        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
                        // where `global.postMessage` means something completely different and can't be used for this purpose.
                        if (global.postMessage && !global.importScripts) {
                            var postMessageIsAsynchronous = true;
                            var oldOnMessage = global.onmessage;
                            global.onmessage = function () {
                                postMessageIsAsynchronous = false;
                            };
                            global.postMessage("", "*");
                            global.onmessage = oldOnMessage;
                            return postMessageIsAsynchronous;
                        }
                    }

                    function installPostMessageImplementation() {
                        // Installs an event handler on `global` for the `message` event: see
                        // * https://developer.mozilla.org/en/DOM/window.postMessage
                        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

                        var messagePrefix = "setImmediate$" + Math.random() + "$";
                        var onGlobalMessage = function (event) {
                            if (event.source === global &&
                                typeof event.data === "string" &&
                                event.data.indexOf(messagePrefix) === 0) {
                                runIfPresent(+event.data.slice(messagePrefix.length));
                            }
                        };

                        if (global.addEventListener) {
                            global.addEventListener("message", onGlobalMessage, false);
                        } else {
                            global.attachEvent("onmessage", onGlobalMessage);
                        }

                        registerImmediate = function (handle) {
                            global.postMessage(messagePrefix + handle, "*");
                        };
                    }

                    function installMessageChannelImplementation() {
                        var channel = new MessageChannel();
                        channel.port1.onmessage = function (event) {
                            var handle = event.data;
                            runIfPresent(handle);
                        };

                        registerImmediate = function (handle) {
                            channel.port2.postMessage(handle);
                        };
                    }

                    function installReadyStateChangeImplementation() {
                        var html = doc.documentElement;
                        registerImmediate = function (handle) {
                            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
                            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
                            var script = doc.createElement("script");
                            script.onreadystatechange = function () {
                                runIfPresent(handle);
                                script.onreadystatechange = null;
                                html.removeChild(script);
                                script = null;
                            };
                            html.appendChild(script);
                        };
                    }

                    function installSetTimeoutImplementation() {
                        registerImmediate = function (handle) {
                            setTimeout(runIfPresent, 0, handle);
                        };
                    }

                    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
                    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
                    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

                    // Don't get fooled by e.g. browserify environments.
                    if ({}.toString.call(global.process) === "[object process]") {
                        // For Node.js before 0.9
                        installNextTickImplementation();

                    } else if (canUsePostMessage()) {
                        // For non-IE10 modern browsers
                        installPostMessageImplementation();

                    } else if (global.MessageChannel) {
                        // For web workers, where supported
                        installMessageChannelImplementation();

                    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
                        // For IE 6–8
                        installReadyStateChangeImplementation();

                    } else {
                        // For older browsers
                        installSetTimeoutImplementation();
                    }

                    attachTo.setImmediate = setImmediate;
                    attachTo.clearImmediate = clearImmediate;
                }(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

                /* WEBPACK VAR INJECTION */
            }.call(this, __webpack_require__(8), __webpack_require__(29)))

            /***/
        }),
/* 29 */
/***/ (function (module, exports) {

            // shim for using process in browser
            var process = module.exports = {};

            // cached from whatever global is present so that test runners that stub it
            // don't break things.  But we need to wrap it in a try catch in case it is
            // wrapped in strict mode code which doesn't define any globals.  It's inside a
            // function because try/catches deoptimize in certain engines.

            var cachedSetTimeout;
            var cachedClearTimeout;

            function defaultSetTimout() {
                throw new Error('setTimeout has not been defined');
            }
            function defaultClearTimeout() {
                throw new Error('clearTimeout has not been defined');
            }
            (function () {
                try {
                    if (typeof setTimeout === 'function') {
                        cachedSetTimeout = setTimeout;
                    } else {
                        cachedSetTimeout = defaultSetTimout;
                    }
                } catch (e) {
                    cachedSetTimeout = defaultSetTimout;
                }
                try {
                    if (typeof clearTimeout === 'function') {
                        cachedClearTimeout = clearTimeout;
                    } else {
                        cachedClearTimeout = defaultClearTimeout;
                    }
                } catch (e) {
                    cachedClearTimeout = defaultClearTimeout;
                }
            }())
            function runTimeout(fun) {
                if (cachedSetTimeout === setTimeout) {
                    //normal enviroments in sane situations
                    return setTimeout(fun, 0);
                }
                // if setTimeout wasn't available but was latter defined
                if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
                    cachedSetTimeout = setTimeout;
                    return setTimeout(fun, 0);
                }
                try {
                    // when when somebody has screwed with setTimeout but no I.E. maddness
                    return cachedSetTimeout(fun, 0);
                } catch (e) {
                    try {
                        // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
                        return cachedSetTimeout.call(null, fun, 0);
                    } catch (e) {
                        // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
                        return cachedSetTimeout.call(this, fun, 0);
                    }
                }


            }
            function runClearTimeout(marker) {
                if (cachedClearTimeout === clearTimeout) {
                    //normal enviroments in sane situations
                    return clearTimeout(marker);
                }
                // if clearTimeout wasn't available but was latter defined
                if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
                    cachedClearTimeout = clearTimeout;
                    return clearTimeout(marker);
                }
                try {
                    // when when somebody has screwed with setTimeout but no I.E. maddness
                    return cachedClearTimeout(marker);
                } catch (e) {
                    try {
                        // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
                        return cachedClearTimeout.call(null, marker);
                    } catch (e) {
                        // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
                        // Some versions of I.E. have different rules for clearTimeout vs setTimeout
                        return cachedClearTimeout.call(this, marker);
                    }
                }



            }
            var queue = [];
            var draining = false;
            var currentQueue;
            var queueIndex = -1;

            function cleanUpNextTick() {
                if (!draining || !currentQueue) {
                    return;
                }
                draining = false;
                if (currentQueue.length) {
                    queue = currentQueue.concat(queue);
                } else {
                    queueIndex = -1;
                }
                if (queue.length) {
                    drainQueue();
                }
            }

            function drainQueue() {
                if (draining) {
                    return;
                }
                var timeout = runTimeout(cleanUpNextTick);
                draining = true;

                var len = queue.length;
                while (len) {
                    currentQueue = queue;
                    queue = [];
                    while (++queueIndex < len) {
                        if (currentQueue) {
                            currentQueue[queueIndex].run();
                        }
                    }
                    queueIndex = -1;
                    len = queue.length;
                }
                currentQueue = null;
                draining = false;
                runClearTimeout(timeout);
            }

            process.nextTick = function (fun) {
                var args = new Array(arguments.length - 1);
                if (arguments.length > 1) {
                    for (var i = 1; i < arguments.length; i++) {
                        args[i - 1] = arguments[i];
                    }
                }
                queue.push(new Item(fun, args));
                if (queue.length === 1 && !draining) {
                    runTimeout(drainQueue);
                }
            };

            // v8 likes predictible objects
            function Item(fun, array) {
                this.fun = fun;
                this.array = array;
            }
            Item.prototype.run = function () {
                this.fun.apply(null, this.array);
            };
            process.title = 'browser';
            process.browser = true;
            process.env = {};
            process.argv = [];
            process.version = ''; // empty string to avoid regexp issues
            process.versions = {};

            function noop() { }

            process.on = noop;
            process.addListener = noop;
            process.once = noop;
            process.off = noop;
            process.removeListener = noop;
            process.removeAllListeners = noop;
            process.emit = noop;
            process.prependListener = noop;
            process.prependOnceListener = noop;

            process.listeners = function (name) { return [] }

            process.binding = function (name) {
                throw new Error('process.binding is not supported');
            };

            process.cwd = function () { return '/' };
            process.chdir = function (dir) {
                throw new Error('process.chdir is not supported');
            };
            process.umask = function () { return 0; };


            /***/
        }),
/* 30 */
/***/ (function (module, exports, __webpack_require__) {

            "use strict";
/* WEBPACK VAR INJECTION */(function (Promise) {
                Object.defineProperty(exports, "__esModule", { value: true });
                var en_1 = __webpack_require__(9);
                var common_1 = __webpack_require__(10);
                function confirm(props) {
                    props.buttonsAlignment = props.buttonsAlignment || "right";
                    var apply = props.buttons && props.buttons[1] ? props.buttons[1] : en_1.default.apply;
                    var reject = props.buttons && props.buttons[0] ? props.buttons[0] : en_1.default.reject;
                    var unblock = common_1.blockScreen(props.blockerCss);
                    return new Promise(function (res) {
                        var confirmBox = document.createElement("div");
                        confirmBox.setAttribute("role", "alertdialog");
                        confirmBox.setAttribute("aria-modal", "true");
                        props.text && confirmBox.setAttribute("aria-describedby", "dhx_alert__content");
                        props.header && confirmBox.setAttribute("aria-labelledby", "dhx_alert__header");
                        var focusItem;
                        var answer = function (val) {
                            unblock();
                            // eslint-disable-next-line @typescript-eslint/no-use-before-define
                            confirmBox.removeEventListener("click", clickHandler);
                            // eslint-disable-next-line @typescript-eslint/no-use-before-define
                            document.removeEventListener("keydown", closeConfirm);
                            document.body.removeChild(confirmBox);
                            res(val);
                        };
                        var clickHandler = function (e) {
                            if (e.target.tagName === "BUTTON") {
                                answer(e.target.classList.contains("dhx_alert__confirm-aply"));
                            }
                        };
                        var closeConfirm = function (e) {
                            if (e.key === "Escape" || e.key === "Esc") {
                                confirmBox.querySelector(".dhx_alert__confirm-aply").focus();
                                answer(e.target.classList.contains("dhx_alert__confirm-reject"));
                            }
                            else if (e.key === "Tab") {
                                if (focusItem === "aply") {
                                    focusItem = "reject";
                                    confirmBox.querySelector(".dhx_alert__confirm-reject").focus();
                                }
                                else {
                                    focusItem = "aply";
                                    confirmBox.querySelector(".dhx_alert__confirm-aply").focus();
                                }
                                e.preventDefault();
                            }
                        };
                        confirmBox.className = "dhx_widget dhx_alert dhx_alert--confirm" + (props.css ? " " + props.css : "");
                        confirmBox.innerHTML = "\n\t\t" + (props.header ? "<div class=\"dhx_alert__header\"> " + props.header + " </div>" : "") + "\n\t\t" + (props.text ? "<div class=\"dhx_alert__content\">" + props.text + "</div>" : "") + "\n\t\t\t<div class=\"dhx_alert__footer " + (props.buttonsAlignment ? "dhx_alert__footer--" + props.buttonsAlignment : "") + "\">\n\t\t\t\t<button type=\"button\" aria-label=\"reject\" class=\"dhx_alert__confirm-reject dhx_button dhx_button--view_link dhx_button--color_primary dhx_button--size_medium\">" + reject + "</button>\n\t\t\t\t<button type=\"button\"  aria-label=\"aply\"class=\"dhx_alert__confirm-aply dhx_button dhx_button--view_flat dhx_button--color_primary dhx_button--size_medium\">" + apply + "</button>\n\t\t\t</div>";
                        document.body.appendChild(confirmBox);
                        focusItem = "aply";
                        confirmBox.querySelector(".dhx_alert__confirm-aply").focus();
                        confirmBox.addEventListener("click", clickHandler);
                        document.addEventListener("keydown", closeConfirm);
                    });
                }
                exports.confirm = confirm;

                /* WEBPACK VAR INJECTION */
            }.call(this, __webpack_require__(7)))

            /***/
        }),
/* 31 */
/***/ (function (module, exports, __webpack_require__) {

            "use strict";

            var __assign = (this && this.__assign) || function () {
                __assign = Object.assign || function (t) {
                    for (var s, i = 1, n = arguments.length; i < n; i++) {
                        s = arguments[i];
                        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                            t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", { value: true });
            var html_1 = __webpack_require__(0);
            var types_1 = __webpack_require__(6);
            var DEFAULT_SHOW_DELAY = 750;
            var DEFAULT_HIDE_DELAY = 200;
            function findPosition(targetRect, position, width, height) {
                var margin = 8; // margin top/bot, left/right
                var pos;
                var left;
                var top;
                switch (position) {
                    case types_1.Position.center:
                        left = targetRect.left + window.pageXOffset + (targetRect.width - width) / 2;
                        if (left + margin < window.pageXOffset) {
                            left = targetRect.left + window.pageXOffset;
                        }
                        top = targetRect.top + window.pageYOffset + (targetRect.height - height) / 2;
                        pos = types_1.RealPosition.center;
                        return { left: left, top: top, pos: pos };
                    case types_1.Position.right:
                        pos = types_1.RealPosition.right;
                        left = targetRect.right + window.pageXOffset;
                        if (left + width + margin > window.innerWidth + window.pageXOffset) {
                            // set left
                            left = window.pageXOffset + targetRect.left - width;
                            pos = types_1.RealPosition.left;
                        }
                        top = window.pageYOffset + targetRect.top + (targetRect.height - height) / 2;
                        return { left: left, top: top, pos: pos };
                    case types_1.Position.bottom:
                    default:
                        left = window.pageXOffset + targetRect.left + (targetRect.width - width) / 2;
                        if (left + width > window.innerWidth + window.pageXOffset) {
                            left = window.innerWidth + window.pageXOffset - width;
                        }
                        else if (left < 0) {
                            left = 0;
                        }
                        pos = types_1.RealPosition.bottom;
                        top = window.pageYOffset + targetRect.bottom;
                        if (top + height + margin > window.innerHeight + window.pageYOffset) {
                            // set top
                            top = window.pageYOffset + targetRect.top - height;
                            pos = types_1.RealPosition.top;
                        }
                        return { left: left, top: top, pos: pos };
                }
            }
            exports.findPosition = findPosition;
            // tooltip init
            var tooltipBox = document.createElement("div");
            var tooltipText = document.createElement("span");
            tooltipText.className = "dhx_tooltip__text";
            tooltipBox.appendChild(tooltipText);
            tooltipBox.setAttribute("role", "tooltip");
            tooltipBox.style.position = "absolute";
            var lastNode = null;
            var isActive = false;
            var hideTimeout = null;
            var showTimeout = null;
            var activeListenersDestructor;
            function getZIndex(node) {
                if (node &&
                    node.classList.contains("dhx_popup--window") &&
                    node.classList.contains("dhx_popup--window_active")) {
                    return 2147483647;
                }
                if (node && node.classList.contains("dhx_popup--window")) {
                    return 2147483646;
                }
                if (node && node.offsetParent) {
                    return getZIndex(node.offsetParent);
                }
                return null;
            }
            exports.getZIndex = getZIndex;
            function showTooltip(node, text, position, css, force, htmlEnable) {
                if (force === void 0) { force = false; }
                var rects = node.getBoundingClientRect();
                if (htmlEnable) {
                    tooltipText.innerHTML = text;
                }
                else {
                    tooltipText.textContent = text;
                }
                document.body.appendChild(tooltipBox);
                tooltipBox.className = "dhx_widget dhx_tooltip" + (force ? " dhx_tooltip--forced" : "");
                var _a = tooltipBox.getBoundingClientRect(), width = _a.width, height = _a.height;
                var _b = findPosition(rects, position, width, height), left = _b.left, top = _b.top, pos = _b.pos;
                var zIndex = getZIndex(node);
                if (zIndex) {
                    tooltipBox.style.zIndex = zIndex.toString();
                }
                switch (pos) {
                    case types_1.RealPosition.bottom:
                        tooltipBox.style.left = left + "px";
                        tooltipBox.style.top = top + "px";
                        break;
                    case types_1.RealPosition.top:
                        tooltipBox.style.left = left + "px";
                        tooltipBox.style.top = top + "px";
                        break;
                    case types_1.RealPosition.left:
                        tooltipBox.style.left = left + "px";
                        tooltipBox.style.top = top + "px";
                        break;
                    case types_1.RealPosition.right:
                        tooltipBox.style.left = left + "px";
                        tooltipBox.style.top = top + "px";
                        break;
                    case types_1.RealPosition.center:
                        tooltipBox.style.left = left + "px";
                        tooltipBox.style.top = top + "px";
                        break;
                }
                tooltipBox.className += " dhx_tooltip--" + pos + " " + (css || "");
                isActive = true;
                if (!force) {
                    setTimeout(function () {
                        tooltipBox.className += " dhx_tooltip--animate";
                    });
                }
            }
            function hideTooltip(delay) {
                if (lastNode) {
                    hideTimeout = setTimeout(function () {
                        document.body.removeChild(tooltipBox);
                        isActive = false;
                        hideTimeout = null;
                    }, delay || DEFAULT_HIDE_DELAY);
                }
            }
            function addListeners(node, text, config) {
                var force = config.force, showDelay = config.showDelay, hideDelay = config.hideDelay, position = config.position, css = config.css, htmlEnable = config.htmlEnable;
                if (!force) {
                    showTimeout = setTimeout(function () {
                        showTooltip(node, text, position || types_1.Position.bottom, css, false, htmlEnable);
                    }, showDelay || DEFAULT_SHOW_DELAY);
                }
                var hide = function () {
                    if (isActive) {
                        hideTooltip(hideDelay);
                    }
                    clearTimeout(showTimeout);
                    node.removeEventListener("mouseleave", hide);
                    node.removeEventListener("blur", hide);
                    document.removeEventListener("mousedown", hide);
                    lastNode = null;
                    activeListenersDestructor = null;
                };
                if (force) {
                    showTooltip(node, text, position, css, force, htmlEnable);
                }
                node.addEventListener("mouseleave", hide);
                node.addEventListener("blur", hide);
                document.addEventListener("mousedown", hide);
                activeListenersDestructor = hide;
            }
            // default
            function tooltip(text, config) {
                var node = html_1.toNode(config.node);
                if (node === lastNode) {
                    return;
                }
                if (activeListenersDestructor) {
                    activeListenersDestructor();
                    activeListenersDestructor = null;
                }
                lastNode = node;
                if (hideTimeout) {
                    clearTimeout(hideTimeout);
                    hideTimeout = null;
                    addListeners(node, text, __assign(__assign({}, config), { force: true }));
                }
                else {
                    addListeners(node, text, config);
                }
            }
            exports.tooltip = tooltip;
            function _mousemove(e) {
                var node = html_1.locateNode(e, "dhx_tooltip_text");
                if (!node) {
                    return;
                }
                tooltip(node.getAttribute("dhx_tooltip_text"), {
                    position: node.getAttribute("dhx_tooltip_position") || types_1.Position.bottom,
                    node: node,
                });
            }
            function enableTooltip() {
                document.addEventListener("mousemove", _mousemove);
            }
            exports.enableTooltip = enableTooltip;
            function disableTooltip() {
                document.removeEventListener("mousemove", _mousemove);
            }
            exports.disableTooltip = disableTooltip;


            /***/
        }),
/* 32 */
/***/ (function (module, exports, __webpack_require__) {

            "use strict";

            var __extends = (this && this.__extends) || (function () {
                var extendStatics = function (d, b) {
                    extendStatics = Object.setPrototypeOf ||
                        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
                        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
                    return extendStatics(d, b);
                };
                return function (d, b) {
                    extendStatics(d, b);
                    function __() { this.constructor = d; }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            })();
            var __assign = (this && this.__assign) || function () {
                __assign = Object.assign || function (t) {
                    for (var s, i = 1, n = arguments.length; i < n; i++) {
                        s = arguments[i];
                        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                            t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", { value: true });
            var core_1 = __webpack_require__(1);
            var dom_1 = __webpack_require__(2);
            var events_1 = __webpack_require__(3);
            var html_1 = __webpack_require__(0);
            var view_1 = __webpack_require__(4);
            var types_1 = __webpack_require__(12);
            var Popup = /** @class */ (function (_super) {
                __extends(Popup, _super);
                function Popup(config) {
                    if (config === void 0) { config = {}; }
                    var _this = _super.call(this, null, core_1.extend({}, config)) || this;
                    var popup = (_this._popup = document.createElement("div"));
                    popup.className = "dhx_widget dhx_popup" + (_this.config.css ? " " + _this.config.css : "");
                    popup.style.position = "absolute";
                    popup.setAttribute("role", "dialog");
                    popup.setAttribute("aria-modal", "true");
                    popup.setAttribute("aria-live", "polite");
                    _this.mount(popup, dom_1.create({
                        render: function () { return _this.toVDOM(); },
                    }));
                    _this._clickEvent = function (e) { return _this.events.fire(types_1.PopupEvents.click, [e]); };
                    _this.events = config.events || new events_1.EventSystem(_this);
                    _this._isActive = false;
                    return _this;
                }
                Popup.prototype.show = function (node, config, attached) {
                    var _this = this;
                    if (config === void 0) { config = {}; }
                    if (!this.events.fire(types_1.PopupEvents.beforeShow, [node])) {
                        return;
                    }
                    node = html_1.toNode(node);
                    if (this._isActive) {
                        this._setPopupSize(node, config);
                        return;
                    }
                    if (attached) {
                        this.attach(attached);
                    }
                    this._popup.style.left = "0";
                    this._popup.style.top = "0";
                    dom_1.awaitRedraw()
                        .then(function () {
                            _this._setPopupSize(node, config);
                            _this._popup.style.position = "fixed";
                            document.body.appendChild(_this._popup);
                            _this._isActive = true;
                        })
                        .then(function () {
                            _this._popup.style.position = "absolute";
                            _this.events.fire(types_1.PopupEvents.afterShow, [node]);
                            _this._outerClickDestructor = _this._detectOuterClick(node);
                        });
                };
                Popup.prototype.hide = function () {
                    this._hide(false, null);
                };
                Popup.prototype.isVisible = function () {
                    return this._isActive;
                };
                Popup.prototype.attach = function (name, config) {
                    this._html = null;
                    if (typeof name === "object") {
                        this._ui = name;
                    }
                    else if (typeof name === "string") {
                        this._ui = new window.dhx[name](null, config);
                    }
                    else if (typeof name === "function") {
                        if (name.prototype instanceof view_1.View) {
                            this._ui = new name(null, config);
                        }
                        else {
                            this._ui = {
                                getRootView: function () {
                                    return name(config);
                                },
                            };
                        }
                    }
                    this.paint();
                    return this._ui;
                };
                Popup.prototype.attachHTML = function (html) {
                    this._html = html;
                    this.paint();
                };
                Popup.prototype.getWidget = function () {
                    return this._ui;
                };
                Popup.prototype.getContainer = function () {
                    return this.getRootView().refs.content.el;
                };
                Popup.prototype.toVDOM = function () {
                    var view;
                    if (this._html) {
                        view = dom_1.el(".dhx_popup__inner-html-content", {
                            ".innerHTML": this._html,
                        });
                    }
                    else {
                        view = this._ui ? this._ui.getRootView() : null;
                        if (view && view.render) {
                            view = dom_1.inject(view);
                        }
                    }
                    return dom_1.el("div", {
                        class: "dhx_popup-content",
                        onclick: this._clickEvent,
                        _key: this._uid,
                        _ref: "content",
                    }, [view]);
                };
                Popup.prototype.destructor = function () {
                    this.hide();
                    if (this._outerClickDestructor) {
                        this._outerClickDestructor();
                    }
                    this._popup = null;
                };
                Popup.prototype._setPopupSize = function (node, config, calls) {
                    var _this = this;
                    if (calls === void 0) { calls = 3; }
                    var _a = this._popup.getBoundingClientRect(), width = _a.width, height = _a.height;
                    // TODO: IE popup height = 0
                    if (this._timeout) {
                        clearTimeout(this._timeout);
                        this._timeout = null;
                    }
                    if (calls && (width === 0 || height === 0)) {
                        this._timeout = setTimeout(function () {
                            if (!_this._isActive) {
                                return;
                            }
                            _this._setPopupSize(node, config, calls - 1);
                            _this._timeout = null;
                        });
                        return;
                    }
                    var _b = html_1.fitPosition(node, __assign(__assign({ centering: true, mode: "bottom" }, config), {
                        width: width,
                        height: height
                    })), left = _b.left, top = _b.top;
                    this._popup.style.left = left;
                    this._popup.style.top = top;
                    if (config.indent && config.indent !== 0) {
                        switch (config.mode) {
                            case "top":
                                this._popup.style.top =
                                    parseInt(this._popup.style.top.slice(0, -2), null) -
                                    parseInt(config.indent.toString(), null) +
                                    "px";
                                break;
                            case "bottom":
                                this._popup.style.top =
                                    parseInt(this._popup.style.top.slice(0, -2), null) +
                                    parseInt(config.indent.toString(), null) +
                                    "px";
                                break;
                            case "left":
                                this._popup.style.left =
                                    parseInt(this._popup.style.left.slice(0, -2), null) -
                                    parseInt(config.indent.toString(), null) +
                                    "px";
                                break;
                            case "right":
                                this._popup.style.left =
                                    parseInt(this._popup.style.left.slice(0, -2), null) +
                                    parseInt(config.indent.toString(), null) +
                                    "px";
                                break;
                            default:
                                this._popup.style.top =
                                    parseInt(this._popup.style.top.slice(0, -2), null) +
                                    parseInt(config.indent.toString(), null) +
                                    "px";
                                break;
                        }
                    }
                };
                Popup.prototype._detectOuterClick = function (node) {
                    var _this = this;
                    var outerClick = function (event) {
                        var target = event.target;
                        while (target) {
                            if (target === node || target === _this._popup) {
                                return;
                            }
                            target = target.parentNode;
                        }
                        if (_this._hide(true, event)) {
                            document.removeEventListener("mousedown", outerClick);
                        }
                    };
                    document.addEventListener("mousedown", outerClick);
                    return function () { return document.removeEventListener("mousedown", outerClick); };
                };
                Popup.prototype._hide = function (fromOuterClick, e) {
                    if (this._isActive) {
                        if (!this.events.fire(types_1.PopupEvents.beforeHide, [fromOuterClick, e])) {
                            return false;
                        }
                        document.body.removeChild(this._popup);
                        this._isActive = false;
                        if (this._outerClickDestructor) {
                            this._outerClickDestructor();
                            this._outerClickDestructor = null;
                        }
                        this.events.fire(types_1.PopupEvents.afterHide, [e]);
                        return true;
                    }
                };
                return Popup;
            }(view_1.View));
            exports.Popup = Popup;


            /***/
        }),
/* 33 */
/***/ (function (module, exports, __webpack_require__) {

            /**
            * Copyright (c) 2017, Leon Sorokin
            * All rights reserved. (MIT Licensed)
            *
            * domvm.js (DOM ViewModel)
            * A thin, fast, dependency-free vdom view layer
            * @preserve https://github.com/leeoniya/domvm (v3.2.6, micro build)
            */

            (function (global, factory) {
                true ? module.exports = factory() :
                    undefined;
            }(this, (function () {
                'use strict';

                // NOTE: if adding a new *VNode* type, make it < COMMENT and renumber rest.
                // There are some places that test <= COMMENT to assert if node is a VNode

                // VNode types
                var ELEMENT = 1;
                var TEXT = 2;
                var COMMENT = 3;

                // placeholder types
                var VVIEW = 4;
                var VMODEL = 5;

                var ENV_DOM = typeof window !== "undefined";
                var win = ENV_DOM ? window : {};
                var rAF = win.requestAnimationFrame;

                var emptyObj = {};

                function noop() { }

                var isArr = Array.isArray;

                function isSet(val) {
                    return val != null;
                }

                function isPlainObj(val) {
                    return val != null && val.constructor === Object;		//  && typeof val === "object"
                }

                function insertArr(targ, arr, pos, rem) {
                    targ.splice.apply(targ, [pos, rem].concat(arr));
                }

                function isVal(val) {
                    var t = typeof val;
                    return t === "string" || t === "number";
                }

                function isFunc(val) {
                    return typeof val === "function";
                }

                function isProm(val) {
                    return typeof val === "object" && isFunc(val.then);
                }



                function assignObj(targ) {
                    var args = arguments;

                    for (var i = 1; i < args.length; i++) {
                        for (var k in args[i]) { targ[k] = args[i][k]; }
                    }

                    return targ;
                }

                // export const defProp = Object.defineProperty;

                function deepSet(targ, path, val) {
                    var seg;

                    while (seg = path.shift()) {
                        if (path.length === 0) { targ[seg] = val; }
                        else { targ[seg] = targ = targ[seg] || {}; }
                    }
                }

                /*
                export function deepUnset(targ, path) {
                    var seg;
                
                    while (seg = path.shift()) {
                        if (path.length === 0)
                            targ[seg] = val;
                        else
                            targ[seg] = targ = targ[seg] || {};
                    }
                }
                */

                function sliceArgs(args, offs) {
                    var arr = [];
                    for (var i = offs; i < args.length; i++) { arr.push(args[i]); }
                    return arr;
                }

                function cmpObj(a, b) {
                    for (var i in a) {
                        if (a[i] !== b[i]) { return false; }
                    }

                    return true;
                }

                function cmpArr(a, b) {
                    var alen = a.length;

                    if (b.length !== alen) { return false; }

                    for (var i = 0; i < alen; i++) {
                        if (a[i] !== b[i]) { return false; }
                    }

                    return true;
                }

                // https://github.com/darsain/raft
                // rAF throttler, aggregates multiple repeated redraw calls within single animframe
                function raft(fn) {
                    if (!rAF) { return fn; }

                    var id, ctx, args;

                    function call() {
                        id = 0;
                        fn.apply(ctx, args);
                    }

                    return function () {
                        ctx = this;
                        args = arguments;
                        if (!id) { id = rAF(call); }
                    };
                }

                function curry(fn, args, ctx) {
                    return function () {
                        return fn.apply(ctx, args);
                    };
                }

                /*
                export function prop(val, cb, ctx, args) {
                    return function(newVal, execCb) {
                        if (newVal !== undefined && newVal !== val) {
                            val = newVal;
                            execCb !== false && isFunc(cb) && cb.apply(ctx, args);
                        }
                
                        return val;
                    };
                }
                */

                /*
                // adapted from https://github.com/Olical/binary-search
                export function binaryKeySearch(list, item) {
                    var min = 0;
                    var max = list.length - 1;
                    var guess;
                
                    var bitwise = (max <= 2147483647) ? true : false;
                    if (bitwise) {
                        while (min <= max) {
                            guess = (min + max) >> 1;
                            if (list[guess].key === item) { return guess; }
                            else {
                                if (list[guess].key < item) { min = guess + 1; }
                                else { max = guess - 1; }
                            }
                        }
                    } else {
                        while (min <= max) {
                            guess = Math.floor((min + max) / 2);
                            if (list[guess].key === item) { return guess; }
                            else {
                                if (list[guess].key < item) { min = guess + 1; }
                                else { max = guess - 1; }
                            }
                        }
                    }
                
                    return -1;
                }
                */

                // https://en.wikipedia.org/wiki/Longest_increasing_subsequence
                // impl borrowed from https://github.com/ivijs/ivi
                function longestIncreasingSubsequence(a) {
                    var p = a.slice();
                    var result = [];
                    result.push(0);
                    var u;
                    var v;

                    for (var i = 0, il = a.length; i < il; ++i) {
                        var j = result[result.length - 1];
                        if (a[j] < a[i]) {
                            p[i] = j;
                            result.push(i);
                            continue;
                        }

                        u = 0;
                        v = result.length - 1;

                        while (u < v) {
                            var c = ((u + v) / 2) | 0;
                            if (a[result[c]] < a[i]) {
                                u = c + 1;
                            } else {
                                v = c;
                            }
                        }

                        if (a[i] < a[result[u]]) {
                            if (u > 0) {
                                p[i] = result[u - 1];
                            }
                            result[u] = i;
                        }
                    }

                    u = result.length;
                    v = result[u - 1];

                    while (u-- > 0) {
                        result[u] = v;
                        v = p[v];
                    }

                    return result;
                }

                // based on https://github.com/Olical/binary-search
                function binaryFindLarger(item, list) {
                    var min = 0;
                    var max = list.length - 1;
                    var guess;

                    var bitwise = (max <= 2147483647) ? true : false;
                    if (bitwise) {
                        while (min <= max) {
                            guess = (min + max) >> 1;
                            if (list[guess] === item) { return guess; }
                            else {
                                if (list[guess] < item) { min = guess + 1; }
                                else { max = guess - 1; }
                            }
                        }
                    } else {
                        while (min <= max) {
                            guess = Math.floor((min + max) / 2);
                            if (list[guess] === item) { return guess; }
                            else {
                                if (list[guess] < item) { min = guess + 1; }
                                else { max = guess - 1; }
                            }
                        }
                    }

                    return (min == list.length) ? null : min;

                    //	return -1;
                }

                function isEvProp(name) {
                    return name[0] === "o" && name[1] === "n";
                }

                function isSplProp(name) {
                    return name[0] === "_";
                }

                function isStyleProp(name) {
                    return name === "style";
                }

                function repaint(node) {
                    node && node.el && node.el.offsetHeight;
                }

                function isHydrated(vm) {
                    return vm.node != null && vm.node.el != null;
                }

                // tests interactive props where real val should be compared
                function isDynProp(tag, attr) {
                    //	switch (tag) {
                    //		case "input":
                    //		case "textarea":
                    //		case "select":
                    //		case "option":
                    switch (attr) {
                        case "value":
                        case "checked":
                        case "selected":
                            //				case "selectedIndex":
                            return true;
                    }
                    //	}

                    return false;
                }

                function getVm(n) {
                    n = n || emptyObj;
                    while (n.vm == null && n.parent) { n = n.parent; }
                    return n.vm;
                }

                function VNode() { }

                var VNodeProto = VNode.prototype = {
                    constructor: VNode,

                    type: null,

                    vm: null,

                    // all this stuff can just live in attrs (as defined) just have getters here for it
                    key: null,
                    ref: null,
                    data: null,
                    hooks: null,
                    ns: null,

                    el: null,

                    tag: null,
                    attrs: null,
                    body: null,

                    flags: 0,

                    _class: null,
                    _diff: null,

                    // pending removal on promise resolution
                    _dead: false,
                    // part of longest increasing subsequence?
                    _lis: false,

                    idx: null,
                    parent: null,

                    /*
                    // break out into optional fluent module
                    key:	function(val) { this.key	= val; return this; },
                    ref:	function(val) { this.ref	= val; return this; },		// deep refs
                    data:	function(val) { this.data	= val; return this; },
                    hooks:	function(val) { this.hooks	= val; return this; },		// h("div").hooks()
                    html:	function(val) { this.html	= true; return this.body(val); },
                
                    body:	function(val) { this.body	= val; return this; },
                    */
                };

                function defineText(body) {
                    var node = new VNode;
                    node.type = TEXT;
                    node.body = body;
                    return node;
                }

                // creates a one-shot self-ending stream that redraws target vm
                // TODO: if it's already registered by any parent vm, then ignore to avoid simultaneous parent & child refresh

                var tagCache = {};

                var RE_ATTRS = /\[(\w+)(?:=(\w+))?\]/g;

                function cssTag(raw) {
                    {
                        var cached = tagCache[raw];

                        if (cached == null) {
                            var tag, id, cls, attr;

                            tagCache[raw] = cached = {
                                tag: (tag = raw.match(/^[-\w]+/)) ? tag[0] : "div",
                                id: (id = raw.match(/#([-\w]+)/)) ? id[1] : null,
                                class: (cls = raw.match(/\.([-\w.]+)/)) ? cls[1].replace(/\./g, " ") : null,
                                attrs: null,
                            };

                            while (attr = RE_ATTRS.exec(raw)) {
                                if (cached.attrs == null) { cached.attrs = {}; }
                                cached.attrs[attr[1]] = attr[2] || "";
                            }
                        }

                        return cached;
                    }
                }

                // (de)optimization flags

                // forces slow bottom-up removeChild to fire deep willRemove/willUnmount hooks,
                var DEEP_REMOVE = 1;
                // prevents inserting/removing/reordering of children
                var FIXED_BODY = 2;
                // enables fast keyed lookup of children via binary search, expects homogeneous keyed body
                var KEYED_LIST = 4;
                // indicates an vnode match/diff/recycler function for body
                var LAZY_LIST = 8;

                function initElementNode(tag, attrs, body, flags) {
                    var node = new VNode;

                    node.type = ELEMENT;

                    if (isSet(flags)) { node.flags = flags; }

                    node.attrs = attrs;

                    var parsed = cssTag(tag);

                    node.tag = parsed.tag;

                    // meh, weak assertion, will fail for id=0, etc.
                    if (parsed.id || parsed.class || parsed.attrs) {
                        var p = node.attrs || {};

                        if (parsed.id && !isSet(p.id)) { p.id = parsed.id; }

                        if (parsed.class) {
                            node._class = parsed.class;		// static class
                            p.class = parsed.class + (isSet(p.class) ? (" " + p.class) : "");
                        }
                        if (parsed.attrs) {
                            for (var key in parsed.attrs) {
                                if (!isSet(p[key])) { p[key] = parsed.attrs[key]; }
                            }
                        }

                        //		if (node.attrs !== p)
                        node.attrs = p;
                    }

                    var mergedAttrs = node.attrs;

                    if (isSet(mergedAttrs)) {
                        if (isSet(mergedAttrs._key)) { node.key = mergedAttrs._key; }

                        if (isSet(mergedAttrs._ref)) { node.ref = mergedAttrs._ref; }

                        if (isSet(mergedAttrs._hooks)) { node.hooks = mergedAttrs._hooks; }

                        if (isSet(mergedAttrs._data)) { node.data = mergedAttrs._data; }

                        if (isSet(mergedAttrs._flags)) { node.flags = mergedAttrs._flags; }

                        if (!isSet(node.key)) {
                            if (isSet(node.ref)) { node.key = node.ref; }
                            else if (isSet(mergedAttrs.id)) { node.key = mergedAttrs.id; }
                            else if (isSet(mergedAttrs.name)) { node.key = mergedAttrs.name + (mergedAttrs.type === "radio" || mergedAttrs.type === "checkbox" ? mergedAttrs.value : ""); }
                        }
                    }

                    if (body != null) { node.body = body; }

                    return node;
                }

                function setRef(vm, name, node) {
                    var path = ["refs"].concat(name.split("."));
                    deepSet(vm, path, node);
                }

                function setDeepRemove(node) {
                    while (node = node.parent) { node.flags |= DEEP_REMOVE; }
                }

                // vnew, vold
                function preProc(vnew, parent, idx, ownVm) {
                    if (vnew.type === VMODEL || vnew.type === VVIEW) { return; }

                    vnew.parent = parent;
                    vnew.idx = idx;
                    vnew.vm = ownVm;

                    if (vnew.ref != null) { setRef(getVm(vnew), vnew.ref, vnew); }

                    var nh = vnew.hooks,
                        vh = ownVm && ownVm.hooks;

                    if (nh && (nh.willRemove || nh.didRemove) ||
                        vh && (vh.willUnmount || vh.didUnmount)) { setDeepRemove(vnew); }

                    if (isArr(vnew.body)) { preProcBody(vnew); }
                    else { }
                }

                function preProcBody(vnew) {
                    var body = vnew.body;

                    for (var i = 0; i < body.length; i++) {
                        var node2 = body[i];

                        // remove false/null/undefined
                        if (node2 === false || node2 == null) { body.splice(i--, 1); }
                        // flatten arrays
                        else if (isArr(node2)) {
                            insertArr(body, node2, i--, 1);
                        }
                        else {
                            if (node2.type == null) { body[i] = node2 = defineText("" + node2); }

                            if (node2.type === TEXT) {
                                // remove empty text nodes
                                if (node2.body == null || node2.body === "") { body.splice(i--, 1); }
                                // merge with previous text node
                                else if (i > 0 && body[i - 1].type === TEXT) {
                                    body[i - 1].body += node2.body;
                                    body.splice(i--, 1);
                                }
                                else { preProc(node2, vnew, i, null); }
                            }
                            else { preProc(node2, vnew, i, null); }
                        }
                    }
                }

                var unitlessProps = {
                    animationIterationCount: true,
                    boxFlex: true,
                    boxFlexGroup: true,
                    boxOrdinalGroup: true,
                    columnCount: true,
                    flex: true,
                    flexGrow: true,
                    flexPositive: true,
                    flexShrink: true,
                    flexNegative: true,
                    flexOrder: true,
                    gridRow: true,
                    gridColumn: true,
                    order: true,
                    lineClamp: true,

                    borderImageOutset: true,
                    borderImageSlice: true,
                    borderImageWidth: true,
                    fontWeight: true,
                    lineHeight: true,
                    opacity: true,
                    orphans: true,
                    tabSize: true,
                    widows: true,
                    zIndex: true,
                    zoom: true,

                    fillOpacity: true,
                    floodOpacity: true,
                    stopOpacity: true,
                    strokeDasharray: true,
                    strokeDashoffset: true,
                    strokeMiterlimit: true,
                    strokeOpacity: true,
                    strokeWidth: true
                };

                function autoPx(name, val) {
                    {
                        // typeof val === 'number' is faster but fails for numeric strings
                        return !isNaN(val) && !unitlessProps[name] ? (val + "px") : val;
                    }
                }

                // assumes if styles exist both are objects or both are strings
                function patchStyle(n, o) {
                    var ns = (n.attrs || emptyObj).style;
                    var os = o ? (o.attrs || emptyObj).style : null;

                    // replace or remove in full
                    if (ns == null || isVal(ns)) { n.el.style.cssText = ns; }
                    else {
                        for (var nn in ns) {
                            var nv = ns[nn];

                            if (os == null || nv != null && nv !== os[nn]) { n.el.style[nn] = autoPx(nn, nv); }
                        }

                        // clean old
                        if (os) {
                            for (var on in os) {
                                if (ns[on] == null) { n.el.style[on] = ""; }
                            }
                        }
                    }
                }

                var didQueue = [];

                function fireHook(hooks, name, o, n, immediate) {
                    if (hooks != null) {
                        var fn = o.hooks[name];

                        if (fn) {
                            if (name[0] === "d" && name[1] === "i" && name[2] === "d") {	// did*
                                //	console.log(name + " should queue till repaint", o, n);
                                immediate ? repaint(o.parent) && fn(o, n) : didQueue.push([fn, o, n]);
                            }
                            else {		// will*
                                //	console.log(name + " may delay by promise", o, n);
                                return fn(o, n);		// or pass  done() resolver
                            }
                        }
                    }
                }

                function drainDidHooks(vm) {
                    if (didQueue.length) {
                        repaint(vm.node);

                        var item;
                        while (item = didQueue.shift()) { item[0](item[1], item[2]); }
                    }
                }

                var doc = ENV_DOM ? document : null;

                function closestVNode(el) {
                    while (el._node == null) { el = el.parentNode; }
                    return el._node;
                }

                function createElement(tag, ns) {
                    if (ns != null) { return doc.createElementNS(ns, tag); }
                    return doc.createElement(tag);
                }

                function createTextNode(body) {
                    return doc.createTextNode(body);
                }

                function createComment(body) {
                    return doc.createComment(body);
                }

                // ? removes if !recycled
                function nextSib(sib) {
                    return sib.nextSibling;
                }

                // ? removes if !recycled
                function prevSib(sib) {
                    return sib.previousSibling;
                }

                // TODO: this should collect all deep proms from all hooks and return Promise.all()
                function deepNotifyRemove(node) {
                    var vm = node.vm;

                    var wuRes = vm != null && fireHook(vm.hooks, "willUnmount", vm, vm.data);

                    var wrRes = fireHook(node.hooks, "willRemove", node);

                    if ((node.flags & DEEP_REMOVE) === DEEP_REMOVE && isArr(node.body)) {
                        for (var i = 0; i < node.body.length; i++) { deepNotifyRemove(node.body[i]); }
                    }

                    return wuRes || wrRes;
                }

                function _removeChild(parEl, el, immediate) {
                    var node = el._node, vm = node.vm;

                    if (isArr(node.body)) {
                        if ((node.flags & DEEP_REMOVE) === DEEP_REMOVE) {
                            for (var i = 0; i < node.body.length; i++) { _removeChild(el, node.body[i].el); }
                        }
                        else { deepUnref(node); }
                    }

                    delete el._node;

                    parEl.removeChild(el);

                    fireHook(node.hooks, "didRemove", node, null, immediate);

                    if (vm != null) {
                        fireHook(vm.hooks, "didUnmount", vm, vm.data, immediate);
                        vm.node = null;
                    }
                }

                // todo: should delay parent unmount() by returning res prom?
                function removeChild(parEl, el) {
                    var node = el._node;

                    // already marked for removal
                    if (node._dead) { return; }

                    var res = deepNotifyRemove(node);

                    if (res != null && isProm(res)) {
                        node._dead = true;
                        res.then(curry(_removeChild, [parEl, el, true]));
                    }
                    else { _removeChild(parEl, el); }
                }

                function deepUnref(node) {
                    var obody = node.body;

                    for (var i = 0; i < obody.length; i++) {
                        var o2 = obody[i];
                        delete o2.el._node;

                        if (o2.vm != null) { o2.vm.node = null; }

                        if (isArr(o2.body)) { deepUnref(o2); }
                    }
                }

                function clearChildren(parent) {
                    var parEl = parent.el;

                    if ((parent.flags & DEEP_REMOVE) === 0) {
                        isArr(parent.body) && deepUnref(parent);
                        parEl.textContent = null;
                    }
                    else {
                        var el = parEl.firstChild;

                        do {
                            var next = nextSib(el);
                            removeChild(parEl, el);
                        } while (el = next);
                    }
                }

                // todo: hooks
                function insertBefore(parEl, el, refEl) {
                    var node = el._node, inDom = el.parentNode != null;

                    // el === refEl is asserted as a no-op insert called to fire hooks
                    var vm = (el === refEl || !inDom) ? node.vm : null;

                    if (vm != null) { fireHook(vm.hooks, "willMount", vm, vm.data); }

                    fireHook(node.hooks, inDom ? "willReinsert" : "willInsert", node);
                    parEl.insertBefore(el, refEl);
                    fireHook(node.hooks, inDom ? "didReinsert" : "didInsert", node);

                    if (vm != null) { fireHook(vm.hooks, "didMount", vm, vm.data); }
                }

                function insertAfter(parEl, el, refEl) {
                    insertBefore(parEl, el, refEl ? nextSib(refEl) : null);
                }

                var onemit = {};

                function emitCfg(cfg) {
                    assignObj(onemit, cfg);
                }

                function emit(evName) {
                    var targ = this,
                        src = targ;

                    var args = sliceArgs(arguments, 1).concat(src, src.data);

                    do {
                        var evs = targ.onemit;
                        var fn = evs ? evs[evName] : null;

                        if (fn) {
                            fn.apply(targ, args);
                            break;
                        }
                    } while (targ = targ.parent());

                    if (onemit[evName]) { onemit[evName].apply(targ, args); }
                }

                var onevent = noop;

                function config(newCfg) {
                    onevent = newCfg.onevent || onevent;

                    {
                        if (newCfg.onemit) { emitCfg(newCfg.onemit); }
                    }


                }

                function bindEv(el, type, fn) {
                    el[type] = fn;
                }

                function exec(fn, args, e, node, vm) {
                    var out = fn.apply(vm, args.concat([e, node, vm, vm.data]));

                    // should these respect out === false?
                    vm.onevent(e, node, vm, vm.data, args);
                    onevent.call(null, e, node, vm, vm.data, args);

                    if (out === false) {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                }

                function handle(e) {
                    var node = closestVNode(e.target);
                    var vm = getVm(node);

                    var evDef = e.currentTarget._node.attrs["on" + e.type], fn, args;

                    if (isArr(evDef)) {
                        fn = evDef[0];
                        args = evDef.slice(1);
                        exec(fn, args, e, node, vm);
                    }
                    else {
                        for (var sel in evDef) {
                            if (e.target.matches(sel)) {
                                var evDef2 = evDef[sel];

                                if (isArr(evDef2)) {
                                    fn = evDef2[0];
                                    args = evDef2.slice(1);
                                }
                                else {
                                    fn = evDef2;
                                    args = [];
                                }

                                exec(fn, args, e, node, vm);
                            }
                        }
                    }
                }

                function patchEvent(node, name, nval, oval) {
                    if (nval === oval) { return; }

                    var el = node.el;

                    if (nval == null || isFunc(nval)) { bindEv(el, name, nval); }
                    else if (oval == null) { bindEv(el, name, handle); }
                }

                function remAttr(node, name, asProp) {
                    if (name[0] === ".") {
                        name = name.substr(1);
                        asProp = true;
                    }

                    if (asProp) { node.el[name] = ""; }
                    else { node.el.removeAttribute(name); }
                }

                // setAttr
                // diff, ".", "on*", bool vals, skip _*, value/checked/selected selectedIndex
                function setAttr(node, name, val, asProp, initial) {
                    var el = node.el;

                    if (val == null) { !initial && remAttr(node, name, false); }		// will also removeAttr of style: null
                    else if (node.ns != null) { el.setAttribute(name, val); }
                    else if (name === "class") { el.className = val; }
                    else if (name === "id" || typeof val === "boolean" || asProp) { el[name] = val; }
                    else if (name[0] === ".") { el[name.substr(1)] = val; }
                    else { el.setAttribute(name, val); }
                }

                function patchAttrs(vnode, donor, initial) {
                    var nattrs = vnode.attrs || emptyObj;
                    var oattrs = donor.attrs || emptyObj;

                    if (nattrs === oattrs) {

                    }
                    else {
                        for (var key in nattrs) {
                            var nval = nattrs[key];
                            var isDyn = isDynProp(vnode.tag, key);
                            var oval = isDyn ? vnode.el[key] : oattrs[key];

                            if (nval === oval) { }
                            else if (isStyleProp(key)) { patchStyle(vnode, donor); }
                            else if (isSplProp(key)) { }
                            else if (isEvProp(key)) { patchEvent(vnode, key, nval, oval); }
                            else { setAttr(vnode, key, nval, isDyn, initial); }
                        }

                        // TODO: bench style.cssText = "" vs removeAttribute("style")
                        for (var key in oattrs) {
                            !(key in nattrs) &&
                                !isSplProp(key) &&
                                remAttr(vnode, key, isDynProp(vnode.tag, key) || isEvProp(key));
                        }
                    }
                }

                function createView(view, data, key, opts) {
                    if (view.type === VVIEW) {
                        data = view.data;
                        key = view.key;
                        opts = view.opts;
                        view = view.view;
                    }

                    return new ViewModel(view, data, key, opts);
                }

                //import { XML_NS, XLINK_NS } from './defineSvgElement';
                function hydrateBody(vnode) {
                    for (var i = 0; i < vnode.body.length; i++) {
                        var vnode2 = vnode.body[i];
                        var type2 = vnode2.type;

                        // ELEMENT,TEXT,COMMENT
                        if (type2 <= COMMENT) { insertBefore(vnode.el, hydrate(vnode2)); }		// vnode.el.appendChild(hydrate(vnode2))
                        else if (type2 === VVIEW) {
                            var vm = createView(vnode2.view, vnode2.data, vnode2.key, vnode2.opts)._redraw(vnode, i, false);		// todo: handle new data updates
                            type2 = vm.node.type;
                            insertBefore(vnode.el, hydrate(vm.node));
                        }
                        else if (type2 === VMODEL) {
                            var vm = vnode2.vm;
                            vm._redraw(vnode, i);					// , false
                            type2 = vm.node.type;
                            insertBefore(vnode.el, vm.node.el);		// , hydrate(vm.node)
                        }
                    }
                }

                //  TODO: DRY this out. reusing normal patch here negatively affects V8's JIT
                function hydrate(vnode, withEl) {
                    if (vnode.el == null) {
                        if (vnode.type === ELEMENT) {
                            vnode.el = withEl || createElement(vnode.tag, vnode.ns);

                            //	if (vnode.tag === "svg")
                            //		vnode.el.setAttributeNS(XML_NS, 'xmlns:xlink', XLINK_NS);

                            if (vnode.attrs != null) { patchAttrs(vnode, emptyObj, true); }

                            if ((vnode.flags & LAZY_LIST) === LAZY_LIST)	// vnode.body instanceof LazyList
                            { vnode.body.body(vnode); }

                            if (isArr(vnode.body)) { hydrateBody(vnode); }
                            else if (vnode.body != null && vnode.body !== "") { vnode.el.textContent = vnode.body; }
                        }
                        else if (vnode.type === TEXT) { vnode.el = withEl || createTextNode(vnode.body); }
                        else if (vnode.type === COMMENT) { vnode.el = withEl || createComment(vnode.body); }
                    }

                    vnode.el._node = vnode;

                    return vnode.el;
                }

                // prevent GCC from inlining some large funcs (which negatively affects Chrome's JIT)
                //window.syncChildren = syncChildren;
                window.lisMove = lisMove;

                function nextNode(node, body) {
                    return body[node.idx + 1];
                }

                function prevNode(node, body) {
                    return body[node.idx - 1];
                }

                function parentNode(node) {
                    return node.parent;
                }

                var BREAK = 1;
                var BREAK_ALL = 2;

                function syncDir(advSib, advNode, insert, sibName, nodeName, invSibName, invNodeName, invInsert) {
                    return function (node, parEl, body, state, convTest, lis) {
                        var sibNode, tmpSib;

                        if (state[sibName] != null) {
                            // skip dom elements not created by domvm
                            if ((sibNode = state[sibName]._node) == null) {
                                state[sibName] = advSib(state[sibName]);
                                return;
                            }

                            if (parentNode(sibNode) !== node) {
                                tmpSib = advSib(state[sibName]);
                                sibNode.vm != null ? sibNode.vm.unmount(true) : removeChild(parEl, state[sibName]);
                                state[sibName] = tmpSib;
                                return;
                            }
                        }

                        if (state[nodeName] == convTest) { return BREAK_ALL; }
                        else if (state[nodeName].el == null) {
                            insert(parEl, hydrate(state[nodeName]), state[sibName]);	// should lis be updated here?
                            state[nodeName] = advNode(state[nodeName], body);		// also need to advance sib?
                        }
                        else if (state[nodeName].el === state[sibName]) {
                            state[nodeName] = advNode(state[nodeName], body);
                            state[sibName] = advSib(state[sibName]);
                        }
                        // head->tail or tail->head
                        else if (!lis && sibNode === state[invNodeName]) {
                            tmpSib = state[sibName];
                            state[sibName] = advSib(tmpSib);
                            invInsert(parEl, tmpSib, state[invSibName]);
                            state[invSibName] = tmpSib;
                        }
                        else {
                            if (lis && state[sibName] != null) { return lisMove(advSib, advNode, insert, sibName, nodeName, parEl, body, sibNode, state); }

                            return BREAK;
                        }
                    };
                }

                function lisMove(advSib, advNode, insert, sibName, nodeName, parEl, body, sibNode, state) {
                    if (sibNode._lis) {
                        insert(parEl, state[nodeName].el, state[sibName]);
                        state[nodeName] = advNode(state[nodeName], body);
                    }
                    else {
                        // find closest tomb
                        var t = binaryFindLarger(sibNode.idx, state.tombs);
                        sibNode._lis = true;
                        var tmpSib = advSib(state[sibName]);
                        insert(parEl, state[sibName], t != null ? body[state.tombs[t]].el : t);

                        if (t == null) { state.tombs.push(sibNode.idx); }
                        else { state.tombs.splice(t, 0, sibNode.idx); }

                        state[sibName] = tmpSib;
                    }
                }

                var syncLft = syncDir(nextSib, nextNode, insertBefore, "lftSib", "lftNode", "rgtSib", "rgtNode", insertAfter);
                var syncRgt = syncDir(prevSib, prevNode, insertAfter, "rgtSib", "rgtNode", "lftSib", "lftNode", insertBefore);

                function syncChildren(node, donor) {
                    var obody = donor.body,
                        parEl = node.el,
                        body = node.body,
                        state = {
                            lftNode: body[0],
                            rgtNode: body[body.length - 1],
                            lftSib: ((obody)[0] || emptyObj).el,
                            rgtSib: (obody[obody.length - 1] || emptyObj).el,
                        };

                    converge:
                    while (1) {
                        //		from_left:
                        while (1) {
                            var l = syncLft(node, parEl, body, state, null, false);
                            if (l === BREAK) { break; }
                            if (l === BREAK_ALL) { break converge; }
                        }

                        //		from_right:
                        while (1) {
                            var r = syncRgt(node, parEl, body, state, state.lftNode, false);
                            if (r === BREAK) { break; }
                            if (r === BREAK_ALL) { break converge; }
                        }

                        sortDOM(node, parEl, body, state);
                        break;
                    }
                }

                // TODO: also use the state.rgtSib and state.rgtNode bounds, plus reduce LIS range
                function sortDOM(node, parEl, body, state) {
                    var kids = Array.prototype.slice.call(parEl.childNodes);
                    var domIdxs = [];

                    for (var k = 0; k < kids.length; k++) {
                        var n = kids[k]._node;

                        if (n.parent === node) { domIdxs.push(n.idx); }
                    }

                    // list of non-movable vnode indices (already in correct order in old dom)
                    var tombs = longestIncreasingSubsequence(domIdxs).map(function (i) { return domIdxs[i]; });

                    for (var i = 0; i < tombs.length; i++) { body[tombs[i]]._lis = true; }

                    state.tombs = tombs;

                    while (1) {
                        var r = syncLft(node, parEl, body, state, null, true);
                        if (r === BREAK_ALL) { break; }
                    }
                }

                function alreadyAdopted(vnode) {
                    return vnode.el._node.parent !== vnode.parent;
                }

                function takeSeqIndex(n, obody, fromIdx) {
                    return obody[fromIdx];
                }

                function findSeqThorough(n, obody, fromIdx) {		// pre-tested isView?
                    for (; fromIdx < obody.length; fromIdx++) {
                        var o = obody[fromIdx];

                        if (o.vm != null) {
                            // match by key & viewFn || vm
                            if (n.type === VVIEW && o.vm.view === n.view && o.vm.key === n.key || n.type === VMODEL && o.vm === n.vm) { return o; }
                        }
                        else if (!alreadyAdopted(o) && n.tag === o.tag && n.type === o.type && n.key === o.key && (n.flags & ~DEEP_REMOVE) === (o.flags & ~DEEP_REMOVE)) { return o; }
                    }

                    return null;
                }

                function findHashKeyed(n, obody, fromIdx) {
                    return obody[obody._keys[n.key]];
                }

                /*
                // list must be a sorted list of vnodes by key
                function findBinKeyed(n, list) {
                    var idx = binaryKeySearch(list, n.key);
                    return idx > -1 ? list[idx] : null;
                }
                */

                // have it handle initial hydrate? !donor?
                // types (and tags if ELEM) are assumed the same, and donor exists
                function patch(vnode, donor) {
                    fireHook(donor.hooks, "willRecycle", donor, vnode);

                    var el = vnode.el = donor.el;

                    var obody = donor.body;
                    var nbody = vnode.body;

                    el._node = vnode;

                    // "" => ""
                    if (vnode.type === TEXT && nbody !== obody) {
                        el.nodeValue = nbody;
                        return;
                    }

                    if (vnode.attrs != null || donor.attrs != null) { patchAttrs(vnode, donor, false); }

                    // patch events

                    var oldIsArr = isArr(obody);
                    var newIsArr = isArr(nbody);
                    var lazyList = (vnode.flags & LAZY_LIST) === LAZY_LIST;

                    //	var nonEqNewBody = nbody != null && nbody !== obody;

                    if (oldIsArr) {
                        // [] => []
                        if (newIsArr || lazyList) { patchChildren(vnode, donor); }
                        // [] => "" | null
                        else if (nbody !== obody) {
                            if (nbody != null) { el.textContent = nbody; }
                            else { clearChildren(donor); }
                        }
                    }
                    else {
                        // "" | null => []
                        if (newIsArr) {
                            clearChildren(donor);
                            hydrateBody(vnode);
                        }
                        // "" | null => "" | null
                        else if (nbody !== obody) {
                            if (el.firstChild) { el.firstChild.nodeValue = nbody; }
                            else { el.textContent = nbody; }
                        }
                    }

                    fireHook(donor.hooks, "didRecycle", donor, vnode);
                }

                // larger qtys of KEYED_LIST children will use binary search
                //const SEQ_FAILS_MAX = 100;

                // TODO: modify vtree matcher to work similar to dom reconciler for keyed from left -> from right -> head/tail -> binary
                // fall back to binary if after failing nri - nli > SEQ_FAILS_MAX
                // while-advance non-keyed fromIdx
                // [] => []
                function patchChildren(vnode, donor) {
                    var nbody = vnode.body,
                        nlen = nbody.length,
                        obody = donor.body,
                        olen = obody.length,
                        isLazy = (vnode.flags & LAZY_LIST) === LAZY_LIST,
                        isFixed = (vnode.flags & FIXED_BODY) === FIXED_BODY,
                        isKeyed = (vnode.flags & KEYED_LIST) === KEYED_LIST,
                        domSync = !isFixed && vnode.type === ELEMENT,
                        doFind = true,
                        find = (
                            isKeyed ? findHashKeyed :				// keyed lists/lazyLists
                                isFixed || isLazy ? takeSeqIndex :		// unkeyed lazyLists and FIXED_BODY
                                    findSeqThorough							// more complex stuff
                        );

                    if (isKeyed) {
                        var keys = {};
                        for (var i = 0; i < obody.length; i++) { keys[obody[i].key] = i; }
                        obody._keys = keys;
                    }

                    if (domSync && nlen === 0) {
                        clearChildren(donor);
                        if (isLazy) { vnode.body = []; }	// nbody.tpl(all);
                        return;
                    }

                    var donor2,
                        node2,
                        foundIdx,
                        patched = 0,
                        everNonseq = false,
                        fromIdx = 0;		// first unrecycled node (search head)

                    if (isLazy) {
                        var fnode2 = { key: null };
                        var nbodyNew = Array(nlen);
                    }

                    for (var i = 0; i < nlen; i++) {
                        if (isLazy) {
                            var remake = false;
                            var diffRes = null;

                            if (doFind) {
                                if (isKeyed) { fnode2.key = nbody.key(i); }

                                donor2 = find(fnode2, obody, fromIdx);
                            }

                            if (donor2 != null) {
                                foundIdx = donor2.idx;
                                diffRes = nbody.diff(i, donor2);

                                // diff returns same, so cheaply adopt vnode without patching
                                if (diffRes === true) {
                                    node2 = donor2;
                                    node2.parent = vnode;
                                    node2.idx = i;
                                    node2._lis = false;
                                }
                                // diff returns new diffVals, so generate new vnode & patch
                                else { remake = true; }
                            }
                            else { remake = true; }

                            if (remake) {
                                node2 = nbody.tpl(i);			// what if this is a VVIEW, VMODEL, injected element?
                                preProc(node2, vnode, i);

                                node2._diff = diffRes != null ? diffRes : nbody.diff(i);

                                if (donor2 != null) { patch(node2, donor2); }
                            }
                            else {
                                // TODO: flag tmp FIXED_BODY on unchanged nodes?

                                // domSync = true;		if any idx changes or new nodes added/removed
                            }

                            nbodyNew[i] = node2;
                        }
                        else {
                            var node2 = nbody[i];
                            var type2 = node2.type;

                            // ELEMENT,TEXT,COMMENT
                            if (type2 <= COMMENT) {
                                if (donor2 = doFind && find(node2, obody, fromIdx)) {
                                    patch(node2, donor2);
                                    foundIdx = donor2.idx;
                                }
                            }
                            else if (type2 === VVIEW) {
                                if (donor2 = doFind && find(node2, obody, fromIdx)) {		// update/moveTo
                                    foundIdx = donor2.idx;
                                    var vm = donor2.vm._update(node2.data, vnode, i);		// withDOM
                                }
                                else { var vm = createView(node2.view, node2.data, node2.key, node2.opts)._redraw(vnode, i, false); }	// createView, no dom (will be handled by sync below)

                                type2 = vm.node.type;
                            }
                            else if (type2 === VMODEL) {
                                // if the injected vm has never been rendered, this vm._update() serves as the
                                // initial vtree creator, but must avoid hydrating (creating .el) because syncChildren()
                                // which is responsible for mounting below (and optionally hydrating), tests .el presence
                                // to determine if hydration & mounting are needed
                                var withDOM = isHydrated(node2.vm);

                                var vm = node2.vm._update(node2.data, vnode, i, withDOM);
                                type2 = vm.node.type;
                            }
                        }

                        // found donor & during a sequential search ...at search head
                        if (!isKeyed && donor2 != null) {
                            if (foundIdx === fromIdx) {
                                // advance head
                                fromIdx++;
                                // if all old vnodes adopted and more exist, stop searching
                                if (fromIdx === olen && nlen > olen) {
                                    // short-circuit find, allow loop just create/init rest
                                    donor2 = null;
                                    doFind = false;
                                }
                            }
                            else { everNonseq = true; }

                            if (olen > 100 && everNonseq && ++patched % 10 === 0) {
                                while (fromIdx < olen && alreadyAdopted(obody[fromIdx])) { fromIdx++; }
                            }
                        }
                    }

                    // replace List w/ new body
                    if (isLazy) { vnode.body = nbodyNew; }

                    domSync && syncChildren(vnode, donor);
                }

                // view + key serve as the vm's unique identity
                function ViewModel(view, data, key, opts) {
                    var vm = this;

                    vm.view = view;
                    vm.data = data;
                    vm.key = key;

                    if (opts) {
                        vm.opts = opts;
                        vm.config(opts);
                    }

                    var out = isPlainObj(view) ? view : view.call(vm, vm, data, key, opts);

                    if (isFunc(out)) { vm.render = out; }
                    else {
                        vm.render = out.render;
                        vm.config(out);
                    }

                    // these must be wrapped here since they're debounced per view
                    vm._redrawAsync = raft(function (_) { return vm.redraw(true); });
                    vm._updateAsync = raft(function (newData) { return vm.update(newData, true); });

                    vm.init && vm.init.call(vm, vm, vm.data, vm.key, opts);
                }

                var ViewModelProto = ViewModel.prototype = {
                    constructor: ViewModel,

                    _diff: null,	// diff cache

                    init: null,
                    view: null,
                    key: null,
                    data: null,
                    state: null,
                    api: null,
                    opts: null,
                    node: null,
                    hooks: null,
                    onevent: noop,
                    refs: null,
                    render: null,

                    mount: mount,
                    unmount: unmount,
                    config: function (opts) {
                        var t = this;

                        if (opts.init) { t.init = opts.init; }
                        if (opts.diff) { t.diff = opts.diff; }
                        if (opts.onevent) { t.onevent = opts.onevent; }

                        // maybe invert assignment order?
                        if (opts.hooks) { t.hooks = assignObj(t.hooks || {}, opts.hooks); }

                        {
                            if (opts.onemit) { t.onemit = assignObj(t.onemit || {}, opts.onemit); }
                        }
                    },
                    parent: function () {
                        return getVm(this.node.parent);
                    },
                    root: function () {
                        var p = this.node;

                        while (p.parent) { p = p.parent; }

                        return p.vm;
                    },
                    redraw: function (sync) {
                        var vm = this;
                        sync ? vm._redraw(null, null, isHydrated(vm)) : vm._redrawAsync();
                        return vm;
                    },
                    update: function (newData, sync) {
                        var vm = this;
                        sync ? vm._update(newData, null, null, isHydrated(vm)) : vm._updateAsync(newData);
                        return vm;
                    },

                    _update: updateSync,
                    _redraw: redrawSync,
                    _redrawAsync: null,
                    _updateAsync: null,
                };

                function mount(el, isRoot) {
                    var vm = this;

                    if (isRoot) {
                        clearChildren({ el: el, flags: 0 });

                        vm._redraw(null, null, false);

                        // if placeholder node doesnt match root tag
                        if (el.nodeName.toLowerCase() !== vm.node.tag) {
                            hydrate(vm.node);
                            insertBefore(el.parentNode, vm.node.el, el);
                            el.parentNode.removeChild(el);
                        }
                        else { insertBefore(el.parentNode, hydrate(vm.node, el), el); }
                    }
                    else {
                        vm._redraw(null, null);

                        if (el) { insertBefore(el, vm.node.el); }
                    }

                    if (el) { drainDidHooks(vm); }

                    return vm;
                }

                // asSub means this was called from a sub-routine, so don't drain did* hook queue
                function unmount(asSub) {
                    var vm = this;

                    var node = vm.node;
                    var parEl = node.el.parentNode;

                    // edge bug: this could also be willRemove promise-delayed; should .then() or something to make sure hooks fire in order
                    removeChild(parEl, node.el);

                    if (!asSub) { drainDidHooks(vm); }
                }

                function reParent(vm, vold, newParent, newIdx) {
                    if (newParent != null) {
                        newParent.body[newIdx] = vold;
                        vold.idx = newIdx;
                        vold.parent = newParent;
                        vold._lis = false;
                    }
                    return vm;
                }

                function redrawSync(newParent, newIdx, withDOM) {
                    var isRedrawRoot = newParent == null;
                    var vm = this;
                    var isMounted = vm.node && vm.node.el && vm.node.el.parentNode;

                    var vold = vm.node, oldDiff, newDiff;

                    if (vm.diff != null) {
                        oldDiff = vm._diff;
                        vm._diff = newDiff = vm.diff(vm, vm.data);

                        if (vold != null) {
                            var cmpFn = isArr(oldDiff) ? cmpArr : cmpObj;
                            var isSame = oldDiff === newDiff || cmpFn(oldDiff, newDiff);

                            if (isSame) { return reParent(vm, vold, newParent, newIdx); }
                        }
                    }

                    isMounted && fireHook(vm.hooks, "willRedraw", vm, vm.data);

                    var vnew = vm.render.call(vm, vm, vm.data, oldDiff, newDiff);

                    if (vnew === vold) { return reParent(vm, vold, newParent, newIdx); }

                    // todo: test result of willRedraw hooks before clearing refs
                    vm.refs = null;

                    // always assign vm key to root vnode (this is a de-opt)
                    if (vm.key != null && vnew.key !== vm.key) { vnew.key = vm.key; }

                    vm.node = vnew;

                    if (newParent) {
                        preProc(vnew, newParent, newIdx, vm);
                        newParent.body[newIdx] = vnew;
                    }
                    else if (vold && vold.parent) {
                        preProc(vnew, vold.parent, vold.idx, vm);
                        vold.parent.body[vold.idx] = vnew;
                    }
                    else { preProc(vnew, null, null, vm); }

                    if (withDOM !== false) {
                        if (vold) {
                            // root node replacement
                            if (vold.tag !== vnew.tag || vold.key !== vnew.key) {
                                // hack to prevent the replacement from triggering mount/unmount
                                vold.vm = vnew.vm = null;

                                var parEl = vold.el.parentNode;
                                var refEl = nextSib(vold.el);
                                removeChild(parEl, vold.el);
                                insertBefore(parEl, hydrate(vnew), refEl);

                                // another hack that allows any higher-level syncChildren to set
                                // reconciliation bounds using a live node
                                vold.el = vnew.el;

                                // restore
                                vnew.vm = vm;
                            }
                            else { patch(vnew, vold); }
                        }
                        else { hydrate(vnew); }
                    }

                    isMounted && fireHook(vm.hooks, "didRedraw", vm, vm.data);

                    if (isRedrawRoot && isMounted) { drainDidHooks(vm); }

                    return vm;
                }

                // this also doubles as moveTo
                // TODO? @withRedraw (prevent redraw from firing)
                function updateSync(newData, newParent, newIdx, withDOM) {
                    var vm = this;

                    if (newData != null) {
                        if (vm.data !== newData) {
                            fireHook(vm.hooks, "willUpdate", vm, newData);
                            vm.data = newData;


                        }
                    }

                    return vm._redraw(newParent, newIdx, withDOM);
                }

                function defineElement(tag, arg1, arg2, flags) {
                    var attrs, body;

                    if (arg2 == null) {
                        if (isPlainObj(arg1)) { attrs = arg1; }
                        else { body = arg1; }
                    }
                    else {
                        attrs = arg1;
                        body = arg2;
                    }

                    return initElementNode(tag, attrs, body, flags);
                }

                //export const XML_NS = "http://www.w3.org/2000/xmlns/";
                var SVG_NS = "http://www.w3.org/2000/svg";

                function defineSvgElement(tag, arg1, arg2, flags) {
                    var n = defineElement(tag, arg1, arg2, flags);
                    n.ns = SVG_NS;
                    return n;
                }

                function defineComment(body) {
                    var node = new VNode;
                    node.type = COMMENT;
                    node.body = body;
                    return node;
                }

                // placeholder for declared views
                function VView(view, data, key, opts) {
                    this.view = view;
                    this.data = data;
                    this.key = key;
                    this.opts = opts;
                }

                VView.prototype = {
                    constructor: VView,

                    type: VVIEW,
                    view: null,
                    data: null,
                    key: null,
                    opts: null,
                };

                function defineView(view, data, key, opts) {
                    return new VView(view, data, key, opts);
                }

                // placeholder for injected ViewModels
                function VModel(vm) {
                    this.vm = vm;
                }

                VModel.prototype = {
                    constructor: VModel,

                    type: VMODEL,
                    vm: null,
                };

                function injectView(vm) {
                    //	if (vm.node == null)
                    //		vm._redraw(null, null, false);

                    //	return vm.node;

                    return new VModel(vm);
                }

                function injectElement(el) {
                    var node = new VNode;
                    node.type = ELEMENT;
                    node.el = node.key = el;
                    return node;
                }

                function lazyList(items, cfg) {
                    var len = items.length;

                    var self = {
                        items: items,
                        length: len,
                        // defaults to returning item identity (or position?)
                        key: function (i) {
                            return cfg.key(items[i], i);
                        },
                        // default returns 0?
                        diff: function (i, donor) {
                            var newVals = cfg.diff(items[i], i);
                            if (donor == null) { return newVals; }
                            var oldVals = donor._diff;
                            var same = newVals === oldVals || isArr(oldVals) ? cmpArr(newVals, oldVals) : cmpObj(newVals, oldVals);
                            return same || newVals;
                        },
                        tpl: function (i) {
                            return cfg.tpl(items[i], i);
                        },
                        map: function (tpl) {
                            cfg.tpl = tpl;
                            return self;
                        },
                        body: function (vnode) {
                            var nbody = Array(len);

                            for (var i = 0; i < len; i++) {
                                var vnode2 = self.tpl(i);

                                //	if ((vnode.flags & KEYED_LIST) === KEYED_LIST && self. != null)
                                //		vnode2.key = getKey(item);

                                vnode2._diff = self.diff(i);			// holds oldVals for cmp

                                nbody[i] = vnode2;

                                // run preproc pass (should this be just preProc in above loop?) bench
                                preProc(vnode2, vnode, i);
                            }

                            // replace List with generated body
                            vnode.body = nbody;
                        }
                    };

                    return self;
                }

                var nano = {
                    config: config,

                    ViewModel: ViewModel,
                    VNode: VNode,

                    createView: createView,

                    defineElement: defineElement,
                    defineSvgElement: defineSvgElement,
                    defineText: defineText,
                    defineComment: defineComment,
                    defineView: defineView,

                    injectView: injectView,
                    injectElement: injectElement,

                    lazyList: lazyList,

                    FIXED_BODY: FIXED_BODY,
                    DEEP_REMOVE: DEEP_REMOVE,
                    KEYED_LIST: KEYED_LIST,
                    LAZY_LIST: LAZY_LIST,
                };

                function protoPatch(n, doRepaint) {
                    patch$1(this, n, doRepaint);
                }

                // newNode can be either {class: style: } or full new VNode
                // will/didPatch hooks?
                function patch$1(o, n, doRepaint) {
                    if (n.type != null) {
                        // no full patching of view roots, just use redraw!
                        if (o.vm != null) { return; }

                        preProc(n, o.parent, o.idx, null);
                        o.parent.body[o.idx] = n;
                        patch(n, o);
                        doRepaint && repaint(n);
                        drainDidHooks(getVm(n));
                    }
                    else {
                        // TODO: re-establish refs

                        // shallow-clone target
                        var donor = Object.create(o);
                        // fixate orig attrs
                        donor.attrs = assignObj({}, o.attrs);
                        // assign new attrs into live targ node
                        var oattrs = assignObj(o.attrs, n);
                        // prepend any fixed shorthand class
                        if (o._class != null) {
                            var aclass = oattrs.class;
                            oattrs.class = aclass != null && aclass !== "" ? o._class + " " + aclass : o._class;
                        }

                        patchAttrs(o, donor);

                        doRepaint && repaint(o);
                    }
                }

                VNodeProto.patch = protoPatch;

                function nextSubVms(n, accum) {
                    var body = n.body;

                    if (isArr(body)) {
                        for (var i = 0; i < body.length; i++) {
                            var n2 = body[i];

                            if (n2.vm != null) { accum.push(n2.vm); }
                            else { nextSubVms(n2, accum); }
                        }
                    }

                    return accum;
                }

                function defineElementSpread(tag) {
                    var args = arguments;
                    var len = args.length;
                    var body, attrs;

                    if (len > 1) {
                        var bodyIdx = 1;

                        if (isPlainObj(args[1])) {
                            attrs = args[1];
                            bodyIdx = 2;
                        }

                        if (len === bodyIdx + 1 && (isVal(args[bodyIdx]) || isArr(args[bodyIdx]) || attrs && (attrs._flags & LAZY_LIST) === LAZY_LIST)) { body = args[bodyIdx]; }
                        else { body = sliceArgs(args, bodyIdx); }
                    }

                    return initElementNode(tag, attrs, body);
                }

                function defineSvgElementSpread() {
                    var n = defineElementSpread.apply(null, arguments);
                    n.ns = SVG_NS;
                    return n;
                }

                ViewModelProto.emit = emit;
                ViewModelProto.onemit = null;

                ViewModelProto.body = function () {
                    return nextSubVms(this.node, []);
                };

                nano.defineElementSpread = defineElementSpread;
                nano.defineSvgElementSpread = defineSvgElementSpread;

                return nano;

            })));
            //# sourceMappingURL=domvm.micro.js.map


            /***/
        }),
/* 34 */
/***/ (function (module, exports, __webpack_require__) {

            "use strict";

            var __extends = (this && this.__extends) || (function () {
                var extendStatics = function (d, b) {
                    extendStatics = Object.setPrototypeOf ||
                        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
                        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
                    return extendStatics(d, b);
                };
                return function (d, b) {
                    extendStatics(d, b);
                    function __() { this.constructor = d; }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            })();
            var __assign = (this && this.__assign) || function () {
                __assign = Object.assign || function (t) {
                    for (var s, i = 1, n = arguments.length; i < n; i++) {
                        s = arguments[i];
                        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                            t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            var __spreadArrays = (this && this.__spreadArrays) || function () {
                for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
                for (var r = Array(s), k = 0, i = 0; i < il; i++)
                    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
                        r[k] = a[j];
                return r;
            };
            Object.defineProperty(exports, "__esModule", { value: true });
            var core_1 = __webpack_require__(1);
            var dom_1 = __webpack_require__(2);
            var events_1 = __webpack_require__(3);
            var view_1 = __webpack_require__(4);
            var ts_timepicker_1 = __webpack_require__(35);
            var helper_1 = __webpack_require__(47);
            var date_1 = __webpack_require__(15);
            var types_1 = __webpack_require__(48);
            var Calendar = /** @class */ (function (_super) {
                __extends(Calendar, _super);
                function Calendar(container, config) {
                    if (config === void 0) { config = {}; }
                    var _this = _super.call(this, container, core_1.extend({
                        weekStart: "sunday",
                        thisMonthOnly: false,
                        dateFormat: window && window.dhx && window.dhx.dateFormat,
                        width: "250px",
                    }, config)) || this;
                    _this._selected = [];
                    _this.events = new events_1.EventSystem();
                    _this.config.disabledDates = _this.config.disabledDates || _this.config.block; // TODO: remove suite_7.0
                    _this.config.mode = _this.config.mode || _this.config.view; // TODO: remove suite_7.0
                    if (!_this.config.dateFormat) {
                        if (_this.config.timePicker) {
                            if (_this.config.timeFormat === 12) {
                                _this.config.dateFormat = "%d/%m/%y %h:%i %A";
                            }
                            else {
                                _this.config.dateFormat = "%d/%m/%y %H:%i";
                            }
                        }
                        else {
                            _this.config.dateFormat = "%d/%m/%y";
                        }
                    }
                    if (_this.config.value) {
                        _this._setSelected(_this.config.value);
                    }
                    if (_this.config.date) {
                        _this._currentDate = date_1.DateHelper.toDateObject(_this.config.date, _this.config.dateFormat);
                    }
                    else if (_this._getSelected()) {
                        _this._currentDate = date_1.DateHelper.copy(_this._getSelected());
                    }
                    else {
                        _this._currentDate = new Date();
                    }
                    switch (_this.config.mode) {
                        case "month":
                            _this._currentViewMode = "month";
                            break;
                        case "year":
                            _this._currentViewMode = "year";
                            break;
                        default:
                            _this._currentViewMode = "calendar";
                    }
                    _this._initHandlers();
                    if (_this.config.timePicker) {
                        _this._timepicker = new ts_timepicker_1.Timepicker(null, {
                            timeFormat: _this.config.timeFormat,
                            controls: true,
                        });
                        var initTime = _this._getSelected() || new Date();
                        _this._timepicker.setValue(initTime);
                        _this._time = _this._timepicker.getValue();
                        _this._timepicker.events.on(ts_timepicker_1.TimepickerEvents.afterClose, function () {
                            _this._timepicker.setValue(_this._time);
                            _this.showDate(null, "calendar");
                        });
                        _this._timepicker.events.on(ts_timepicker_1.TimepickerEvents.afterApply, function () {
                            var _a = _this._timepicker.getValue(true), hour = _a.hour, minute = _a.minute, AM = _a.AM;
                            var oldDate = _this._getSelected();
                            var newDate = date_1.DateHelper.withHoursAndMinutes(_this._getSelected() || new Date(), hour, minute, AM);
                            if (_this.events.fire(types_1.CalendarEvents.beforeChange, [newDate, oldDate, true])) {
                                _this._selected[_this._selected.length - 1] = newDate;
                                _this.events.fire(types_1.CalendarEvents.change, [newDate, oldDate, true]);
                            }
                            _this._time = _this._timepicker.getValue();
                            _this.showDate(null, "calendar");
                        });
                    }
                    var render = function () { return _this._draw(); };
                    _this.mount(container, dom_1.create({ render: render }));
                    return _this;
                }
                Calendar.prototype.setValue = function (value) {
                    if (!value || (value instanceof Array && value.length === 0)) {
                        return false;
                    }
                    this._selected = [];
                    var currentDate = value instanceof Array ? value[0] : value;
                    var date = date_1.DateHelper.toDateObject(currentDate, this.config.dateFormat);
                    var oldDate = date_1.DateHelper.copy(this._getSelected());
                    if (!this.events.fire(types_1.CalendarEvents.beforeChange, [date, oldDate, false])) {
                        return false;
                    }
                    this._setSelected(value);
                    if (this._timepicker) {
                        this._timepicker.setValue(date);
                        this._time = this._timepicker.getValue();
                    }
                    this.showDate(this._getSelected());
                    this.events.fire(types_1.CalendarEvents.change, [date, oldDate, false]);
                    this.paint();
                    return true;
                };
                Calendar.prototype.getValue = function (asDateObject) {
                    var _this = this;
                    if (asDateObject === void 0) { asDateObject = false; }
                    if (!this._selected[0]) {
                        return "";
                    }
                    if (this.config.range) {
                        return asDateObject
                            ? this._selected.map(function (date) { return date_1.DateHelper.copy(date); })
                            : this._selected.map(function (date) { return date_1.getFormattedDate(_this.config.dateFormat, date); });
                    }
                    return asDateObject
                        ? date_1.DateHelper.copy(this._selected[0])
                        : date_1.getFormattedDate(this.config.dateFormat, this._selected[0]);
                };
                Calendar.prototype.getCurrentMode = function () {
                    return this._currentViewMode;
                };
                Calendar.prototype.showDate = function (date, mode) {
                    if (date) {
                        this._currentDate = date_1.DateHelper.copy(date);
                    }
                    if (mode) {
                        this._currentViewMode = mode;
                    }
                    this.paint();
                };
                Calendar.prototype.destructor = function () {
                    this._linkedCalendar && this._unlink();
                    this._timepicker && this._timepicker.destructor();
                    this.events && this.events.clear();
                    this.config = this.events = null;
                    this._uid = this._selected = this._currentDate = this._currentViewMode = this._handlers = this._timepicker = this._time = null;
                    this.unmount();
                };
                Calendar.prototype.clear = function () {
                    var oldDate = this.getValue(true);
                    if (this.config.timePicker) {
                        this._timepicker.clear();
                        this._time = this._timepicker.getValue();
                    }
                    this._selected = [];
                    this.showDate(null, this.config.mode);
                    this.events.fire(types_1.CalendarEvents.change, [this.getValue(true), oldDate, false]);
                };
                Calendar.prototype.link = function (targetCalendar) {
                    var _this = this;
                    if (this._linkedCalendar) {
                        this._unlink();
                    }
                    this._linkedCalendar = targetCalendar;
                    var rawLowerDate = this.getValue(true);
                    var rawUpperDate = targetCalendar.getValue(true);
                    var lowerDate = rawLowerDate && date_1.DateHelper.dayStart(rawLowerDate);
                    var upperDate = rawUpperDate && date_1.DateHelper.dayStart(rawUpperDate);
                    var getRangeClass = function (date) {
                        if (date_1.DateHelper.isSameDay(upperDate, lowerDate)) {
                            return null;
                        }
                        var positionInRange = "dhx_calendar-day--in-range";
                        if (date_1.DateHelper.isSameDay(date, lowerDate)) {
                            positionInRange += " dhx_calendar-day--first-date";
                        }
                        if (date_1.DateHelper.isSameDay(date, upperDate)) {
                            positionInRange += " dhx_calendar-day--last-date";
                        }
                        return positionInRange;
                    };
                    var rangeMark = function (date) {
                        if (lowerDate && upperDate) {
                            return date >= lowerDate && date <= upperDate && getRangeClass(date);
                        }
                    };
                    if (!this.config.$rangeMark || !this._linkedCalendar.config.$rangeMark) {
                        this.config.$rangeMark = this._linkedCalendar.config.$rangeMark = rangeMark;
                    }
                    if (!this.config.disabledDates || !this._linkedCalendar.config.disabledDates) {
                        this.config.disabledDates = function (date) {
                            if (upperDate) {
                                return date > upperDate;
                            }
                        };
                        this._linkedCalendar.config.disabledDates = function (date) {
                            if (lowerDate) {
                                return date < lowerDate;
                            }
                        };
                    }
                    this.config.thisMonthOnly = true;
                    targetCalendar.config.thisMonthOnly = true;
                    this.events.on(types_1.CalendarEvents.change, function (date) {
                        lowerDate = date_1.DateHelper.dayStart(date);
                        _this._linkedCalendar.paint();
                    }, "link");
                    this._linkedCalendar.events.on(types_1.CalendarEvents.change, function (date) {
                        upperDate = date_1.DateHelper.dayStart(date);
                        _this.paint();
                    }, "link");
                    this._linkedCalendar.paint();
                    this.paint();
                };
                Calendar.prototype._unlink = function () {
                    if (this._linkedCalendar) {
                        this.config.$rangeMark = this._linkedCalendar.config.$rangeMark = null;
                        this.config.disabledDates = this._linkedCalendar.config.disabledDates = null;
                        this.events.detach(types_1.CalendarEvents.change, "link");
                        this._linkedCalendar.events.detach(types_1.CalendarEvents.change, "link");
                        this._linkedCalendar.paint();
                        this._linkedCalendar = null;
                    }
                };
                Calendar.prototype._setSelected = function (value) {
                    var _this = this;
                    var currentDate = value instanceof Array ? value[0] : value;
                    var date = date_1.DateHelper.toDateObject(currentDate, this.config.dateFormat);
                    if (value instanceof Array && this.config.range) {
                        var filterDate_1 = [];
                        value.forEach(function (element, index) {
                            if (index < 2) {
                                filterDate_1.push(date_1.DateHelper.toDateObject(element, _this.config.dateFormat));
                            }
                        });
                        if (filterDate_1.length === 2 && filterDate_1[0] < filterDate_1[1]) {
                            filterDate_1.forEach(function (element) { return _this._selected.push(element); });
                        }
                        else {
                            this._selected[0] = filterDate_1[0];
                        }
                    }
                    else {
                        this._selected[0] = date;
                    }
                };
                Calendar.prototype._getSelected = function () {
                    return this._selected[this._selected.length - 1];
                };
                Calendar.prototype._draw = function () {
                    switch (this._currentViewMode) {
                        case "calendar":
                            this.events.fire(types_1.CalendarEvents.modeChange, ["calendar"]);
                            return this._drawCalendar();
                        case "month":
                            this.events.fire(types_1.CalendarEvents.modeChange, ["month"]);
                            return this._drawMonthSelector();
                        case "year":
                            this.events.fire(types_1.CalendarEvents.modeChange, ["year"]);
                            return this._drawYearSelector();
                        case "timepicker":
                            this.events.fire(types_1.CalendarEvents.modeChange, ["timepicker"]);
                            return this._drawTimepicker();
                    }
                };
                Calendar.prototype._initHandlers = function () {
                    var _this = this;
                    this._handlers = {
                        onclick: {
                            ".dhx_calendar-year, .dhx_calendar-month, .dhx_calendar-day": function (_e, vn) {
                                var date = vn.attrs._date;
                                var oldDate = date_1.DateHelper.copy(_this._getSelected());
                                switch (_this._currentViewMode) {
                                    case "calendar": {
                                        var mergedDate = _this.config.timePicker
                                            ? date_1.DateHelper.mergeHoursAndMinutes(date, _this._getSelected() || _this._currentDate)
                                            : date;
                                        if (!_this.events.fire(types_1.CalendarEvents.beforeChange, [mergedDate, oldDate, true])) {
                                            return;
                                        }
                                        if (_this.config.range &&
                                            _this._selected.length === 1 &&
                                            _this._selected[0] < mergedDate) {
                                            _this._selected.push(mergedDate);
                                        }
                                        else {
                                            _this._selected = [];
                                            _this._selected[0] = mergedDate;
                                        }
                                        vn.el.blur();
                                        _this.showDate(_this._getSelected());
                                        _this.events.fire(types_1.CalendarEvents.change, [date, oldDate, true]);
                                        break;
                                    }
                                    case "month":
                                        if (_this.config.mode !== "month") {
                                            date_1.DateHelper.setMonth(_this._currentDate, date);
                                            _this.showDate(null, "calendar");
                                            _this.events.fire(types_1.CalendarEvents.monthSelected, [date]);
                                        }
                                        else {
                                            var newDate = date_1.DateHelper.fromYearAndMonth(_this._currentDate.getFullYear() || _this._getSelected().getFullYear(), date);
                                            if (!_this.events.fire(types_1.CalendarEvents.beforeChange, [newDate, oldDate, true])) {
                                                return;
                                            }
                                            _this._currentDate = newDate;
                                            _this._selected[0] = newDate;
                                            _this.events.fire(types_1.CalendarEvents.change, [_this._getSelected(), oldDate, true]);
                                            _this.events.fire(types_1.CalendarEvents.monthSelected, [date]);
                                            _this.paint();
                                        }
                                        break;
                                    case "year":
                                        if (_this.config.mode !== "year") {
                                            date_1.DateHelper.setYear(_this._currentDate, date);
                                            _this.showDate(null, "month");
                                            _this.events.fire(types_1.CalendarEvents.yearSelected, [date]);
                                        }
                                        else {
                                            var newDate = date_1.DateHelper.fromYear(date);
                                            if (!_this.events.fire(types_1.CalendarEvents.beforeChange, [newDate, oldDate, true])) {
                                                return;
                                            }
                                            _this._currentDate = newDate;
                                            _this._selected[0] = newDate;
                                            _this.events.fire(types_1.CalendarEvents.change, [_this._getSelected(), oldDate, true]);
                                            _this.events.fire(types_1.CalendarEvents.yearSelected, [date]);
                                            _this.paint();
                                        }
                                }
                            },
                            ".dhx_calendar-action__cancel": function () {
                                _this.showDate(_this._getSelected(), "calendar");
                                _this.events.fire(types_1.CalendarEvents.cancelClick, []);
                            },
                            ".dhx_calendar-action__show-month": function () { return _this.showDate(null, "month"); },
                            ".dhx_calendar-action__show-year": function () { return _this.showDate(null, "year"); },
                            ".dhx_calendar-action__next": function () {
                                var newDate;
                                switch (_this._currentViewMode) {
                                    case "calendar":
                                        newDate = date_1.DateHelper.addMonth(_this._currentDate, 1);
                                        break;
                                    case "month":
                                        newDate = date_1.DateHelper.addYear(_this._currentDate, 1);
                                        break;
                                    case "year":
                                        newDate = date_1.DateHelper.addYear(_this._currentDate, 12);
                                }
                                _this.showDate(newDate);
                            },
                            ".dhx_calendar-action__prev": function () {
                                var newDate;
                                switch (_this._currentViewMode) {
                                    case "calendar":
                                        newDate = date_1.DateHelper.addMonth(_this._currentDate, -1);
                                        break;
                                    case "month":
                                        newDate = date_1.DateHelper.addYear(_this._currentDate, -1);
                                        break;
                                    case "year":
                                        newDate = date_1.DateHelper.addYear(_this._currentDate, -12);
                                }
                                _this.showDate(newDate);
                            },
                            ".dhx_calendar-action__show-timepicker": function () {
                                _this._currentViewMode = "timepicker";
                                _this.paint();
                            },
                        },
                        onmouseover: {
                            ".dhx_calendar-day": function (event, node) {
                                _this.events.fire(types_1.CalendarEvents.dateMouseOver, [new Date(node.attrs._date), event]);
                                _this.events.fire(types_1.CalendarEvents.dateHover, [new Date(node.attrs._date), event]); // TODO: remove suite_7.0
                            },
                        },
                    };
                };
                Calendar.prototype._getData = function (date) {
                    var _this = this;
                    var firstDay = this.config.weekStart === "monday" ? 1 : 0;
                    var first = date_1.DateHelper.weekStart(date_1.DateHelper.monthStart(date), firstDay);
                    var data = [];
                    var weeksCount = 6;
                    var currentDate = first;
                    while (weeksCount--) {
                        var currentWeek = date_1.DateHelper.getWeekNumber(currentDate);
                        var disabledDays = 0;
                        var daysCount = 7;
                        var days = [];
                        var _loop_1 = function () {
                            var isDateWeekEnd = date_1.DateHelper.isWeekEnd(currentDate);
                            var isCurrentMonth = date.getMonth() === currentDate.getMonth();
                            var isBlocked = this_1.config.disabledDates && this_1.config.disabledDates(currentDate);
                            var css = [];
                            if (this_1.config.range && this_1._selected[0] && this_1._selected[1]) {
                                var getRangeClass_1 = function () {
                                    if (date_1.DateHelper.isSameDay(_this._selected[0], _this._selected[1])) {
                                        return null;
                                    }
                                    return "dhx_calendar-day--in-range";
                                };
                                var rangeMark = function () {
                                    if (_this._selected[0] && _this._selected[1]) {
                                        var firstDate = date_1.DateHelper.dayStart(_this._selected[0]);
                                        var lastDate = date_1.DateHelper.dayStart(_this._selected[1]);
                                        return currentDate >= firstDate && currentDate <= lastDate && getRangeClass_1();
                                    }
                                };
                                this_1.config.$rangeMark = rangeMark;
                            }
                            if (isDateWeekEnd && isCurrentMonth) {
                                css.push("dhx_calendar-day--weekend");
                            }
                            if (!isCurrentMonth) {
                                if (this_1.config.thisMonthOnly) {
                                    disabledDays++;
                                    css.push("dhx_calendar-day--hidden");
                                }
                                else {
                                    css.push("dhx_calendar-day--muffled");
                                }
                            }
                            if (this_1.config.mark) {
                                var markedCss = this_1.config.mark(currentDate);
                                if (markedCss) {
                                    css.push(markedCss);
                                }
                            }
                            if (this_1.config.$rangeMark) {
                                var rangeMark = this_1.config.$rangeMark(currentDate);
                                if (rangeMark) {
                                    css.push(rangeMark);
                                }
                            }
                            if (isBlocked) {
                                if (isDateWeekEnd) {
                                    css.push("dhx_calendar-day--weekend-disabled");
                                }
                                else {
                                    css.push("dhx_calendar-day--disabled");
                                }
                            }
                            this_1._selected.forEach(function (selected, index) {
                                if (selected && date_1.DateHelper.isSameDay(selected, currentDate)) {
                                    var dayCss = "dhx_calendar-day--selected";
                                    if (_this.config.range) {
                                        dayCss += " dhx_calendar-day--selected-" + (index === 0 ? "first " : "last");
                                    }
                                    css.push(dayCss);
                                }
                            });
                            days.push({
                                date: currentDate,
                                day: currentDate.getDate(),
                                css: css.join(" "),
                            });
                            currentDate = date_1.DateHelper.addDay(currentDate);
                        };
                        var this_1 = this;
                        while (daysCount--) {
                            _loop_1();
                        }
                        data.push({
                            weekNumber: currentWeek,
                            days: days,
                            disabledWeekNumber: disabledDays === 7,
                        });
                    }
                    return data;
                };
                Calendar.prototype._drawCalendar = function () {
                    var date = this._currentDate;
                    var _a = this.config, weekStart = _a.weekStart, thisMonthOnly = _a.thisMonthOnly, css = _a.css, timePicker = _a.timePicker, width = _a.width;
                    var weekDays = weekStart === "monday" ? __spreadArrays(date_1.locale.daysShort.slice(1), [date_1.locale.daysShort[0]]) : date_1.locale.daysShort;
                    var weekDaysHeader = weekDays.map(function (day) { return dom_1.el(".dhx_calendar-weekday", day); });
                    var data = this._getData(date);
                    var content = [];
                    var weekNumbers = [];
                    var weekNumbersWrapper;
                    for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                        var week = data_1[_i];
                        var weekRow = week.days.map(function (item) {
                            return dom_1.el("div.dhx_calendar-day", {
                                class: item.css,
                                _date: item.date,
                                tabIndex: 1,
                            }, item.day);
                        });
                        if (this.config.weekNumbers && !(week.disabledWeekNumber && thisMonthOnly)) {
                            weekNumbers.push(dom_1.el("div", {
                                class: "dhx_calendar-week-number",
                            }, week.weekNumber));
                        }
                        content = content.concat(weekRow);
                    }
                    if (this.config.weekNumbers) {
                        weekNumbersWrapper = dom_1.el(".dhx_calendar__week-numbers", weekNumbers);
                    }
                    var widgetClass = "dhx_calendar dhx_widget" +
                        (css ? " " + css : "") +
                        (timePicker ? " dhx_calendar--with_timepicker" : "") +
                        (this.config.weekNumbers ? " dhx_calendar--with_week-numbers" : "");
                    return dom_1.el("div", __assign({
                        class: widgetClass, style: {
                            width: this.config.weekNumbers ? "calc(" + width + " + 48px )" : width,
                        }
                    }, this._handlers), [
                        dom_1.el(".dhx_calendar__wrapper", [
                            this._drawHeader(dom_1.el("button.dhx_calendar-action__show-month.dhx_button.dhx_button--view_link.dhx_button--size_small.dhx_button--color_secondary.dhx_button--circle", date_1.locale.months[date.getMonth()] + " " + date.getFullYear())),
                            this.config.weekNumbers &&
                            dom_1.el(".dhx_calendar__dates-wrapper", [
                                dom_1.el(".dhx_calendar__weekdays", weekDaysHeader),
                                dom_1.el(".dhx_calendar__days", content),
                                weekNumbersWrapper,
                            ]),
                            !this.config.weekNumbers && dom_1.el(".dhx_calendar__weekdays", weekDaysHeader),
                            !this.config.weekNumbers && dom_1.el(".dhx_calendar__days", content),
                            timePicker
                                ? dom_1.el(".dhx_timepicker__actions", [
                                    dom_1.el("button.dhx_calendar__timepicker-button." +
                                        "dhx_button.dhx_button--view_link.dhx_button--size_small.dhx_button--color_secondary.dhx_button--width_full.dhx_button--circle.dhx_calendar-action__show-timepicker", [
                                        dom_1.el("span.dhx_button__icon.dxi.dxi-clock-outline"),
                                        dom_1.el("span.dhx_button__text", this._time),
                                    ]),
                                ])
                                : null,
                        ]),
                    ]);
                };
                Calendar.prototype._drawMonthSelector = function () {
                    var date = this._currentDate;
                    var currentMonth = date.getMonth();
                    var currentYear = this._getSelected() ? this._getSelected().getFullYear() : null;
                    var _a = this.config, css = _a.css, timePicker = _a.timePicker, weekNumbers = _a.weekNumbers, width = _a.width, mode = _a.mode;
                    var widgetClass = "dhx_calendar dhx_widget" +
                        (css ? " " + css : "") +
                        (timePicker ? " dhx_calendar--with_timepicker" : "") +
                        (weekNumbers ? " dhx_calendar--with_week-numbers" : "");
                    return dom_1.el("div", __assign({
                        class: widgetClass, style: {
                            width: weekNumbers ? "calc(" + width + " + 48px)" : width,
                        }
                    }, this._handlers), [
                        dom_1.el(".dhx_calendar__wrapper", [
                            this._drawHeader(dom_1.el("button.dhx_calendar-action__show-year.dhx_button.dhx_button--view_link.dhx_button--size_small.dhx_button--color_secondary.dhx_button--circle", date.getFullYear())),
                            dom_1.el(".dhx_calendar__months", date_1.locale.monthsShort.map(function (item, i) {
                                return dom_1.el("div", {
                                    class: "dhx_calendar-month" +
                                        (currentMonth === i && currentYear === date.getFullYear()
                                            ? " dhx_calendar-month--selected"
                                            : ""),
                                    tabIndex: 1,
                                    _date: i,
                                }, item);
                            })),
                            mode !== "month"
                                ? dom_1.el(".dhx_calendar__actions", [
                                    dom_1.el("button.dhx_button.dhx_button--color_primary.dhx_button--view_link.dhx_button--size_small.dhx_button--width_full.dhx_button--circle.dhx_calendar-action__cancel", date_1.locale.cancel),
                                ])
                                : null,
                        ]),
                    ]);
                };
                Calendar.prototype._drawYearSelector = function () {
                    var _this = this;
                    var date = this._currentDate;
                    var yearsDiapason = date_1.DateHelper.getTwelweYears(date);
                    var _a = this.config, css = _a.css, timePicker = _a.timePicker, weekNumbers = _a.weekNumbers, width = _a.width, mode = _a.mode;
                    var widgetClass = "dhx_calendar dhx_widget" +
                        (css ? " " + css : "") +
                        (timePicker ? " dhx_calendar--with_timepicker" : "") +
                        (weekNumbers ? " dhx_calendar--with_week-numbers" : "");
                    return dom_1.el("div", __assign({ class: widgetClass, style: { width: weekNumbers ? "calc(" + width + " + 48px)" : width } }, this._handlers), [
                        dom_1.el(".dhx_calendar__wrapper", [
                            this._drawHeader(dom_1.el("button.dhx_button.dhx_button--view_link.dhx_button--size_small.dhx_button--color_secondary.dhx_button--circle", yearsDiapason[0] + "-" + yearsDiapason[yearsDiapason.length - 1])),
                            dom_1.el(".dhx_calendar__years", yearsDiapason.map(function (item) {
                                return dom_1.el("div", {
                                    class: "dhx_calendar-year" +
                                        (_this._getSelected() && item === _this._getSelected().getFullYear()
                                            ? " dhx_calendar-year--selected"
                                            : ""),
                                    _date: item,
                                    tabIndex: 1,
                                }, item);
                            })),
                            mode !== "year" && mode !== "month"
                                ? dom_1.el(".dhx_calendar__actions", [
                                    dom_1.el("button.dhx_button.dhx_button--color_primary.dhx_button--view_link.dhx_button--size_small.dhx_button--width_full.dhx_button--circle.dhx_calendar-action__cancel", date_1.locale.cancel),
                                ])
                                : null,
                        ]),
                    ]);
                };
                Calendar.prototype._drawHeader = function (actionContent) {
                    return dom_1.el(".dhx_calendar__navigation", [
                        dom_1.el("button.dhx_calendar-navigation__button.dhx_calendar-action__prev" +
                            helper_1.linkButtonClasses +
                            ".dhx_button--icon.dhx_button--circle", { "aria-label": "prev" }, [dom_1.el(".dhx_button__icon.dxi.dxi-chevron-left")]),
                        actionContent,
                        dom_1.el("button.dhx_calendar-navigation__button.dhx_calendar-action__next" +
                            helper_1.linkButtonClasses +
                            ".dhx_button--icon.dhx_button--circle", { "aria-label": "next" }, [dom_1.el(".dhx_button__icon.dxi.dxi-chevron-right")]),
                    ]);
                };
                Calendar.prototype._drawTimepicker = function () {
                    var _a = this.config, css = _a.css, weekNumbers = _a.weekNumbers, width = _a.width;
                    return dom_1.el(".dhx_widget.dhx-calendar", {
                        class: css ? " " + css : "",
                        style: { width: weekNumbers ? "calc(" + width + " + 48px)" : width },
                    }, [dom_1.inject(this._timepicker.getRootView())]);
                };
                return Calendar;
            }(view_1.View));
            exports.Calendar = Calendar;


            /***/
        }),
/* 35 */
/***/ (function (module, exports, __webpack_require__) {

            "use strict";

            function __export(m) {
                for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
            }
            Object.defineProperty(exports, "__esModule", { value: true });
            __export(__webpack_require__(36));
            __export(__webpack_require__(14));


            /***/
        }),
/* 36 */
/***/ (function (module, exports, __webpack_require__) {

            "use strict";

            var __extends = (this && this.__extends) || (function () {
                var extendStatics = function (d, b) {
                    extendStatics = Object.setPrototypeOf ||
                        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
                        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
                    return extendStatics(d, b);
                };
                return function (d, b) {
                    extendStatics(d, b);
                    function __() { this.constructor = d; }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            })();
            var __assign = (this && this.__assign) || function () {
                __assign = Object.assign || function (t) {
                    for (var s, i = 1, n = arguments.length; i < n; i++) {
                        s = arguments[i];
                        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                            t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", { value: true });
            var core_1 = __webpack_require__(1);
            var dom_1 = __webpack_require__(2);
            var events_1 = __webpack_require__(3);
            var view_1 = __webpack_require__(4);
            var ts_layout_1 = __webpack_require__(37);
            var ts_slider_1 = __webpack_require__(41);
            var en_1 = __webpack_require__(45);
            var helper_1 = __webpack_require__(46);
            var types_1 = __webpack_require__(14);
            function validate(value, max) {
                if (isNaN(value)) {
                    return 0;
                }
                return Math.min(max, Math.max(0, value));
            }
            var Timepicker = /** @class */ (function (_super) {
                __extends(Timepicker, _super);
                function Timepicker(container, config) {
                    if (config === void 0) { config = {}; }
                    var _this = _super.call(this, container, core_1.extend({
                        timeFormat: 24,
                        controls: false,
                        valueFormat: "string",
                        actions: false,
                    }, config)) || this;
                    _this.events = new events_1.EventSystem(_this);
                    _this._time = {
                        hour: 0,
                        minute: 0,
                        AM: true,
                    };
                    if (_this.config.timeFormat === 12) {
                        _this._time.hour = 12;
                    }
                    _this.config.controls = _this.config.controls || _this.config.actions; // TODO: remove suite_7.0
                    _this.config.value && _this._setValue(_this.config.value);
                    _this._initUI(container);
                    _this._initHandlers();
                    _this._initEvents();
                    return _this;
                }
                Timepicker.prototype.getValue = function (asOBject) {
                    if (this.config.timeFormat === 12)
                        this._time.hour = this._time.hour % 12 || 12;
                    var _a = this._time, h = _a.hour, m = _a.minute, isAM = _a.AM;
                    if (asOBject) {
                        var obj = {
                            hour: h,
                            minute: m,
                        };
                        if (this.config.timeFormat === 12) {
                            obj.AM = isAM;
                        }
                        return obj;
                    }
                    return ((h < 10 ? "0" + h : h) +
                        ":" +
                        (m < 10 ? "0" + m : m) +
                        (this.config.timeFormat === 12 ? (isAM ? "AM" : "PM") : ""));
                };
                Timepicker.prototype.setValue = function (value) {
                    this._setValue(value);
                    this._hoursSlider.setValue(this._time.hour);
                    this._minutesSlider.setValue(this._time.minute);
                    this._inputsView.paint();
                };
                Timepicker.prototype.clear = function () {
                    if (this.config.timeFormat === 24) {
                        this.setValue("00:00");
                    }
                    else {
                        this.setValue("12:00AM");
                    }
                };
                Timepicker.prototype.destructor = function () {
                    this._minutesSlider && this._minutesSlider.destructor();
                    this._hoursSlider && this._hoursSlider.destructor();
                    this.events && this.events.clear();
                    this.layout && this.layout.destructor();
                    this.config = this.events = null;
                    this._handlers = this._time = this._inputsView = this._minutesSlider = this._hoursSlider = null;
                    this.unmount();
                };
                Timepicker.prototype.getRootView = function () {
                    return this.layout.getRootView();
                };
                Timepicker.prototype._setValue = function (value) {
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    var m = 0;
                    var h = 0;
                    var isPM;
                    if (typeof value === "number") {
                        value = new Date(value);
                    }
                    if (value instanceof Date) {
                        m = value.getMinutes();
                        h = value.getHours();
                    }
                    else if (Array.isArray(value)) {
                        h = validate(value[0], 23);
                        m = validate(value[1], 59);
                        if (value[2] && value[2].toLowerCase() === "pm") {
                            isPM = true;
                        }
                    }
                    else if (typeof value === "string") {
                        var matches = value.match(/\d+/g);
                        h = validate(+matches[0], 23);
                        m = validate(+matches[1], 59);
                        if (value.toLowerCase().includes("pm")) {
                            isPM = true;
                        }
                    }
                    else if (typeof value === "object" &&
                        value.hasOwnProperty("hour") &&
                        value.hasOwnProperty("minute")) {
                        h = value.hour;
                        m = value.minute;
                        isPM = !value.AM;
                    }
                    if (isPM && h < 12) {
                        h += 12;
                    }
                    if (this.config.timeFormat === 12 && !helper_1.isTimeCheck(value) && h >= 12)
                        isPM = true;
                    return (this._time = {
                        hour: h,
                        minute: m,
                        AM: !isPM,
                    });
                };
                Timepicker.prototype._initUI = function (container) {
                    var _this = this;
                    var layoutConfig = {
                        gravity: false,
                        css: "dhx_widget dhx_timepicker " +
                            (this.config.css ? this.config.css : "") +
                            (this.config.controls ? " dhx_timepicker--with-controls" : ""),
                        rows: [
                            {
                                id: "timepicker",
                                css: "dhx_timepicker__inputs",
                            },
                            {
                                id: "hour-slider",
                                css: "dhx_timepicker__hour",
                            },
                            {
                                id: "minute-slider",
                                css: "dhx_timepicker__minute",
                            },
                        ],
                    };
                    if (this.config.controls) {
                        layoutConfig.rows.unshift({
                            id: "close-action",
                            css: "dhx_timepicker__close",
                        });
                        layoutConfig.rows.push({
                            id: "save-action",
                            css: "dhx_timepicker__save",
                        });
                    }
                    var layout = (this.layout = new ts_layout_1.Layout(container, layoutConfig));
                    var timepicker = dom_1.create({
                        render: function () { return _this._draw(); },
                    });
                    var inputsView = (this._inputsView = view_1.toViewLike(timepicker));
                    var mSlider = (this._minutesSlider = new ts_slider_1.Slider(null, {
                        min: 0,
                        max: 59,
                        step: 1,
                        tooltip: false,
                        labelPosition: "top",
                        label: en_1.default.minutes,
                        value: this.config.value ? this._time.minute : 0,
                    }));
                    var hSlider = (this._hoursSlider = new ts_slider_1.Slider(null, {
                        min: 0,
                        max: 23,
                        step: 1,
                        tooltip: false,
                        labelPosition: "top",
                        label: en_1.default.hours,
                        value: this.config.value ? (this._time.hour === 12 && this._time.AM ? 0 : this._time.hour) : 0,
                    }));
                    layout.getCell("timepicker").attach(inputsView);
                    layout.getCell("hour-slider").attach(hSlider);
                    layout.getCell("minute-slider").attach(mSlider);
                    if (this.config.controls) {
                        var save = function () {
                            return dom_1.el("button.dhx_timepicker__button-save.dhx_button.dhx_button--view_flat.dhx_button--color_primary.dhx_button--size_small.dhx_button--circle.dhx_button--width_full", { onclick: _this._outerHandlers.save }, en_1.default.save);
                        };
                        var close_1 = function () {
                            return dom_1.el("button.dhx_timepicker__button-close.dhx_button.dhx_button--view_link.dhx_button--size_medium.dhx_button--view_link.dhx_button--color_secondary.dhx_button--icon.dhx_button--circle", {
                                onclick: _this._outerHandlers.close,
                                "aria-label": "close timepicker",
                            }, [dom_1.el("span.dhx_button__icon.dxi.dxi-close")]);
                        };
                        layout.getCell("save-action").attach(save);
                        layout.getCell("close-action").attach(close_1);
                    }
                };
                Timepicker.prototype._initHandlers = function () {
                    var _this = this;
                    this._handlers = {
                        onchange: {
                            ".dhx_timepicker-input--hour": function (e) {
                                var hour = validate(parseInt(e.target.value, 10), 23);
                                e.target.value = hour;
                                _this._hoursSlider.setValue(hour);
                            },
                            ".dhx_timepicker-input--minutes": function (e) {
                                var min = validate(parseInt(e.target.value, 10), 59);
                                e.target.value = min;
                                _this._minutesSlider.setValue(min);
                            },
                        },
                    };
                    this._outerHandlers = {
                        close: function () {
                            if (!_this.events.fire(types_1.TimepickerEvents.beforeClose, [
                                _this.getValue(_this.config.valueFormat === "timeObject"),
                            ])) {
                                return;
                            }
                            _this.events.fire(types_1.TimepickerEvents.afterClose, [
                                _this.getValue(_this.config.valueFormat === "timeObject"),
                            ]);
                            _this.events.fire(types_1.TimepickerEvents.close, []); // TODO: remove suite_7.0
                        },
                        save: function () {
                            if (!_this.events.fire(types_1.TimepickerEvents.beforeApply, [
                                _this.getValue(_this.config.valueFormat === "timeObject"),
                            ]))
                                return;
                            _this.events.fire(types_1.TimepickerEvents.afterApply, [
                                _this.getValue(_this.config.valueFormat === "timeObject"),
                            ]);
                            _this.events.fire(types_1.TimepickerEvents.apply, [_this.getValue()]); // TODO: remove suite_7.0
                            _this.events.fire(types_1.TimepickerEvents.save, [_this._time]); // TODO: remove suite_7.0
                        },
                    };
                };
                Timepicker.prototype._initEvents = function () {
                    var _this = this;
                    this._hoursSlider.events.on(ts_slider_1.SliderEvents.change, function (value) {
                        if (value < _this._hoursSlider.config.min || value > _this._hoursSlider.config.max) {
                            return;
                        }
                        if (_this.config.timeFormat === 12) {
                            _this._time.AM = value < 12;
                            _this._time.hour = value % 12 || 12;
                        }
                        else {
                            _this._time.hour = value;
                        }
                        _this.events.fire(types_1.TimepickerEvents.change, [
                            _this.getValue(_this.config.valueFormat === "timeObject"),
                        ]);
                        _this._inputsView.paint();
                    });
                    this._minutesSlider.events.on(ts_slider_1.SliderEvents.change, function (value) {
                        if (value < _this._minutesSlider.config.min || value > _this._minutesSlider.config.max) {
                            return;
                        }
                        _this._time.minute = value;
                        _this.events.fire(types_1.TimepickerEvents.change, [
                            _this.getValue(_this.config.valueFormat === "timeObject"),
                        ]);
                        _this._inputsView.paint();
                    });
                };
                Timepicker.prototype._draw = function () {
                    return dom_1.el(".dhx_timepicker-inputs", __assign({}, this._handlers), [
                        dom_1.el("input.dhx_timepicker-input.dhx_timepicker-input--hour", {
                            _key: "hour",
                            value: this.getValue(true).hour.toString().length > 1
                                ? this.getValue(true).hour
                                : "0" + this.getValue(true).hour,
                            "aria-label": "hours",
                        }),
                        dom_1.el("span.dhx_timepicker-delimer", ":"),
                        dom_1.el("input.dhx_timepicker-input.dhx_timepicker-input--minutes", {
                            _key: "minute",
                            value: this.getValue(true).minute.toString().length > 1
                                ? this.getValue(true).minute
                                : "0" + this.getValue(true).minute,
                            "aria-label": "minutes",
                        }),
                        this.config.timeFormat === 12
                            ? dom_1.el(".dhx_timepicker-ampm", this._time.AM ? "AM" : "PM")
                            : null,
                    ]);
                };
                return Timepicker;
            }(view_1.View));
            exports.Timepicker = Timepicker;


            /***/
        }),
/* 37 */
/***/ (function (module, exports, __webpack_require__) {

            "use strict";

            function __export(m) {
                for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
            }
            Object.defineProperty(exports, "__esModule", { value: true });
            __export(__webpack_require__(38));
            __export(__webpack_require__(5));


            /***/
        }),
/* 38 */
/***/ (function (module, exports, __webpack_require__) {

            "use strict";

            var __extends = (this && this.__extends) || (function () {
                var extendStatics = function (d, b) {
                    extendStatics = Object.setPrototypeOf ||
                        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
                        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
                    return extendStatics(d, b);
                };
                return function (d, b) {
                    extendStatics(d, b);
                    function __() { this.constructor = d; }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            })();
            Object.defineProperty(exports, "__esModule", { value: true });
            var Cell_1 = __webpack_require__(39);
            var types_1 = __webpack_require__(5);
            var dom_1 = __webpack_require__(2);
            var Layout = /** @class */ (function (_super) {
                __extends(Layout, _super);
                function Layout(parent, config) {
                    var _this = _super.call(this, parent, config) || this;
                    // root layout
                    _this._root = _this.config.parent || _this;
                    _this._all = {};
                    _this._parseConfig();
                    if (_this.config.activeTab) {
                        _this.config.activeView = _this.config.activeTab;
                    }
                    // Need replace to tabbar
                    if (_this.config.views) {
                        _this.config.activeView = _this.config.activeView || _this._cells[0].id;
                        _this._isViewLayout = true;
                    }
                    if (!config.parent) {
                        var view = dom_1.create({ render: function () { return _this.toVDOM(); } }, _this);
                        _this.mount(parent, view);
                    }
                    return _this;
                }
                Layout.prototype.destructor = function () {
                    for (var key in this._all) {
                        if (Object.prototype.hasOwnProperty.call(this._all, key)) {
                            var cell = this._all[key];
                            if (cell.getWidget() && typeof cell.getWidget().destructor === "function") {
                                cell.getWidget().destructor();
                            }
                            cell.destructor();
                        }
                    }
                    this.config = this._cells = this._root = this._xLayout = this._isViewLayout = null;
                    this._all = {};
                    this.unmount();
                };
                Layout.prototype.toVDOM = function () {
                    if (this._isViewLayout) {
                        var roots = [this.getCell(this.config.activeView).toVDOM()];
                        return _super.prototype.toVDOM.call(this, roots);
                    }
                    var nodes = [];
                    this._inheritTypes();
                    this._cells.forEach(function (cell) {
                        var node = cell.toVDOM();
                        if (Array.isArray(node)) {
                            nodes = nodes.concat(node);
                        }
                        else {
                            nodes.push(node);
                        }
                    });
                    return _super.prototype.toVDOM.call(this, nodes);
                };
                Layout.prototype.removeCell = function (id) {
                    if (!this.events.fire(types_1.LayoutEvents.beforeRemove, [id])) {
                        return;
                    }
                    var root = this.config.parent || this;
                    if (root !== this) {
                        return root.removeCell(id);
                    }
                    // this === root layout
                    var view = this.getCell(id);
                    if (view) {
                        var parent_1 = view.getParent();
                        delete this._all[id];
                        parent_1._cells = parent_1._cells.filter(function (cell) { return cell.id != id; });
                        parent_1.paint();
                    }
                    this.events.fire(types_1.LayoutEvents.afterRemove, [id]);
                };
                Layout.prototype.addCell = function (config, index) {
                    if (index === void 0) { index = -1; }
                    if (!this.events.fire(types_1.LayoutEvents.beforeAdd, [config.id])) {
                        return;
                    }
                    var view = this._createCell(config);
                    if (index < 0) {
                        index = this._cells.length + index + 1;
                    }
                    this._cells.splice(index, 0, view);
                    this.paint();
                    if (!this.events.fire(types_1.LayoutEvents.afterAdd, [config.id])) {
                        return;
                    }
                };
                Layout.prototype.getId = function (index) {
                    if (index < 0) {
                        index = this._cells.length + index;
                    }
                    return this._cells[index] ? this._cells[index].id : undefined;
                };
                Layout.prototype.getRefs = function (name) {
                    return this._root.getRootView().refs[name];
                };
                Layout.prototype.getCell = function (id) {
                    return this._root._all[id];
                };
                Layout.prototype.forEach = function (callback, parent, level) {
                    if (level === void 0) { level = Infinity; }
                    if (!this._haveCells(parent) || level < 1) {
                        return;
                    }
                    var array;
                    if (parent) {
                        array = this._root._all[parent]._cells;
                    }
                    else {
                        array = this._root._cells;
                    }
                    for (var index = 0; index < array.length; index++) {
                        var cell = array[index];
                        callback.call(this, cell, index, array);
                        if (this._haveCells(cell.id)) {
                            cell.forEach(callback, cell.id, --level);
                        }
                    }
                };
                /** @deprecated See a documentation: https://docs.dhtmlx.com/ */
                Layout.prototype.cell = function (id) {
                    return this.getCell(id);
                };
                Layout.prototype._getCss = function (content) {
                    var layoutCss = this._xLayout ? "dhx_layout-columns" : "dhx_layout-rows";
                    var directionCss = this.config.align ? " " + layoutCss + "--" + this.config.align : "";
                    if (content) {
                        return (layoutCss +
                            " dhx_layout-cell" +
                            (this.config.align ? " dhx_layout-cell--" + this.config.align : ""));
                    }
                    else {
                        var cellCss = this.config.parent ? _super.prototype._getCss.call(this) : "dhx_widget dhx_layout";
                        var fullModeCss = this.config.parent ? "" : " dhx_layout-cell";
                        return cellCss + (this.config.full ? fullModeCss : " " + layoutCss) + directionCss;
                    }
                };
                Layout.prototype._parseConfig = function () {
                    var _this = this;
                    var config = this.config;
                    var cells = config.rows || config.cols || config.views || [];
                    this._xLayout = !config.rows;
                    this._cells = cells.map(function (a) { return _this._createCell(a); });
                };
                Layout.prototype._createCell = function (cell) {
                    var view;
                    if (cell.rows || cell.cols || cell.views) {
                        cell.parent = this._root;
                        view = new Layout(this, cell);
                    }
                    else {
                        view = new Cell_1.Cell(this, cell);
                    }
                    // FIxME
                    this._root._all[view.id] = view;
                    if (cell.init) {
                        cell.init(view, cell);
                    }
                    return view;
                };
                Layout.prototype._haveCells = function (id) {
                    if (id) {
                        var array = this._root._all[id];
                        return array._cells && array._cells.length > 0;
                    }
                    return Object.keys(this._all).length > 0;
                };
                Layout.prototype._inheritTypes = function (obj) {
                    var _this = this;
                    if (obj === void 0) { obj = this._cells; }
                    if (Array.isArray(obj)) {
                        obj.forEach(function (cell) { return _this._inheritTypes(cell); });
                    }
                    else {
                        var cellConfig = obj.config;
                        if (cellConfig.rows || cellConfig.cols) {
                            var viewParent = obj.getParent();
                            if (!cellConfig.type && viewParent) {
                                if (viewParent.config.type) {
                                    cellConfig.type = viewParent.config.type;
                                }
                                else {
                                    this._inheritTypes(viewParent);
                                }
                            }
                        }
                    }
                };
                return Layout;
            }(Cell_1.Cell));
            exports.Layout = Layout;


            /***/
        }),
/* 39 */
/***/ (function (module, exports, __webpack_require__) {

            "use strict";

            var __extends = (this && this.__extends) || (function () {
                var extendStatics = function (d, b) {
                    extendStatics = Object.setPrototypeOf ||
                        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
                        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
                    return extendStatics(d, b);
                };
                return function (d, b) {
                    extendStatics(d, b);
                    function __() { this.constructor = d; }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            })();
            var __assign = (this && this.__assign) || function () {
                __assign = Object.assign || function (t) {
                    for (var s, i = 1, n = arguments.length; i < n; i++) {
                        s = arguments[i];
                        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                            t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", { value: true });
            var core_1 = __webpack_require__(1);
            var dom_1 = __webpack_require__(2);
            var view_1 = __webpack_require__(4);
            var types_1 = __webpack_require__(5);
            var helpers_1 = __webpack_require__(40);
            var events_1 = __webpack_require__(3);
            var Cell = /** @class */ (function (_super) {
                __extends(Cell, _super);
                function Cell(parent, config) {
                    var _this = _super.call(this, parent, config) || this;
                    _this._disabled = [];
                    var p = parent;
                    if (p && p.isVisible) {
                        _this._parent = p;
                    }
                    if (_this._parent && _this._parent.events) {
                        _this.events = _this._parent.events;
                    }
                    else {
                        _this.events = new events_1.EventSystem(_this);
                    }
                    _this.config.full =
                        _this.config.full === undefined
                            ? Boolean(_this.config.header ||
                                _this.config.collapsable ||
                                _this.config.headerHeight ||
                                _this.config.headerIcon ||
                                _this.config.headerImage)
                            : _this.config.full;
                    _this._initHandlers();
                    _this.id = _this.config.id || core_1.uid();
                    return _this;
                }
                Cell.prototype.paint = function () {
                    if (this.isVisible()) {
                        var view = this.getRootView();
                        if (view) {
                            view.redraw();
                        }
                        else {
                            this._parent.paint();
                        }
                    }
                };
                Cell.prototype.isVisible = function () {
                    // top level node
                    if (!this._parent) {
                        if (this._container && this._container.tagName) {
                            return true;
                        }
                        return Boolean(this.getRootNode());
                    }
                    // check active view in case of multiview
                    var active = this._parent.config.activeView;
                    if (active && active !== this.id) {
                        return false;
                    }
                    // check that all parents of the cell are visible as well
                    return !this.config.hidden && (!this._parent || this._parent.isVisible());
                };
                Cell.prototype.hide = function () {
                    if (!this.events.fire(types_1.LayoutEvents.beforeHide, [this.id])) {
                        return;
                    }
                    this.config.hidden = true;
                    if (this._parent && this._parent.paint) {
                        this._parent.paint();
                    }
                    this.events.fire(types_1.LayoutEvents.afterHide, [this.id]);
                };
                Cell.prototype.show = function () {
                    if (!this.events.fire(types_1.LayoutEvents.beforeShow, [this.id])) {
                        return;
                    }
                    if (this._parent && this._parent.config && this._parent.config.activeView !== undefined) {
                        this._parent.config.activeView = this.id;
                    }
                    else {
                        this.config.hidden = false;
                    }
                    if (this._parent && !this._parent.isVisible()) {
                        this._parent.show();
                    }
                    this.paint();
                    this.events.fire(types_1.LayoutEvents.afterShow, [this.id]);
                };
                Cell.prototype.expand = function () {
                    if (!this.events.fire(types_1.LayoutEvents.beforeExpand, [this.id])) {
                        return;
                    }
                    this.config.collapsed = false;
                    this.events.fire(types_1.LayoutEvents.afterExpand, [this.id]);
                    this.paint();
                };
                Cell.prototype.collapse = function () {
                    if (!this.events.fire(types_1.LayoutEvents.beforeCollapse, [this.id])) {
                        return;
                    }
                    this.config.collapsed = true;
                    this.events.fire(types_1.LayoutEvents.afterCollapse, [this.id]);
                    this.paint();
                };
                Cell.prototype.toggle = function () {
                    if (this.config.collapsed) {
                        this.expand();
                    }
                    else {
                        this.collapse();
                    }
                };
                Cell.prototype.getParent = function () {
                    return this._parent;
                };
                Cell.prototype.destructor = function () {
                    this.events && this.events.clear();
                    this.config = this.events = this.id = null;
                    this._parent = this._handlers = this._uid = this._disabled = this._resizerHandlers = null;
                    this.unmount();
                };
                Cell.prototype.getWidget = function () {
                    return this._ui;
                };
                Cell.prototype.getCellView = function () {
                    return this._parent && this._parent.getRefs(this._uid);
                };
                Cell.prototype.attach = function (name, config) {
                    this.config.html = null;
                    if (typeof name === "object") {
                        this._ui = name;
                    }
                    else if (typeof name === "string") {
                        this._ui = new window.dhx[name](null, config);
                    }
                    else if (typeof name === "function") {
                        if (name.prototype instanceof view_1.View) {
                            this._ui = new name(null, config);
                        }
                        else {
                            this._ui = {
                                getRootView: function () {
                                    return name(config);
                                },
                            };
                        }
                    }
                    this.paint();
                    return this._ui;
                };
                Cell.prototype.attachHTML = function (html) {
                    this.config.html = html;
                    this.paint();
                };
                Cell.prototype.toVDOM = function (nodes) {
                    var _a;
                    if (this.config === null) {
                        this.config = {};
                    }
                    if (this.config.hidden) {
                        return;
                    }
                    var style = this._calculateStyle();
                    var stylePadding = core_1.isDefined(this.config.padding)
                        ? !isNaN(Number(this.config.padding))
                            ? { padding: this.config.padding + "px" }
                            : { padding: this.config.padding }
                        : "";
                    var fullStyle = this.config.full || this.config.html ? style : __assign(__assign({}, style), stylePadding);
                    var kids;
                    if (!this.config.html) {
                        if (this._ui) {
                            var view = this._ui.getRootView();
                            if (view.render) {
                                view = dom_1.inject(view);
                            }
                            kids = [view];
                        }
                        else {
                            kids = nodes || null;
                        }
                    }
                    var resizer = this.config.resizable && !this._isLastCell() && !this.config.collapsed
                        ? dom_1.el(".dhx_layout-resizer." +
                            (this._isXDirection() ? "dhx_layout-resizer--x" : "dhx_layout-resizer--y"), __assign(__assign({}, this._resizerHandlers), { _ref: "resizer_" + this._uid }), [
                            dom_1.el("span.dhx_layout-resizer__icon", {
                                class: "dxi " +
                                    (this._isXDirection() ? "dxi-dots-vertical" : "dxi-dots-horizontal"),
                            }),
                        ])
                        : null;
                    var handlers = {};
                    if (this.config.on) {
                        for (var key in this.config.on) {
                            handlers["on" + key] = this.config.on[key];
                        }
                    }
                    var typeClass = "";
                    var isParent = this.config.cols || this.config.rows;
                    if (this.config.type && isParent) {
                        switch (this.config.type) {
                            case "line":
                                typeClass = " dhx_layout-line";
                                break;
                            case "wide":
                                typeClass = " dhx_layout-wide";
                                break;
                            case "space":
                                typeClass = " dhx_layout-space";
                                break;
                            default:
                                break;
                        }
                    }
                    var cell = dom_1.el("div", __assign(__assign((_a = { _key: this._uid, _ref: this._uid }, _a["aria-label"] = this.config.id ? "tab-content-" + this.config.id : null, _a), handlers), {
                        class: this._getCss(false) +
                            (this.config.css ? " " + this.config.css : "") +
                            (this.config.collapsed ? " dhx_layout-cell--collapsed" : "") +
                            (this.config.resizable ? " dhx_layout-cell--resizable" : "") +
                            (this.config.type && !this.config.full ? typeClass : ""), style: fullStyle
                    }), this.config.full
                        ? [
                            dom_1.el("div", {
                                tabindex: this.config.collapsable ? "0" : "-1",
                                class: "dhx_layout-cell-header" +
                                    (this._isXDirection()
                                        ? " dhx_layout-cell-header--col"
                                        : " dhx_layout-cell-header--row") +
                                    (this.config.collapsable ? " dhx_layout-cell-header--collapseble" : "") +
                                    (this.config.collapsed ? " dhx_layout-cell-header--collapsed" : "") +
                                    (((this.getParent() || {}).config || {}).isAccordion
                                        ? " dhx_layout-cell-header--accordion"
                                        : ""),
                                style: {
                                    height: this.config.headerHeight,
                                },
                                onclick: this._handlers.toggle,
                                onkeydown: this._handlers.enterCollapse,
                            }, [
                                this.config.headerIcon &&
                                dom_1.el("span.dhx_layout-cell-header__icon", {
                                    class: this.config.headerIcon,
                                }),
                                this.config.headerImage &&
                                dom_1.el(".dhx_layout-cell-header__image-wrapper", [
                                    dom_1.el("img", {
                                        src: this.config.headerImage,
                                        class: "dhx_layout-cell-header__image",
                                    }),
                                ]),
                                this.config.header &&
                                dom_1.el("h3.dhx_layout-cell-header__title", this.config.header),
                                this.config.collapsable
                                    ? dom_1.el("div.dhx_layout-cell-header__collapse-icon", {
                                        class: this._getCollapseIcon(),
                                    })
                                    : dom_1.el("div.dhx_layout-cell-header__collapse-icon", {
                                        class: "dxi dxi-empty",
                                    }),
                            ]),
                            !this.config.collapsed
                                ? dom_1.el("div", {
                                    style: __assign(__assign({}, stylePadding), { height: "calc(100% - " + (this.config.headerHeight || 37) + "px)" }),
                                    ".innerHTML": this.config.html,
                                    class: this._getCss(true) +
                                        " dhx_layout-cell-content" +
                                        (this.config.type ? typeClass : ""),
                                }, kids)
                                : null,
                        ]
                        : this.config.html &&
                            !(this.config.rows &&
                                this.config.cols &&
                                this.config.views)
                            ? [
                                dom_1.el(".dhx_layout-cell-content", {
                                    ".innerHTML": this.config.html,
                                    style: stylePadding,
                                }),
                            ]
                            : kids);
                    return resizer ? [cell, resizer] : cell;
                };
                Cell.prototype._getCss = function (_content) {
                    return "dhx_layout-cell";
                };
                Cell.prototype._initHandlers = function () {
                    var _this = this;
                    this._handlers = {
                        enterCollapse: function (e) {
                            if (e.keyCode === 13) {
                                _this._handlers.toggle();
                            }
                        },
                        collapse: function () {
                            if (!_this.config.collapsable) {
                                return;
                            }
                            _this.collapse();
                        },
                        expand: function () {
                            if (!_this.config.collapsable) {
                                return;
                            }
                            _this.expand();
                        },
                        toggle: function () {
                            if (!_this.config.collapsable) {
                                return;
                            }
                            _this.toggle();
                        },
                    };
                    var blockOpts = {
                        left: null,
                        top: null,
                        isActive: false,
                        range: null,
                        xLayout: null,
                        nextCell: null,
                        size: null,
                        resizerLength: null,
                        mode: null,
                        percentsum: null,
                        margin: null,
                    };
                    var resizeMove = function (event) {
                        if (!blockOpts.isActive) {
                            return;
                        }
                        var clientX = event.targetTouches ? event.targetTouches[0].clientX : event.clientX;
                        var clientY = event.targetTouches ? event.targetTouches[0].clientY : event.clientY;
                        var newValue = blockOpts.xLayout
                            ? clientX - blockOpts.range.min + window.pageXOffset
                            : clientY - blockOpts.range.min + window.pageYOffset;
                        var prop = blockOpts.xLayout ? "width" : "height";
                        if (newValue < 0) {
                            newValue = blockOpts.resizerLength / 2;
                        }
                        else if (newValue > blockOpts.size) {
                            newValue = blockOpts.size - blockOpts.resizerLength;
                        }
                        switch (blockOpts.mode) {
                            case types_1.resizeMode.pixels:
                                _this.config[prop] = newValue - blockOpts.resizerLength / 2 + "px";
                                blockOpts.nextCell.config[prop] =
                                    blockOpts.size - newValue - blockOpts.resizerLength / 2 + "px";
                                break;
                            case types_1.resizeMode.mixedpx1:
                                _this.config[prop] = newValue - blockOpts.resizerLength / 2 + "px";
                                break;
                            case types_1.resizeMode.mixedpx2:
                                blockOpts.nextCell.config[prop] =
                                    blockOpts.size - newValue - blockOpts.resizerLength / 2 + "px";
                                break;
                            case types_1.resizeMode.percents:
                                _this.config[prop] = (newValue / blockOpts.size) * blockOpts.percentsum + "%";
                                blockOpts.nextCell.config[prop] =
                                    ((blockOpts.size - newValue) / blockOpts.size) * blockOpts.percentsum + "%";
                                break;
                            case types_1.resizeMode.mixedperc1:
                                _this.config[prop] = (newValue / blockOpts.size) * blockOpts.percentsum + "%";
                                break;
                            case types_1.resizeMode.mixedperc2:
                                blockOpts.nextCell.config[prop] =
                                    ((blockOpts.size - newValue) / blockOpts.size) * blockOpts.percentsum + "%";
                                break;
                            case types_1.resizeMode.unknown:
                                _this.config[prop] = newValue - blockOpts.resizerLength / 2 + "px";
                                blockOpts.nextCell.config[prop] =
                                    blockOpts.size - newValue - blockOpts.resizerLength / 2 + "px";
                                _this.config.$fixed = true;
                                break;
                        }
                        _this.paint();
                        _this.events.fire(types_1.LayoutEvents.resize, [_this.id]);
                    };
                    var resizeEnd = function (event) {
                        blockOpts.isActive = false;
                        document.body.classList.remove("dhx_no-select--resize");
                        if (!event.targetTouches) {
                            document.removeEventListener("mouseup", resizeEnd);
                            document.removeEventListener("mousemove", resizeMove);
                        }
                        else {
                            document.removeEventListener("touchend", resizeEnd);
                            document.removeEventListener("touchmove", resizeMove);
                        }
                        _this.events.fire(types_1.LayoutEvents.afterResizeEnd, [_this.id]);
                    };
                    var resizeStart = function (event) {
                        event.targetTouches && event.preventDefault();
                        if (event.which === 3) {
                            return;
                        }
                        if (blockOpts.isActive) {
                            resizeEnd(event);
                        }
                        if (!_this.events.fire(types_1.LayoutEvents.beforeResizeStart, [_this.id])) {
                            return;
                        }
                        document.body.classList.add("dhx_no-select--resize");
                        var block = _this.getCellView();
                        var nextCell = _this._getNextCell();
                        var nextBlock = nextCell.getCellView();
                        var resizerBlock = _this._getResizerView();
                        var blockOffsets = block.el.getBoundingClientRect();
                        var resizerOffsets = resizerBlock.el.getBoundingClientRect();
                        var nextBlockOffsets = nextBlock.el.getBoundingClientRect();
                        blockOpts.xLayout = _this._isXDirection();
                        blockOpts.left = blockOffsets.left + window.pageXOffset;
                        blockOpts.top = blockOffsets.top + window.pageYOffset;
                        blockOpts.margin = helpers_1.getMarginSize(_this.getParent().config, blockOpts.xLayout);
                        blockOpts.range = helpers_1.getBlockRange(blockOffsets, nextBlockOffsets, blockOpts.xLayout);
                        blockOpts.size = blockOpts.range.max - blockOpts.range.min - blockOpts.margin;
                        blockOpts.isActive = true;
                        blockOpts.nextCell = nextCell;
                        blockOpts.resizerLength = blockOpts.xLayout ? resizerOffsets.width : resizerOffsets.height;
                        blockOpts.mode = helpers_1.getResizeMode(blockOpts.xLayout, _this.config, nextCell.config);
                        if (blockOpts.mode === types_1.resizeMode.percents) {
                            var field = blockOpts.xLayout ? "width" : "height";
                            blockOpts.percentsum =
                                parseFloat(_this.config[field].slice(0, -1)) +
                                parseFloat(nextCell.config[field].slice(0, -1));
                        }
                        if (blockOpts.mode === types_1.resizeMode.mixedperc1) {
                            var field = blockOpts.xLayout ? "width" : "height";
                            blockOpts.percentsum =
                                (1 / (blockOffsets[field] / (blockOpts.size - blockOpts.resizerLength))) *
                                parseFloat(_this.config[field].slice(0, -1));
                        }
                        if (blockOpts.mode === types_1.resizeMode.mixedperc2) {
                            var field = blockOpts.xLayout ? "width" : "height";
                            blockOpts.percentsum =
                                (1 / (nextBlockOffsets[field] / (blockOpts.size - blockOpts.resizerLength))) *
                                parseFloat(nextCell.config[field]);
                        }
                    };
                    this._resizerHandlers = {
                        onmousedown: function (e) {
                            resizeStart(e);
                            document.addEventListener("mouseup", resizeEnd);
                            document.addEventListener("mousemove", resizeMove);
                        },
                        ontouchstart: function (e) {
                            resizeStart(e);
                            document.addEventListener("touchend", resizeEnd);
                            document.addEventListener("touchmove", resizeMove);
                        },
                        ondragstart: function (e) { return e.preventDefault(); },
                    };
                };
                Cell.prototype._getCollapseIcon = function () {
                    if (this._isXDirection() && this.config.collapsed) {
                        return "dxi dxi-chevron-right";
                    }
                    if (this._isXDirection() && !this.config.collapsed) {
                        return "dxi dxi-chevron-left";
                    }
                    if (!this._isXDirection() && this.config.collapsed) {
                        return "dxi dxi-chevron-up";
                    }
                    if (!this._isXDirection() && !this.config.collapsed) {
                        return "dxi dxi-chevron-down";
                    }
                };
                Cell.prototype._isLastCell = function () {
                    var parent = this._parent;
                    return parent && parent._cells.indexOf(this) === parent._cells.length - 1;
                };
                Cell.prototype._getNextCell = function () {
                    var parent = this._parent;
                    var index = parent._cells.indexOf(this);
                    return parent._cells[index + 1];
                };
                Cell.prototype._getResizerView = function () {
                    return this._parent.getRefs("resizer_" + this._uid);
                };
                Cell.prototype._isXDirection = function () {
                    return this._parent && this._parent._xLayout;
                };
                Cell.prototype._calculateStyle = function () {
                    var config = this.config;
                    if (!config) {
                        return;
                    }
                    var style = {};
                    var autoWidth = false;
                    var autoHeight = false;
                    if (!isNaN(Number(config.width)))
                        config.width = config.width + "px";
                    if (!isNaN(Number(config.height)))
                        config.height = config.height + "px";
                    if (!isNaN(Number(config.minWidth)))
                        config.minWidth = config.minWidth + "px";
                    if (!isNaN(Number(config.minHeight)))
                        config.minHeight = config.minHeight + "px";
                    if (!isNaN(Number(config.maxWidth)))
                        config.maxWidth = config.maxWidth + "px";
                    if (!isNaN(Number(config.maxHeight)))
                        config.maxHeight = config.maxHeight + "px";
                    if (config.width === "content")
                        autoWidth = true;
                    if (config.height === "content")
                        autoHeight = true;
                    var _a = config, width = _a.width, height = _a.height, cols = _a.cols, rows = _a.rows, minWidth = _a.minWidth, minHeight = _a.minHeight, maxWidth = _a.maxWidth, maxHeight = _a.maxHeight, gravity = _a.gravity, collapsed = _a.collapsed, $fixed = _a.$fixed;
                    var gravityNumber = Math.sign(gravity) === -1 ? 0 : gravity;
                    if (typeof gravity === "boolean") {
                        gravityNumber = gravity ? 1 : 0;
                    }
                    var fixed = typeof gravity === "boolean" ? !gravity : Math.sign(gravity) === -1;
                    if (this._isXDirection()) {
                        if ($fixed || width || (gravity === undefined && (minWidth || maxWidth))) {
                            fixed = true;
                        }
                    }
                    else {
                        if ($fixed || height || (gravity === undefined && (minHeight || maxHeight))) {
                            fixed = true;
                        }
                    }
                    var grow = fixed ? 0 : gravityNumber || 1;
                    var fillSpace = this._isXDirection() ? "x" : "y";
                    if (minWidth !== undefined)
                        style.minWidth = minWidth;
                    if (minHeight !== undefined)
                        style.minHeight = minHeight;
                    if (maxWidth !== undefined)
                        style.maxWidth = maxWidth;
                    if (maxHeight !== undefined)
                        style.maxHeight = maxHeight;
                    if (this._parent === undefined && !fillSpace !== undefined) {
                        fillSpace = true;
                    }
                    if (width !== undefined && width !== "content") {
                        style.width = width;
                    }
                    else {
                        if (fillSpace === true) {
                            style.width = "100%";
                        }
                        else if (fillSpace === "x") {
                            if (autoWidth) {
                                style.flex = "0 0 auto";
                            }
                            else {
                                var isAuto = this._isXDirection() ? "1px" : "auto";
                                style.flex = grow + " " + (cols || rows ? "0 " + isAuto : "1 auto");
                            }
                        }
                    }
                    if (height !== undefined && height !== "content") {
                        style.height = height;
                    }
                    else {
                        if (fillSpace === true) {
                            style.height = "100%";
                        }
                        else if (fillSpace === "y") {
                            if (autoHeight) {
                                style.flex = "0 0 auto";
                            }
                            else {
                                var isAuto = !this._isXDirection() ? "1px" : "auto";
                                style.flex = grow + " " + (cols || rows ? "0 " + isAuto : "1 auto");
                            }
                        }
                    }
                    if (fillSpace === true && config.width === undefined && config.height === undefined) {
                        style.flex = grow + " 1 auto";
                    }
                    if (collapsed) {
                        if (this._isXDirection()) {
                            style.width = "auto";
                        }
                        else {
                            style.height = "auto";
                        }
                        style.flex = "0 0 auto";
                    }
                    return style;
                };
                return Cell;
            }(view_1.View));
            exports.Cell = Cell;


            /***/
        }),
/* 40 */
/***/ (function (module, exports, __webpack_require__) {

            "use strict";

            Object.defineProperty(exports, "__esModule", { value: true });
            var types_1 = __webpack_require__(5);
            function getResizeMode(isXLayout, conf1, conf2) {
                var field = isXLayout ? "width" : "height";
                var is1perc = conf1[field] && conf1[field].includes("%");
                var is2perc = conf2[field] && conf2[field].includes("%");
                var is1px = conf1[field] && conf1[field].includes("px");
                var is2px = conf2[field] && conf2[field].includes("px");
                if (is1perc && is2perc) {
                    return types_1.resizeMode.percents;
                }
                if (is1px && is2px) {
                    return types_1.resizeMode.pixels;
                }
                if (is1px && !is2px) {
                    return types_1.resizeMode.mixedpx1;
                }
                if (is2px && !is1px) {
                    return types_1.resizeMode.mixedpx2;
                }
                if (is1perc) {
                    return types_1.resizeMode.mixedperc1;
                }
                if (is2perc) {
                    return types_1.resizeMode.mixedperc2;
                }
                return types_1.resizeMode.unknown;
            }
            exports.getResizeMode = getResizeMode;
            function getBlockRange(block1, block2, isXLayout) {
                if (isXLayout === void 0) { isXLayout = true; }
                if (isXLayout) {
                    return {
                        min: block1.left + window.pageXOffset,
                        max: block2.right + window.pageXOffset,
                    };
                }
                return {
                    min: block1.top + window.pageYOffset,
                    max: block2.bottom + window.pageYOffset,
                };
            }
            exports.getBlockRange = getBlockRange;
            function getMarginSize(config, xLayout) {
                if (!config) {
                    return 0;
                }
                if (config.type === "space" || (config.type === "wide" && xLayout)) {
                    return 10;
                }
                return 0;
            }
            exports.getMarginSize = getMarginSize;


            /***/
        }),
/* 41 */
/***/ (function (module, exports, __webpack_require__) {

            "use strict";

            function __export(m) {
                for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
            }
            Object.defineProperty(exports, "__esModule", { value: true });
            __export(__webpack_require__(42));
            __export(__webpack_require__(13));


            /***/
        }),
/* 42 */
/***/ (function (module, exports, __webpack_require__) {

            "use strict";

            var __extends = (this && this.__extends) || (function () {
                var extendStatics = function (d, b) {
                    extendStatics = Object.setPrototypeOf ||
                        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
                        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
                    return extendStatics(d, b);
                };
                return function (d, b) {
                    extendStatics(d, b);
                    function __() { this.constructor = d; }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            })();
            var __assign = (this && this.__assign) || function () {
                __assign = Object.assign || function (t) {
                    for (var s, i = 1, n = arguments.length; i < n; i++) {
                        s = arguments[i];
                        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                            t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            Object.defineProperty(exports, "__esModule", { value: true });
            var core_1 = __webpack_require__(1);
            var dom_1 = __webpack_require__(2);
            var events_1 = __webpack_require__(3);
            var KeyManager_1 = __webpack_require__(43);
            var view_1 = __webpack_require__(4);
            var ts_popup_1 = __webpack_require__(11);
            var types_1 = __webpack_require__(13);
            var html_1 = __webpack_require__(0);
            function normalizeValue(value, min, max) {
                if (value < min) {
                    return min;
                }
                if (value > max) {
                    return max;
                }
                return value;
            }
            function parseValue(value, min, max) {
                var values;
                if (value === undefined) {
                    values = [];
                }
                else if (Array.isArray(value)) {
                    values = value;
                }
                else if (typeof value === "string") {
                    values = value.split(",").map(function (v) { return parseInt(v, 10); });
                }
                else {
                    values = [value];
                }
                values[0] = values[0] === undefined ? min : normalizeValue(values[0], min, max);
                values[1] = values[1] === undefined ? max : normalizeValue(values[1], min, max);
                return values;
            }
            var Slider = /** @class */ (function (_super) {
                __extends(Slider, _super);
                function Slider(container, config) {
                    var _this = _super.call(this, container, core_1.extend({
                        mode: "horizontal",
                        min: 0,
                        max: 100,
                        step: 1,
                        tooltip: true,
                    }, config)) || this;
                    _this._disabled = false;
                    _this.config.helpMessage = _this.config.helpMessage || _this.config.help; // TODO: remove suite_7.0
                    if (_this.config.thumbLabel !== undefined) {
                        _this.config.tooltip = _this.config.thumbLabel; // TODO: remove suite_7.0
                    }
                    if (_this.config.labelInline) {
                        _this.config.labelPosition = "left"; // TODO: remove suite_7.0
                    }
                    _this.events = new events_1.EventSystem(_this);
                    _this._axis = _this.config.mode === "horizontal" ? "clientX" : "clientY";
                    _this._initStartPosition();
                    _this._keyManager = new KeyManager_1.KeyManager(function () {
                        var _a;
                        var activeEl = document.activeElement;
                        var element = (_a = _this.getRootView().refs[_this._isExtraActive ? "extraRunner" : "runner"]) === null || _a === void 0 ? void 0 : _a.el;
                        return activeEl === element;
                    });
                    _this._initHotkeys();
                    var vNode = dom_1.create({
                        render: function () { return _this._draw(); },
                        hooks: {
                            didMount: function () { return _this._calcSliderPosition(); },
                            didRedraw: function () { return _this._calcSliderPosition(); },
                        },
                    });
                    _this._initHandlers();
                    _this.mount(container, vNode);
                    return _this;
                }
                Slider.prototype.disable = function () {
                    this._disabled = true;
                    this.paint();
                };
                Slider.prototype.enable = function () {
                    this._disabled = false;
                    this.paint();
                };
                Slider.prototype.isDisabled = function () {
                    return this._disabled;
                };
                Slider.prototype.focus = function (extra) {
                    this.getRootView().refs[extra ? "extraRunner" : "runner"].el.focus();
                };
                Slider.prototype.getValue = function () {
                    var res;
                    if (this.config.range) {
                        var a = this._getValue(this._currentPosition);
                        var b = this._getValue(this._extraCurrentPosition);
                        res = a < b ? [a, b] : [b, a];
                    }
                    else {
                        res = [this._getValue(this._currentPosition)];
                    }
                    return res;
                };
                Slider.prototype.setValue = function (value) {
                    var old = this._getValue(this._currentPosition);
                    if (Array.isArray(value) && value.length > 1) {
                        var oldExtra = this._getValue(this._extraCurrentPosition);
                        this._setValue(value[0], false);
                        this.events.fire(types_1.SliderEvents.change, [value[0], old, false]);
                        this._setValue(value[1], true);
                        this.events.fire(types_1.SliderEvents.change, [value[1], oldExtra, true]);
                    }
                    else {
                        value = parseFloat(value);
                        if (!isNaN(value)) {
                            this._setValue(value);
                            this.events.fire(types_1.SliderEvents.change, [value, old, false]);
                        }
                        else {
                            throw new Error("Wrong value type, for more info check documentation https://docs.dhtmlx.com/suite/slider__api__slider_setvalue_method.html");
                        }
                    }
                    this.paint();
                };
                Slider.prototype.destructor = function () {
                    this._keyManager && this._keyManager.destructor();
                    document.body.contains(this._tooltip) && document.body.removeChild(this._tooltip);
                    this._tooltip = null;
                    this.unmount();
                };
                Slider.prototype._calcSliderPosition = function () {
                    var root = this.getRootView();
                    if (!root) {
                        return;
                    }
                    var tracker = root.refs.track.el;
                    var rect = tracker.getBoundingClientRect();
                    this._offsets = {
                        left: rect.left + window.pageXOffset,
                        top: rect.top + window.pageYOffset,
                    };
                    this._length = this.config.mode === "horizontal" ? rect.width : rect.height;
                };
                Slider.prototype._initHotkeys = function () {
                    var _this = this;
                    var handlers = {
                        arrowLeft: function (e) {
                            e.preventDefault();
                            _this._move(-_this.config.step, e.target.classList.contains("dhx_slider__thumb--extra"));
                        },
                        arrowRight: function (e) {
                            e.preventDefault();
                            _this._move(_this.config.step, e.target.classList.contains("dhx_slider__thumb--extra"));
                        },
                        arrowUp: function (e) {
                            e.preventDefault();
                            _this._move(_this.config.step, e.target.classList.contains("dhx_slider__thumb--extra"));
                        },
                        arrowDown: function (e) {
                            e.preventDefault();
                            _this._move(-_this.config.step, e.target.classList.contains("dhx_slider__thumb--extra"));
                        },
                    };
                    for (var key in handlers) {
                        this._keyManager.addHotKey(key, handlers[key]);
                    }
                };
                Slider.prototype._move = function (value, forExtra) {
                    if (this.config.inverse) {
                        value = -value;
                    }
                    var _a = this.config, max = _a.max, min = _a.min;
                    var oldValue = forExtra
                        ? this._getValue(this._extraCurrentPosition)
                        : this._getValue(this._currentPosition);
                    var newValue = oldValue + value;
                    this._setValue(oldValue + value, forExtra);
                    if (newValue > max || newValue < min) {
                        newValue = oldValue;
                    }
                    this.events.fire(types_1.SliderEvents.change, [newValue, oldValue, forExtra]);
                    this.paint();
                };
                Slider.prototype._initStartPosition = function () {
                    var _a = this.config, max = _a.max, min = _a.min, range = _a.range;
                    var _b = parseValue(this.config.value, this.config.min, this.config.max), value = _b[0], extraValue = _b[1];
                    this._currentPosition = ((value - min) / (max - min)) * 100;
                    if (range) {
                        this._extraCurrentPosition = ((max - extraValue) / (max - min)) * 100;
                    }
                    this._currentPosition = ((value - min) / (max - min)) * 100;
                    if (range) {
                        this._extraCurrentPosition = ((extraValue - min) / (max - min)) * 100;
                    }
                    if (this._isInverse()) {
                        this._currentPosition = 100 - this._currentPosition;
                        if (range) {
                            this._extraCurrentPosition = 100 - this._extraCurrentPosition;
                        }
                    }
                };
                Slider.prototype._getValue = function (value) {
                    if (this._isInverse()) {
                        value = 100 - value;
                    }
                    var _a = this.config, min = _a.min, max = _a.max, step = _a.step;
                    if (value === 100) {
                        return max;
                    }
                    if (value === 0) {
                        return min;
                    }
                    var val = (value * (max - min)) / 100;
                    var remain = val % step;
                    var rounder = remain >= step / 2 ? step : 0;
                    var result = Number(min) + Number(val) - remain + rounder;
                    return +result.toFixed(5);
                };
                Slider.prototype._setValue = function (val, forExtra) {
                    if (forExtra === void 0) { forExtra = false; }
                    var _a = this.config, max = _a.max, min = _a.min;
                    if (val > max || val < min) {
                        return false;
                    }
                    var rawValue = ((val - min) / (max - min)) * 100;
                    var newValue = this._isInverse() ? 100 - rawValue : rawValue;
                    if (forExtra) {
                        this._extraCurrentPosition = newValue;
                    }
                    else {
                        this._currentPosition = newValue;
                    }
                };
                Slider.prototype._initHandlers = function () {
                    var _this = this;
                    var sliderMove = function (e) {
                        !e.targetTouches && e.preventDefault();
                        var currentPosition = e.targetTouches ? e.targetTouches[0][_this._axis] : e[_this._axis];
                        var x = ((currentPosition - _this._getBegining()) / _this._length) * 100;
                        if (_this._findNewDirection) {
                            if (Math.abs(_this._currentPosition - x) < 1) {
                                return;
                            }
                            if (x > _this._currentPosition) {
                                _this._possibleRange = [_this._currentPosition, 100];
                            }
                            else {
                                _this._possibleRange = [0, _this._currentPosition];
                            }
                            _this._findNewDirection = null;
                        }
                        if (_this._inSide(x)) {
                            _this._updatePosition(x, _this._isExtraActive);
                        }
                        _this.paint();
                    };
                    var sliderEnd = function (e) {
                        _this.events.fire(types_1.SliderEvents.mouseup, [e]);
                        setTimeout(function () {
                            _this._isMouseMoving = false;
                            _this.paint();
                        }, 4);
                        if (!e.targetTouches) {
                            document.removeEventListener("mouseup", sliderEnd);
                            document.removeEventListener("mousemove", sliderMove);
                        }
                        else {
                            document.removeEventListener("touchend", sliderEnd);
                            document.removeEventListener("touchmove", sliderMove);
                        }
                    };
                    var sliderStart = function (e) {
                        if (_this._disabled || e.which === 3) {
                            return;
                        }
                        _this.events.fire(types_1.SliderEvents.mousedown, [e]);
                        _this._isMouseMoving = true;
                        var active;
                        if (e.target.classList.contains("dhx_slider__thumb--extra")) {
                            _this._isExtraActive = true;
                            active = _this._extraCurrentPosition;
                        }
                        else {
                            _this._isExtraActive = false;
                            active = _this._currentPosition;
                        }
                        _this._findNewDirection = null;
                        // define possible range
                        if (_this.config.range) {
                            var _a = _this._currentPosition > _this._extraCurrentPosition
                                ? [_this._currentPosition, _this._extraCurrentPosition]
                                : [_this._extraCurrentPosition, _this._currentPosition], more = _a[0], less = _a[1];
                            if (_this._currentPosition === _this._extraCurrentPosition) {
                                _this._findNewDirection = active;
                                _this._possibleRange = [0, 100];
                            }
                            else if (active < more) {
                                _this._possibleRange = [0, more];
                            }
                            else {
                                _this._possibleRange = [less, 100];
                            }
                        }
                        else {
                            _this._possibleRange = [0, 100];
                        }
                    };
                    if (this.config.helpMessage) {
                        this._helper = new ts_popup_1.Popup({
                            css: "dhx_tooltip dhx_tooltip--forced dhx_tooltip--light",
                        });
                        this._helper.attachHTML(this.config.helpMessage);
                    }
                    this._handlers = {
                        showHelper: function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                            _this._helper.show(e.target);
                        },
                        onmousedown: function (e) {
                            sliderStart(e);
                            document.addEventListener("mousemove", sliderMove);
                            document.addEventListener("mouseup", sliderEnd);
                        },
                        ontouchstart: function (e) {
                            _this._setTooltip(e);
                            _this._mouseIn = false;
                            sliderStart(e);
                            document.addEventListener("touchmove", sliderMove);
                            document.addEventListener("touchend", sliderEnd);
                            _this.paint();
                        },
                        ontouchend: function (e) {
                            _this._setTooltip(e);
                            _this._mouseIn = false;
                            _this.paint();
                        },
                        onlabelClick: function () {
                            var refs = _this.getRootView().refs;
                            refs.runner.el.focus();
                        },
                        onclick: function (e) {
                            if (_this._disabled || _this._isMouseMoving || e.which === 3) {
                                return;
                            }
                            var x = ((e[_this._axis] - _this._getBegining()) / _this._length) * 100;
                            var refs = _this.getRootView().refs;
                            if (_this.config.range) {
                                var dist = Math.abs(_this._currentPosition - x);
                                var extraDist = Math.abs(_this._extraCurrentPosition - x);
                                if (dist < extraDist) {
                                    _this._updatePosition(x, false);
                                    refs.runner.el.focus();
                                }
                                else {
                                    _this._updatePosition(x, true);
                                    refs.extraRunner.el.focus();
                                }
                            }
                            else {
                                _this._updatePosition(x, false);
                                refs.runner.el.focus();
                            }
                            _this.paint();
                        },
                        onmouseover: function (e) {
                            _this._setTooltip(e);
                            _this._mouseIn = true;
                            _this.paint();
                        },
                        onmouseout: function (e) {
                            _this._setTooltip(e);
                            _this._mouseIn = false;
                            _this.paint();
                        },
                        onfocus: function (e) {
                            _this._setTooltip(e);
                            _this._focusIn = true;
                            _this.paint();
                        },
                        onblur: function (e) {
                            _this._setTooltip(e);
                            _this._focusIn = false;
                            _this.paint();
                        },
                    };
                };
                Slider.prototype._getBegining = function () {
                    return this.config.mode === "horizontal"
                        ? this._offsets.left - window.pageXOffset
                        : this._offsets.top - window.pageYOffset;
                };
                Slider.prototype._inSide = function (x) {
                    var range = this._possibleRange;
                    if (x < range[0]) {
                        this._updatePosition(range[0], this._isExtraActive);
                        return false;
                    }
                    if (x > range[1]) {
                        this._updatePosition(range[1], this._isExtraActive);
                        return false;
                    }
                    return true;
                };
                Slider.prototype._updatePosition = function (x, extra) {
                    if (extra === void 0) { extra = false; }
                    if (x > 100) {
                        x = 100;
                    }
                    if (x < 0) {
                        x = 0;
                    }
                    var _a = this.config, max = _a.max, min = _a.min;
                    var position = extra ? this._extraCurrentPosition : this._currentPosition;
                    var oldValue = this._getValue(position);
                    var newValue = this._getValue(x);
                    if (oldValue === newValue) {
                        return;
                    }
                    var rawValue = ((newValue - min) / (max - min)) * 100;
                    var value = this._isInverse() ? 100 - rawValue : rawValue;
                    if (extra) {
                        this._extraCurrentPosition = value;
                    }
                    else {
                        this._currentPosition = value;
                    }
                    this.events.fire(types_1.SliderEvents.change, [newValue, oldValue, extra]);
                };
                Slider.prototype._getRunnerStyle = function (forExtra) {
                    var _a;
                    if (forExtra === void 0) { forExtra = false; }
                    var direction = this.config.mode === "horizontal" ? "left" : "top";
                    var pos = forExtra ? this._extraCurrentPosition : this._currentPosition;
                    return _a = {},
                        _a[direction] = pos + "%",
                        _a;
                };
                Slider.prototype._isInverse = function () {
                    return ((this.config.inverse && this.config.mode === "horizontal") ||
                        (!this.config.inverse && this.config.mode === "vertical"));
                };
                Slider.prototype._getRunnerCss = function (forExtra) {
                    if (forExtra === void 0) { forExtra = false; }
                    return ("dhx_slider__thumb" +
                        (forExtra ? " dhx_slider__thumb--extra" : "") +
                        (this._isMouseMoving && ((forExtra && this._isExtraActive) || (!forExtra && !this._isExtraActive))
                            ? " dhx_slider__thumb--active"
                            : "") +
                        (this._disabled ? " dhx_slider__thumb--disabled" : "") +
                        (this._isNullable(forExtra ? this._extraCurrentPosition : this._currentPosition) &&
                            !this.config.range
                            ? " dhx_slider__thumb--nullable"
                            : ""));
                };
                Slider.prototype._draw = function () {
                    var _a = this.config, labelPosition = _a.labelPosition, mode = _a.mode, hiddenLabel = _a.hiddenLabel, tick = _a.tick, majorTick = _a.majorTick, css = _a.css, helpMessage = _a.helpMessage;
                    var labelStyle = html_1.getLabelStyle(__assign(__assign({}, this.config), { required: false }));
                    if (this._tooltip && (!this._mouseIn || !this._focusIn || !this._isMouseMoving)) {
                        document.body.contains(this._tooltip) && document.body.removeChild(this._tooltip);
                    }
                    return dom_1.el("div", {
                        class: "dhx_slider" +
                            " dhx_slider--mode_" +
                            mode +
                            (labelPosition === "left" ? " dhx_slider--label-inline" : "") +
                            (hiddenLabel ? " dhx_slider--label_sr" : "") +
                            (tick ? " dhx_slider--ticks" : "") +
                            (majorTick ? " dhx_slider--major-ticks" : "") +
                            (css ? " " + css : "") +
                            (this._disabled ? " dhx_slider--disabled" : ""),
                    }, [
                        labelStyle
                            ? dom_1.el("label.dhx_label.dhx_slider__label", {
                                style: labelStyle.style,
                                class: helpMessage ? "dhx_label--with-help" : "",
                                onclick: this._handlers.onlabelClick,
                            }, helpMessage
                                ? [
                                    labelStyle.label && dom_1.el("span.dhx_label__holder", labelStyle.label),
                                    dom_1.el("span.dhx_label-help.dxi.dxi-help-circle-outline", {
                                        tabindex: "0",
                                        role: "button",
                                        onclick: this._handlers.showHelper,
                                    }),
                                ]
                                : labelStyle.label)
                            : null,
                        this._drawSlider(),
                    ]);
                };
                Slider.prototype._drawSlider = function () {
                    return dom_1.el(".dhx_widget.dhx_slider__track-holder", {
                        dhx_widget_id: this._uid,
                    }, [
                        dom_1.el(".dhx_slider__track", {
                            _ref: "track",
                            onmouseover: this._handlers.onmouseover,
                            onmouseout: this._handlers.onmouseout,
                            onclick: this._handlers.onclick,
                        }, [
                            this._getDetector(),
                            dom_1.el("div", {
                                _ref: "runner",
                                class: this._getRunnerCss(),
                                ontouchstart: this._handlers.ontouchstart,
                                ontouchend: this._handlers.ontouchend,
                                onmousedown: this._handlers.onmousedown,
                                onfocus: this._handlers.onfocus,
                                onblur: this._handlers.onblur,
                                style: this._getRunnerStyle(),
                                tabindex: 0,
                            }),
                            this.config.tooltip && (this._mouseIn || this._focusIn || this._isMouseMoving)
                                ? this._drawTooltip()
                                : null,
                            this.config.tooltip &&
                                this.config.range &&
                                (this._mouseIn || this._focusIn || this._isMouseMoving)
                                ? this._drawTooltip(true)
                                : null,
                            this.config.range
                                ? dom_1.el("div", {
                                    _ref: "extraRunner",
                                    class: this._getRunnerCss(true),
                                    ontouchstart: this._handlers.ontouchstart,
                                    ontouchend: this._handlers.ontouchend,
                                    onmousedown: this._handlers.onmousedown,
                                    onfocus: this._handlers.onfocus,
                                    onblur: this._handlers.onblur,
                                    style: this._getRunnerStyle(true),
                                    tabindex: 0,
                                })
                                : null,
                        ]),
                        this.config.tick ? this._drawTicks() : null,
                    ]);
                };
                Slider.prototype._getDetector = function () {
                    var _a, _b, _c;
                    if (this._disabled) {
                        return dom_1.el(".dhx_slider__range");
                    }
                    var direction = this.config.mode === "horizontal" ? "left" : "top";
                    var size = this.config.mode === "horizontal" ? "width" : "height";
                    if (this.config.range) {
                        var _d = this._currentPosition > this._extraCurrentPosition
                            ? [this._currentPosition, this._extraCurrentPosition]
                            : [this._extraCurrentPosition, this._currentPosition], more = _d[0], less = _d[1];
                        return dom_1.el(".dhx_slider__range", {
                            style: (_a = {},
                                _a[direction] = less + "%",
                                _a[size] = more - less + "%",
                                _a),
                        });
                    }
                    if (this._isInverse()) {
                        return dom_1.el(".dhx_slider__range", {
                            style: (_b = {},
                                _b[direction] = this._currentPosition + "%",
                                _b[size] = 100 - this._currentPosition + "%",
                                _b),
                        });
                    }
                    return dom_1.el(".dhx_slider__range", {
                        style: (_c = {},
                            _c[direction] = 0,
                            _c[size] = this._currentPosition + "%",
                            _c),
                    });
                };
                Slider.prototype._drawTooltip = function (forExtra) {
                    if (forExtra === void 0) { forExtra = false; }
                    if (this._activeTooltip === "none")
                        return;
                    var pos = this._activeTooltip === "extraTooltip" ? this._extraCurrentPosition : this._currentPosition;
                    var direction = this.config.mode === "horizontal" ? "left" : "top";
                    var classNameModifiers = "";
                    if ((forExtra && this._isExtraActive) || (!forExtra && !this._isExtraActive)) {
                        classNameModifiers += " dhx_slider__thumb-label--active";
                    }
                    if (!this._tooltip) {
                        this._tooltip = document.createElement("div");
                    }
                    var coords = this._activeTooltip === "tooltip"
                        ? this.getRootView().refs.runner.el.getBoundingClientRect()
                        : this.getRootView().refs.extraRunner.el.getBoundingClientRect();
                    this._tooltip.className = "dhx_slider__thumb-label" + classNameModifiers;
                    this._tooltip.style.left = coords.x + (direction === "left" ? 6 : -30) + window.pageXOffset + "px";
                    this._tooltip.style.top = coords.y + (direction === "left" ? -30 : 6) + window.pageYOffset + "px";
                    this._tooltip.innerText = this._getValue(pos).toString();
                    document.body.appendChild(this._tooltip);
                };
                Slider.prototype._getTicks = function () {
                    var _a = this.config, max = _a.max, min = _a.min, step = _a.step, tick = _a.tick, majorTick = _a.majorTick;
                    var len = max - min;
                    var tickLength = (step * tick) / len;
                    var positions = [];
                    var length = 0;
                    var index = 0;
                    while (length < 1) {
                        var tickValue = +(Number(min) + length * len).toFixed(5);
                        var isMultiple = index % majorTick === 0;
                        positions.push({
                            position: (this._isInverse() ? (1 - length) * 100 : length * 100) + "%",
                            isMultiple: isMultiple,
                            label: isMultiple && typeof this.config.tickTemplate === "function"
                                ? this.config.tickTemplate(tickValue)
                                : null,
                        });
                        length += tickLength;
                        index++;
                    }
                    positions.push({
                        position: (this._isInverse() ? 0 : 100) + "%",
                        isMultiple: true,
                        label: typeof this.config.tickTemplate === "function" ? this.config.tickTemplate(max) : null,
                    });
                    return positions;
                };
                Slider.prototype._drawTicks = function () {
                    var direction = this.config.mode === "horizontal" ? "left" : "top";
                    return dom_1.el(".dhx_slider__ticks-holder", this._getTicks().map(function (tick) {
                        var _a;
                        return dom_1.el("div", {
                            class: "dhx_slider__tick" + (tick.isMultiple ? " dhx_slider__tick--major" : ""),
                            style: (_a = {},
                                _a[direction] = tick.position,
                                _a),
                        }, tick.label !== undefined ? [dom_1.el(".dhx_slider__tick-label", tick.label)] : null);
                    }));
                };
                Slider.prototype._isNullable = function (value) {
                    if (this._isInverse()) {
                        return value === 100;
                    }
                    else {
                        return value === 0;
                    }
                };
                Slider.prototype._setTooltip = function (e) {
                    if (e.target.classList.contains("dhx_slider__thumb--extra")) {
                        this._activeTooltip = "extraTooltip";
                    }
                    else if (e.target.classList.contains("dhx_slider__thumb")) {
                        this._activeTooltip = "tooltip";
                    }
                    else {
                        this._activeTooltip = "none";
                    }
                };
                return Slider;
            }(view_1.View));
            exports.Slider = Slider;


            /***/
        }),
/* 43 */
/***/ (function (module, exports, __webpack_require__) {

            "use strict";

            Object.defineProperty(exports, "__esModule", { value: true });
            var FocusManager_1 = __webpack_require__(44);
            var html_1 = __webpack_require__(0);
            function getHotKeyCode(code) {
                var matches = code.toLowerCase().match(/\w+/g);
                var comp = 0;
                var key = "";
                for (var i = 0; i < matches.length; i++) {
                    var check = matches[i];
                    if (check === "ctrl") {
                        comp += 4;
                    }
                    else if (check === "shift") {
                        comp += 2;
                    }
                    else if (check === "alt") {
                        comp += 1;
                    }
                    else {
                        key = check;
                    }
                }
                return comp + key;
            }
            var ie_key_map = {
                Up: "arrowUp",
                Down: "arrowDown",
                Right: "arrowRight",
                Left: "arrowLeft",
                Esc: "escape",
                Spacebar: "space",
            };
            var KeyManager = /** @class */ (function () {
                function KeyManager(beforeCall) {
                    var _this = this;
                    this._keysStorage = {};
                    this._initHandler = function (e) {
                        var key;
                        if ((e.which >= 48 && e.which <= 57) || (e.which >= 65 && e.which <= 90)) {
                            key = String.fromCharCode(e.which);
                        }
                        else {
                            var keyName = e.which === 32 ? e.code : e.key;
                            key = html_1.isIE() ? ie_key_map[keyName] || keyName : keyName;
                        }
                        var actions = _this._keysStorage[(e.ctrlKey || e.metaKey ? 4 : 0) +
                            (e.shiftKey ? 2 : 0) +
                            (e.altKey ? 1 : 0) +
                            (key && key.toLowerCase())];
                        if (actions) {
                            for (var i = 0; i < actions.length; i++) {
                                if (_this._beforeCall && _this._beforeCall(e, FocusManager_1.focusManager.getFocusId()) === false) {
                                    return;
                                }
                                actions[i].handler(e);
                            }
                        }
                    };
                    if (beforeCall) {
                        this._beforeCall = beforeCall;
                    }
                    document.addEventListener("keydown", this._initHandler);
                }
                KeyManager.prototype.destructor = function () {
                    document.removeEventListener("keydown", this._initHandler);
                    this.removeHotKey();
                };
                KeyManager.prototype.addHotKey = function (key, handler) {
                    var code = getHotKeyCode(key);
                    if (!this._keysStorage[code]) {
                        this._keysStorage[code] = [];
                    }
                    this._keysStorage[code].push({ handler: handler });
                };
                KeyManager.prototype.removeHotKey = function (key, handler) {
                    var _this = this;
                    if (key) {
                        if (key && handler) {
                            var code_1 = getHotKeyCode(key);
                            var functionToString_1 = function (fun) {
                                return fun
                                    .toString()
                                    .replace(/\n/g, "")
                                    .replace(/\s/g, "");
                            };
                            this._keysStorage[code_1].forEach(function (existHotKey, i) {
                                if (functionToString_1(existHotKey.handler) === functionToString_1(handler)) {
                                    delete _this._keysStorage[code_1][i];
                                    _this._keysStorage[code_1] = _this._keysStorage[code_1].filter(function (el) { return el; });
                                }
                            });
                        }
                        else {
                            var code = getHotKeyCode(key);
                            delete this._keysStorage[code];
                        }
                    }
                    else {
                        this._keysStorage = {};
                    }
                };
                KeyManager.prototype.exist = function (key) {
                    var code = getHotKeyCode(key);
                    return !!this._keysStorage[code];
                };
                return KeyManager;
            }());
            exports.KeyManager = KeyManager;


            /***/
        }),
/* 44 */
/***/ (function (module, exports, __webpack_require__) {

            "use strict";

            Object.defineProperty(exports, "__esModule", { value: true });
            var html_1 = __webpack_require__(0);
            var FocusManager = /** @class */ (function () {
                function FocusManager() {
                    var _this = this;
                    this._initHandler = function (e) { return (_this._activeWidgetId = html_1.locate(e, "dhx_widget_id")); };
                    document.addEventListener("click", this._initHandler);
                }
                FocusManager.prototype.getFocusId = function () {
                    return this._activeWidgetId;
                };
                FocusManager.prototype.setFocusId = function (id) {
                    this._activeWidgetId = id;
                };
                return FocusManager;
            }());
            exports.focusManager = new FocusManager();


            /***/
        }),
/* 45 */
/***/ (function (module, exports, __webpack_require__) {

            "use strict";

            Object.defineProperty(exports, "__esModule", { value: true });
            var locale = {
                hours: "Hours",
                minutes: "Minutes",
                save: "Save",
            };
            exports.default = locale;


            /***/
        }),
/* 46 */
/***/ (function (module, exports, __webpack_require__) {

            "use strict";

            Object.defineProperty(exports, "__esModule", { value: true });
            /**
             * This function is designed to resolve conflicts with the time setting for the 12 hour format.
             */
            function isTimeCheck(value) {
                return /(^12:[0-5][0-9]?AM$)/i.test(value);
            }
            exports.isTimeCheck = isTimeCheck;


            /***/
        }),
/* 47 */
/***/ (function (module, exports, __webpack_require__) {

            "use strict";

            Object.defineProperty(exports, "__esModule", { value: true });
            exports.linkButtonClasses = ".dhx_button.dhx_button--view_link.dhx_button--icon.dhx_button--size_medium.dhx_button--color_secondary";


            /***/
        }),
/* 48 */
/***/ (function (module, exports, __webpack_require__) {

            "use strict";

            Object.defineProperty(exports, "__esModule", { value: true });
            var CalendarEvents;
            (function (CalendarEvents) {
                CalendarEvents["change"] = "change";
                CalendarEvents["beforeChange"] = "beforechange";
                CalendarEvents["modeChange"] = "modeChange";
                CalendarEvents["monthSelected"] = "monthSelected";
                CalendarEvents["yearSelected"] = "yearSelected";
                CalendarEvents["cancelClick"] = "cancelClick";
                CalendarEvents["dateMouseOver"] = "dateMouseOver";
                /** @deprecated See a documentation: https://docs.dhtmlx.com/ */
                CalendarEvents["dateHover"] = "dateHover";
            })(CalendarEvents = exports.CalendarEvents || (exports.CalendarEvents = {}));


            /***/
        })
/******/]);
}); if (window.dhx_legacy) { if (window.dhx) { for (var key in dhx) dhx_legacy[key] = dhx[key]; } window.dhx = dhx_legacy; delete window.dhx_legacy; }
//# sourceMappingURL=calendar.js.map